/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "3TBa");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+E39":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("S82l")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "+ZMJ":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("lOnJ");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "+tPU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("xGkn");
var global = __webpack_require__("7KvD");
var hide = __webpack_require__("hJx8");
var Iterators = __webpack_require__("/bQp");
var TO_STRING_TAG = __webpack_require__("dSzd")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "/bQp":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "/n6Q":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("zQR9");
__webpack_require__("+tPU");
module.exports = __webpack_require__("Kh4W").f('iterator');


/***/ }),

/***/ "06OY":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("3Eo+")('meta');
var isObject = __webpack_require__("EqjI");
var has = __webpack_require__("D2L2");
var setDesc = __webpack_require__("evD5").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("S82l")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "162o":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__("mypn");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "1BEy":
/***/ (function(module, exports) {

// touch事件相关
var isPointer = navigator.msPointerEnabled;
var start = 'ontouchstart' in window ? 'touchstart' : isPointer ? 'MSPointerDown' : 'mousedown';
var move = 'ontouchmove' in window ? 'touchmove' : isPointer ? 'MSPointerMove' : 'mousemove';
var end = 'ontouchend' in window ? 'touchend' : isPointer ? 'MSPointerUp' : 'mouseup';
var cancel = 'ontouchcancel' in window ? 'touchcancel' : 'MSPointerCancel';
if (window.PointerEvent) {
  start = 'pointerdown';
  move = 'pointermove';
  end = 'pointerup';
  cancel = 'pointercancel';
} else if (window.MSPointerEvent) {
  start = 'MSPointerDown';
  move = 'MSPointerMove';
  end = 'MSPointerUp';
}
function getPoint(e) {
  if (e.originalEvent || e, 'touchstart' == start) {
    if (!e.touches[0]) {
      return;
    }
    e.x = e.touches[0].clientX;
    e.y = e.touches[0].clientY;
  } else {
    e.x = e.clientX;
    e.y = e.clientY;
  }
  return e;
}
module.exports = {
  touchStart: start,
  touchMove: move,
  touchEnd: end,
  touchCancel: cancel,
  getPoint: getPoint
};

/***/ }),

/***/ "1kS7":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "21It":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("FtD3");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "3Eo+":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "3TBa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/vuex/dist/vuex.esm.js
/**
 * vuex v3.0.1
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (false) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '3.0.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ var vuex_esm = (index_esm);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/api/api.js
/**
 * Created by xinjundong on 2017/11/21.
 */

// '//app.auto.sohu.com/api'
// http://api.aves.auto.sohuno.com

var instance = axios_default.a.create({
  baseURL: "//app.auto.sohu.com/api"
});
function getHots() {
  return instance.get('/feeds/hot');
}

function getRecs(maxId) {
  if (maxId) {
    return instance.get('/feeds/recommended', {
      params: {
        max_id: maxId
      }
    });
  } else {
    return instance.get('/feeds/recommended');
  }
}

function getContent(newsId) {
  return instance.get('/news/' + newsId + '/detail');
}

function shareVisit(data) {
  return instance.post('https://app.auto.sohu.com/api/usertasks-static/share/visit', data);
}
// EXTERNAL MODULE: ./src/api/utils/funcs.js + 2 modules
var funcs = __webpack_require__("Y5vi");

// CONCATENATED MODULE: ./src/store/index.js
/**
 * Created by xinjundong on 2017/11/21.
 */




function replaceTpl(str, data) {
  str = str.replace(/<!--IMG#([0-9]+)-->/g, function (all, num) {
    num = Number(num);
    var source = data[num].src;
    var str = '';
    if (num === 0) {
      str = '<div class="img-box"><img src="' + source + '"></div>';
    } else {
      str = '<div class="img-box"><img src="//m1.auto.itc.cn/appImage/sohu-default.png" data-src="' + source + '"></div>';
    }
    return str;
  });
  str = str.replace(/width=500&amp;height=375&amp;/g, '').replace(/<iframe/g, '<iframe style=\"width: 100%;height: 250px;border-width:0\"');
  return str;
}
function replaceVideoTpl(str, data) {
  str = str.replace(/<!--VIDEO#([0-9]+)-->/g, function (all, num) {
    num = Number(num);
    var vid = data[num].video_id;
    var vstr = '<div class="video-box" data-bid="' + vid + '"></div>';
    return vstr;
  });
  return str;
}

vue_esm["a" /* default */].use(vuex_esm);
var store = new vuex_esm.Store({
  state: {
    hot: [],
    recommend: [],
    content: {}
  },
  getters: {
    contents: function contents(state) {
      if (!state.content.content) {
        return {};
      }

      state.content.content = replaceTpl(state.content.content, state.content.img);
      if (state.content.video) {
        state.content.content = replaceVideoTpl(state.content.content, state.content.video);
      }
      state.content.published_at = Object(funcs["a" /* formatTime */])(state.content.published_at);
      return state.content;
    },
    hots: function hots(state) {
      if (state.hot.length === 0) {
        return [];
      }
      state.hot.forEach(function (element, index) {
        if (!element) {
          return;
        }
        element.published_at = Object(funcs["a" /* formatTime */])(element.published_at);
      });
      return state.hot && state.hot.slice(0, 4);
    },
    recommends: function recommends(state) {
      if (state.recommend.length === 0) {
        return [];
      }
      state.recommend.forEach(function (element, index) {
        if (!element) {
          return;
        }
        if (isNaN(element.published_at)) {
          return;
        }
        element.published_at = Object(funcs["a" /* formatTime */])(element.published_at);
      });
      return state.recommend;
    },
    lastId: function lastId(state) {
      if (state.recommend.length === 0) {
        return null;
      }
      var last = state.recommend[state.recommend.length - 1];
      if (last) {
        return last.hot_at;
      } else {
        return null;
      }
    }
  },
  mutations: {
    setHot: function setHot(state, payload) {
      state.hot = payload;
    },
    setRecommend: function setRecommend(state, payload) {
      state.recommend = state.recommend.concat(payload);
    },
    setContent: function setContent(state, payload) {
      state.content = payload;
    }
  },
  actions: {
    requestHot: function requestHot(_ref) {
      var commit = _ref.commit;

      getHots().then(function (json) {
        commit('setHot', json.data);
      });
    },
    requestRecommend: function requestRecommend(_ref2, maxId) {
      var commit = _ref2.commit;

      getRecs(maxId).then(function (json) {
        window.loadingFlag = false;
        commit('setRecommend', json.data);
      });
    },
    requestContent: function requestContent(_ref3, newsId) {
      var commit = _ref3.commit;

      getContent(newsId).then(function (json) {
        commit('setContent', json.data);
      });
    },
    requestShare: function requestShare(_ref4, data) {
      var commit = _ref4.commit;

      shareVisit(data);
    }
  }
});

/* harmony default export */ var src_store = (store);
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/api/slide/slide.js
var slide = __webpack_require__("edGf");
var slide_default = /*#__PURE__*/__webpack_require__.n(slide);

// EXTERNAL MODULE: ./src/api/utils/dom.js
var dom = __webpack_require__("fu20");

// EXTERNAL MODULE: ./src/api/utils/checkDir.js
var checkDir = __webpack_require__("PP/d");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/article/top-hot-news.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var slideObj = null;
var checkObj = null;
/* harmony default export */ var top_hot_news = ({
  name: 'top-hot-news',
  computed: extends_default()({}, mapGetters(['hots'])),
  methods: {
    hideTopDom: function hideTopDom() {
      if (checkObj) {
        checkObj.removeEvents();
        checkObj = null;
      }
      Object(dom["a" /* get */])('.main-content').style.paddingTop = '.3rem';
      this.$el.style.display = 'none';
    },
    openAutoApp: function openAutoApp(id, event) {
      event.preventDefault();
      Object(funcs["d" /* openApp */])(id);
    },
    goDownload: function goDownload() {
      Object(funcs["d" /* openApp */])();
    }
  },
  mounted: function mounted() {
    var k = this;
    k.$nextTick(function () {
      slideObj = new slide_default.a({
        el: Object(dom["a" /* get */])('.focus'),
        nav: Object(dom["a" /* get */])('.focus-nav'),
        navType: 'normal',
        auto: true
      });
      checkObj = new checkDir["a" /* default */](function () {
        k.$el.classList.add('hide-ad');
      }, function () {
        k.$el.classList.remove('hide-ad');
      });
    });
  },
  updated: function updated() {
    this.$nextTick(function () {
      slideObj.resizeLayout();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07c10e10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/article/top-hot-news.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-focus-box"},[_c('div',{staticClass:"close",on:{"click":_vm.hideTopDom}}),_vm._v(" "),_c('ul',{staticClass:"focus"},[_c('li',{staticClass:"logo-item",on:{"click":_vm.goDownload}},[_c('img',{attrs:{"src":__webpack_require__("4GjL"),"width":"100","height":"100"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('span',{staticClass:"open"},[_vm._v("打开")])]),_vm._v(" "),_vm._l((_vm.hots),function(item){return _c('li',{on:{"click":function($event){_vm.openAutoApp(item.item_id_str, $event)}}},[_c('img',{attrs:{"src":item.cover,"width":"150","height":"100"}}),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._v("\n        "+_vm._s(item.title)+"\n      ")]),_vm._v(" "),_c('span',{staticClass:"open",attrs:{"href":"#"}},[_vm._v("打开")])])})],2),_vm._v(" "),_c('div',{staticClass:"focus-nav"},[_c('span',{staticClass:"on"}),_vm._v(" "),_vm._l((_vm.hots),function(item){return _c('span')})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_c('h3',[_vm._v("搜狐汽车")]),_vm._v(" "),_c('p',[_vm._v("选车困难症？戳这里")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var article_top_hot_news = (esExports);
// CONCATENATED MODULE: ./src/components/article/top-hot-news.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  top_hot_news,
  article_top_hot_news,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_article_top_hot_news = (Component.exports);

// CONCATENATED MODULE: ./src/api/utils/scrollEvent.js
/**
 * Created by xinjundong on 2017/11/22.
 */
var funcArr = [];
var isActive = false;
function scrollEvent(func) {
  funcArr.push(func);
  if (!isActive) {
    isActive = true;
    window.onscroll = function () {
      funcArr.forEach(function (func) {
        func();
      });
    };
  }
}
// CONCATENATED MODULE: ./src/api/utils/lazyLoad.js

// 图片懒加载
function Lazy(opt) {
  this.parent = opt.parent;
  this.imgs = null;
  this.init();
}
Lazy.prototype = {
  init: function init() {
    var k = this;
    k.getImgs();
    k.lazyEvent();
    setTimeout(function () {
      k.loadImgs();
    });
  },
  reset: function reset() {
    var k = this;
    k.getImgs();
  },
  getImgs: function getImgs() {
    var k = this;
    var arr = [];
    var imgs = k.parent.querySelectorAll('img');
    Array.prototype.forEach.call(imgs, function (e, i) {
      var src = e.getAttribute('data-src');
      if (src) {
        arr.push(e);
      }
    });
    k.imgs = arr;
  },
  lazyEvent: function lazyEvent() {
    var k = this;
    scrollEvent(function () {
      k.loadImgs.call(k);
    });
  },
  loadImgs: function loadImgs() {
    var k = this;
    var len = k.imgs.length;
    if (len === 0) {
      return;
    }
    var wh = window.innerHeight;
    var stop = window.pageYOffset;
    var curH = stop + wh;
    var cur, pos;
    for (var i = 0; i < len; i++) {
      cur = k.imgs[i];
      pos = k.offset(cur);
      if (pos <= curH) {
        var trueSrc = cur.getAttribute('data-src');
        cur.setAttribute('src', trueSrc);
        cur.removeAttribute('data-src');
      }
    }
    k.getImgs();
  },
  offset: function offset(e) {
    var t = e.offsetTop;
    while (e = e.offsetParent) {
      t += e.offsetTop;
    }
    return t;
  }
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/article/bottom-hot-news.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var lazy = null;
/* harmony default export */ var bottom_hot_news = ({
  name: 'bottom-hot-news',
  computed: extends_default()({}, mapGetters(['hots'])),
  methods: {
    openAutoApp: function openAutoApp(id, event) {
      event.preventDefault();
      Object(funcs["d" /* openApp */])(id);
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      setTimeout(function () {
        lazy = new Lazy({
          parent: Object(dom["a" /* get */])('.recommend-list')
        }, 200);
      });
    });
  },
  updated: function updated() {
    this.$nextTick(function () {
      if (lazy) {
        lazy.reset();
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2c2c094","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/article/bottom-hot-news.vue
var bottom_hot_news_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"recommend-box"},[_c('h3',[_vm._v("热门推荐")]),_vm._v(" "),_c('ul',{staticClass:"recommend-list"},_vm._l((_vm.hots),function(item){return _c('li',{staticClass:"recommend-item"},[_c('a',{attrs:{"href":"#","target":"_blank"},on:{"click":function($event){_vm.openAutoApp(item.item_id_str, $event)}}},[_c('img',{attrs:{"src":"//m1.auto.itc.cn/appImage/sohu-default.png","src":item.cover}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.title))])]),_vm._v(" "),_c('div',{staticClass:"aside"},[_c('span',{domProps:{"innerHTML":_vm._s(item.published_at)}}),_vm._v(" "),_c('a',{staticClass:"read-to-app",attrs:{"href":"#","target":"_blank"},on:{"click":function($event){_vm.openAutoApp(item.item_id_str, $event)}}},[_vm._v("去App阅读")])])])}))])}
var bottom_hot_news_staticRenderFns = []
var bottom_hot_news_esExports = { render: bottom_hot_news_render, staticRenderFns: bottom_hot_news_staticRenderFns }
/* harmony default export */ var article_bottom_hot_news = (bottom_hot_news_esExports);
// CONCATENATED MODULE: ./src/components/article/bottom-hot-news.vue
var bottom_hot_news_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var bottom_hot_news___vue_template_functional__ = false
/* styles */
var bottom_hot_news___vue_styles__ = null
/* scopeId */
var bottom_hot_news___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var bottom_hot_news___vue_module_identifier__ = null
var bottom_hot_news_Component = bottom_hot_news_normalizeComponent(
  bottom_hot_news,
  article_bottom_hot_news,
  bottom_hot_news___vue_template_functional__,
  bottom_hot_news___vue_styles__,
  bottom_hot_news___vue_scopeId__,
  bottom_hot_news___vue_module_identifier__
)

/* harmony default export */ var components_article_bottom_hot_news = (bottom_hot_news_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/article/content-main.vue

//
//
//
//
//
//
//
//
//
//





var content_main_lazy = void 0;
var winH = window.innerHeight;
/* harmony default export */ var content_main = ({
  name: 'main-news',
  computed: extends_default()({}, mapGetters(['contents'])),
  mounted: function mounted() {
    this.$nextTick(function () {
      //加载视频
      Object(funcs["c" /* loadVideo */])();
      var contentDom = Object(dom["a" /* get */])('.content');
      var moreDom = Object(dom["a" /* get */])('.more-btn');
      var twoH = 1.5 * winH;
      if (contentDom.scrollHeight > twoH) {
        moreDom.parentNode.style.display = 'block';
        contentDom.style.height = twoH + 'px';
        moreDom.onclick = function (e) {
          e.preventDefault();
          contentDom.style.height = 'auto';
          moreDom.parentNode.style.display = 'none';
        };
      } else {
        moreDom.parentNode.style.display = 'none';
      }
      content_main_lazy = new Lazy({
        parent: contentDom
      }, 200);
    });
  },
  updated: function updated() {
    var k = this;
    k.$nextTick(function () {
      //加载视频
      Object(funcs["c" /* loadVideo */])();
      var contentDom = Object(dom["a" /* get */])('.content');
      var moreDom = Object(dom["a" /* get */])('.more-btn');
      var twoH = 1.5 * winH;
      if (contentDom.scrollHeight > twoH) {
        moreDom.parentNode.style.display = 'block';
        contentDom.style.height = twoH + 'px';
        moreDom.onclick = null;
        moreDom.onclick = function (e) {
          e.preventDefault();
          contentDom.style.height = 'auto';
          moreDom.parentNode.style.display = 'none';
        };
      } else {
        moreDom.parentNode.style.display = 'none';
      }

      if (content_main_lazy) {
        content_main_lazy.reset();
      }
      var keyDom = Object(dom["a" /* get */])('#metaKey');
      var descDom = Object(dom["a" /* get */])('#metaDesc');
      var titleDom = document.querySelector('title');

      keyDom.innerHTML = k.contents.title;
      descDom.innerHTML = k.contents.title;
      titleDom.innerHTML = k.contents.title;
      k.$emit('hideLoading');
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0427759d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/article/content-main.vue
var content_main_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main-content"},[_c('h3',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.contents.title))]),_vm._v(" "),_c('p',{staticClass:"author"},[_vm._v(_vm._s(_vm.contents.author)+"\n    "),_c('span',{staticClass:"time",domProps:{"innerHTML":_vm._s(_vm.contents.published_at)}})]),_vm._v(" "),_c('article',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.contents.content)}})])}
var content_main_staticRenderFns = []
var content_main_esExports = { render: content_main_render, staticRenderFns: content_main_staticRenderFns }
/* harmony default export */ var article_content_main = (content_main_esExports);
// CONCATENATED MODULE: ./src/components/article/content-main.vue
var content_main_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var content_main___vue_template_functional__ = false
/* styles */
var content_main___vue_styles__ = null
/* scopeId */
var content_main___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var content_main___vue_module_identifier__ = null
var content_main_Component = content_main_normalizeComponent(
  content_main,
  article_content_main,
  content_main___vue_template_functional__,
  content_main___vue_styles__,
  content_main___vue_scopeId__,
  content_main___vue_module_identifier__
)

/* harmony default export */ var components_article_content_main = (content_main_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/article/recommend-list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var recommend_list_winH = window.innerHeight;
var recommend_list_lazy = null;
window.loadingFlag = false;
/* harmony default export */ var recommend_list = ({
  name: 'recommend-news',
  computed: extends_default()({}, mapGetters(['recommends', 'lastId'])),
  methods: {
    openAutoApp: function openAutoApp(id, event) {
      event.preventDefault();
      Object(funcs["d" /* openApp */])(id);
    }
  },
  mounted: function mounted() {
    var k = this;
    scrollEvent(function () {
      if (window.loadingFlag) {
        return;
      }
      if (document.documentElement.scrollHeight <= window.pageYOffset + recommend_list_winH + 50) {
        window.loadingFlag = true;
        k.$store.dispatch('requestRecommend', k.lastId);
      }
    });
    k.$nextTick(function () {
      setTimeout(function () {
        recommend_list_lazy = new Lazy({
          parent: Object(dom["a" /* get */])('.wonderful-box')
        }, 200);
      });
    });
  },
  updated: function updated() {
    var k = this;
    k.$nextTick(function () {
      if (recommend_list_lazy) {
        recommend_list_lazy.reset();
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36c51c9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/article/recommend-list.vue
var recommend_list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"recommend-box wonderful-box"},[_c('h3',[_vm._v("精彩推荐")]),_vm._v(" "),_c('ul',{staticClass:"wonderful-list"},_vm._l((_vm.recommends),function(item){return _c('li',{key:item.item_id,staticClass:"wonderful-item"},[_c('a',{staticClass:"img-parent",attrs:{"href":"#","target":"_blank"},on:{"click":function($event){_vm.openAutoApp(item.item_id_str, $event)}}},[_c('img',{attrs:{"src":"//m1.auto.itc.cn/appImage/sohu-default.png","data-src":item.cover}})]),_vm._v(" "),_c('div',{staticClass:"news-info"},[_c('a',{staticClass:"news-title",attrs:{"href":"#","target":"_blank"},on:{"click":function($event){_vm.openAutoApp(item.item_id_str, $event)}}},[_vm._v("\n          "+_vm._s(item.title)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"aside"},[_c('span',{domProps:{"innerHTML":_vm._s(item.published_at)}}),_vm._v(" "),_c('a',{staticClass:"read-to-app",attrs:{"href":"#","target":"_blank"},on:{"click":function($event){_vm.openAutoApp(item.item_id_str, $event)}}},[_vm._v("去App阅读")])])])])})),_vm._v(" "),_vm._m(0)])}
var recommend_list_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-box"},[_c('div',{staticClass:"loading-btn"})])}]
var recommend_list_esExports = { render: recommend_list_render, staticRenderFns: recommend_list_staticRenderFns }
/* harmony default export */ var article_recommend_list = (recommend_list_esExports);
// CONCATENATED MODULE: ./src/components/article/recommend-list.vue
var recommend_list_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var recommend_list___vue_template_functional__ = false
/* styles */
var recommend_list___vue_styles__ = null
/* scopeId */
var recommend_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var recommend_list___vue_module_identifier__ = null
var recommend_list_Component = recommend_list_normalizeComponent(
  recommend_list,
  article_recommend_list,
  recommend_list___vue_template_functional__,
  recommend_list___vue_styles__,
  recommend_list___vue_scopeId__,
  recommend_list___vue_module_identifier__
)

/* harmony default export */ var components_article_recommend_list = (recommend_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/commen/loading.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loadingComp',
  props: ['isShow'],
  data: function data() {
    return {
      isShow: this.isShow
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70d25e52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commen/loading.vue
var loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mask-bg",style:('display:'+_vm.isShow)},[_vm._m(0)])}
var loading_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-loading-box"},[_c('div',{staticClass:"loading-img"}),_vm._v(" "),_c('div',{staticClass:"loading-hint"},[_vm._v("Loading...")])])}]
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var commen_loading = (loading_esExports);
// CONCATENATED MODULE: ./src/components/commen/loading.vue
function injectStyle (ssrContext) {
  __webpack_require__("v5ur")
}
var loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = injectStyle
/* scopeId */
var loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  loading,
  commen_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)

/* harmony default export */ var components_commen_loading = (loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/article/enter.vue
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var enter = ({
  name: 'main',
  components: {
    topNews: components_article_top_hot_news,
    bottomNews: components_article_bottom_hot_news,
    contentMain: components_article_content_main,
    recommendList: components_article_recommend_list,
    LoadingComp: components_commen_loading
  },
  data: function data() {
    return {
      show: 'block'
    };
  },
  methods: {
    hideLoadingFunc: function hideLoadingFunc() {
      this.show = 'none';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a31130e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/article/enter.vue
var enter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-news'),_vm._v(" "),_c('content-main',{on:{"hideLoading":_vm.hideLoadingFunc}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('bottom-news'),_vm._v(" "),_c('recommend-list'),_vm._v(" "),_c('loading-comp',{attrs:{"isShow":_vm.show}})],1)}
var enter_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more-btn-box"},[_c('a',{staticClass:"more-btn",attrs:{"href":"#"}},[_vm._v("展开全文"),_c('s',{staticClass:"icon"})])])}]
var enter_esExports = { render: enter_render, staticRenderFns: enter_staticRenderFns }
/* harmony default export */ var article_enter = (enter_esExports);
// CONCATENATED MODULE: ./src/page/article/enter.vue
var enter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var enter___vue_template_functional__ = false
/* styles */
var enter___vue_styles__ = null
/* scopeId */
var enter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var enter___vue_module_identifier__ = null
var enter_Component = enter_normalizeComponent(
  enter,
  article_enter,
  enter___vue_template_functional__,
  enter___vue_styles__,
  enter___vue_scopeId__,
  enter___vue_module_identifier__
)

/* harmony default export */ var page_article_enter = (enter_Component.exports);

// EXTERNAL MODULE: ./src/assets/css/common.css
var common = __webpack_require__("erWL");
var common_default = /*#__PURE__*/__webpack_require__.n(common);

// EXTERNAL MODULE: ./src/assets/css/article.css
var article = __webpack_require__("aA3F");
var article_default = /*#__PURE__*/__webpack_require__.n(article);

// CONCATENATED MODULE: ./src/api/utils/common.js
var MD5 = function MD5(d) {
  var result = M(V(Y(X(d), 8 * d.length)));return result.toLowerCase();
};function M(d) {
  for (var _, m = '0123456789ABCDEF', f = '', r = 0; r < d.length; r++) {
    _ = d.charCodeAt(r), f += m.charAt(_ >>> 4 & 15) + m.charAt(15 & _);
  }return f;
}function X(d) {
  for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++) {
    _[m] = 0;
  }for (m = 0; m < 8 * d.length; m += 8) {
    _[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32;
  }return _;
}function V(d) {
  for (var _ = '', m = 0; m < 32 * d.length; m += 8) {
    _ += String.fromCharCode(d[m >> 5] >>> m % 32 & 255);
  }return _;
}function Y(d, _) {
  d[_ >> 5] |= 128 << _ % 32, d[14 + (_ + 64 >>> 9 << 4)] = _;for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) {
    var h = m,
        t = f,
        g = r,
        e = i;f = md5_ii(f = md5_ii(f = md5_ii(f = md5_ii(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_ff(f = md5_ff(f = md5_ff(f = md5_ff(f, r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 0], 7, -680876936), f, r, d[n + 1], 12, -389564586), m, f, d[n + 2], 17, 606105819), i, m, d[n + 3], 22, -1044525330), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 4], 7, -176418897), f, r, d[n + 5], 12, 1200080426), m, f, d[n + 6], 17, -1473231341), i, m, d[n + 7], 22, -45705983), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 8], 7, 1770035416), f, r, d[n + 9], 12, -1958414417), m, f, d[n + 10], 17, -42063), i, m, d[n + 11], 22, -1990404162), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 12], 7, 1804603682), f, r, d[n + 13], 12, -40341101), m, f, d[n + 14], 17, -1502002290), i, m, d[n + 15], 22, 1236535329), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 1], 5, -165796510), f, r, d[n + 6], 9, -1069501632), m, f, d[n + 11], 14, 643717713), i, m, d[n + 0], 20, -373897302), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 5], 5, -701558691), f, r, d[n + 10], 9, 38016083), m, f, d[n + 15], 14, -660478335), i, m, d[n + 4], 20, -405537848), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 9], 5, 568446438), f, r, d[n + 14], 9, -1019803690), m, f, d[n + 3], 14, -187363961), i, m, d[n + 8], 20, 1163531501), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 13], 5, -1444681467), f, r, d[n + 2], 9, -51403784), m, f, d[n + 7], 14, 1735328473), i, m, d[n + 12], 20, -1926607734), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 5], 4, -378558), f, r, d[n + 8], 11, -2022574463), m, f, d[n + 11], 16, 1839030562), i, m, d[n + 14], 23, -35309556), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 1], 4, -1530992060), f, r, d[n + 4], 11, 1272893353), m, f, d[n + 7], 16, -155497632), i, m, d[n + 10], 23, -1094730640), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 13], 4, 681279174), f, r, d[n + 0], 11, -358537222), m, f, d[n + 3], 16, -722521979), i, m, d[n + 6], 23, 76029189), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 9], 4, -640364487), f, r, d[n + 12], 11, -421815835), m, f, d[n + 15], 16, 530742520), i, m, d[n + 2], 23, -995338651), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 0], 6, -198630844), f, r, d[n + 7], 10, 1126891415), m, f, d[n + 14], 15, -1416354905), i, m, d[n + 5], 21, -57434055), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 12], 6, 1700485571), f, r, d[n + 3], 10, -1894986606), m, f, d[n + 10], 15, -1051523), i, m, d[n + 1], 21, -2054922799), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 8], 6, 1873313359), f, r, d[n + 15], 10, -30611744), m, f, d[n + 6], 15, -1560198380), i, m, d[n + 13], 21, 1309151649), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 4], 6, -145523070), f, r, d[n + 11], 10, -1120210379), m, f, d[n + 2], 15, 718787259), i, m, d[n + 9], 21, -343485551), m = safe_add(m, h), f = safe_add(f, t), r = safe_add(r, g), i = safe_add(i, e);
  }return Array(m, f, r, i);
}function md5_cmn(d, _, m, f, r, i) {
  return safe_add(bit_rol(safe_add(safe_add(_, d), safe_add(f, i)), r), m);
}function md5_ff(d, _, m, f, r, i, n) {
  return md5_cmn(_ & m | ~_ & f, d, _, r, i, n);
}function md5_gg(d, _, m, f, r, i, n) {
  return md5_cmn(_ & f | m & ~f, d, _, r, i, n);
}function md5_hh(d, _, m, f, r, i, n) {
  return md5_cmn(_ ^ m ^ f, d, _, r, i, n);
}function md5_ii(d, _, m, f, r, i, n) {
  return md5_cmn(m ^ (_ | ~f), d, _, r, i, n);
}function safe_add(d, _) {
  var m = (65535 & d) + (65535 & _);return (d >> 16) + (_ >> 16) + (m >> 16) << 16 | 65535 & m;
}function bit_rol(d, _) {
  return d << _ | d >>> 32 - _;
};

var shareChannel = function shareChannel() {
  var ua = navigator.userAgent;
  if (/MicoMessenger/i.test(ua)) {
    return 1; // '微信'
  } else if (/qq/i.test(ua)) {
    return 2; // 'QQ'
  } else if (/weibo/i.test(ua)) {
    return 3; // '微博'
  } else {
      return 4; // '其他'
    }
};

var getSearchString = function getSearchString(subUrl, key) {
  var str = subUrl;
  str = str.substring(1, str.length);
  var arr = str.split('&');
  var obj = {};
  for (var i = 0; i < arr.length; i++) {
    var tmpArr = arr[i].split('=');
    obj[decodeURIComponent(tmpArr[0])] = decodeURIComponent(tmpArr[1]);
  }
  return obj[key];
};
// CONCATENATED MODULE: ./src/page/article/article.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






vue_esm["a" /* default */].config.productionTip = false;
new vue_esm["a" /* default */]({
  store: src_store,
  components: { enter: page_article_enter },
  template: '<enter />',
  el: '#app',
  created: function created() {
    src_store.dispatch('requestHot');
    src_store.dispatch('requestRecommend');
    if (/userId/i.test(location.hash)) {
      var articleId = location.hash.split('&')[0].slice(1);
      src_store.dispatch('requestContent', articleId);
    } else {
      var _articleId = location.hash.slice(1);
      src_store.dispatch('requestContent', _articleId);
    }

    // store.dispatch('requestContent', '700840288553492480')
    var userId = getSearchString(location.hash, 'userId');
    if (userId) {
      setTimeout(function () {
        var Fingerprint2 = window.Fingerprint2 || {};
        Fingerprint2.get(function (components) {
          var finger = MD5(stringify_default()(components));
          // console.log(finger)
          var payload = {
            id: userId,
            url: 'http://mobile.auto.sohu.com/m/article.html?pvid=3a89a4b3' + location.hash,
            identity: finger || '',
            channel: shareChannel()
            // console.log(payload)
          };src_store.dispatch('requestShare', payload);
        });
      }, 500);
    }
  }
});

/***/ }),

/***/ "3fs2":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("RY/4");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var Iterators = __webpack_require__("/bQp");
module.exports = __webpack_require__("FeBl").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "4GjL":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAAAeAAD/4QONaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjYtYzEzOCA3OS4xNTk4MjQsIDIwMTYvMDkvMTQtMDE6MDk6MDEgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6YjEzNTY2MDYtMTUxZS00M2U3LThkN2QtNWRlMTZjOGVkOGZhIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjhFOUQwRUYwQ0I0NzExRTdBMDI2OTVBNzM3MTgyRDkxIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjhFOUQwRUVGQ0I0NzExRTdBMDI2OTVBNzM3MTgyRDkxIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE3IChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjI4YTY5OTU0LTc0MDAtOTY0NS05ZjY5LTRlYzIzZmVmN2EwYyIgc3RSZWY6ZG9jdW1lbnRJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOjViYzdkNzBiLTA5OWMtMTE3Yi04MTNkLWMwMDNhMWU1MDJjMCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pv/uAA5BZG9iZQBkwAAAAAH/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/AABEIAGQAZAMBIgACEQEDEQH/xACMAAACAwEBAQAAAAAAAAAAAAAABgMFBwQBAgEBAQEBAAAAAAAAAAAAAAAAAAECBBAAAQMDAgMFBQQFDAMAAAAAAQIDBAARBRIGITETQVFhgSKRQhQVB3GhMmJSI5NVFrFygqLSoyRUlCVlJpJjFxEBAQEAAQQDAQAAAAAAAAAAAAECESExQQNREgQF/9oADAMBAAIRAxEAPwBpw2GYYYQ++gLkLAV6hcIB5ADvq2sO6gchXtB5Yd1Fh3VUZXdOFxEkRZz5Q8UhelKFL9JJA4pB7qlZ3FinsU5mEOn4FokKcKFDiCBwSRc8TagsrDuosO6qbHbtweTfMeG8pbiUKcVdtaQEI/ESVC1RRN67emyWokd9a3nlBDaeksXJ8SmgvrDuosO6qGTvfbkWS5FdkK6zKy2sJbWoaknSQCE8eNT5PdeFxMgRp7q2nVIDgT01n0qvY3A8KC3sO6iw7q5sbkoeUiImwl9RhZISogpN0nSbhVjVbkN44DHS3IUqQpL7VgtIbWoAkBXNItyNBd2HdUb0aPIQUPNpWk9hFUH/ANA2v/mV/snP7NfTe/NtOLS23IWpayEpSGnLkngB+Ggj/h7/AHToXPwmnqau217aPtv91FMlvVfttRQejkKjkyGosd2S8rS0yhS1q7kpFzUg5CuPMym4eKlynAFJaaWrSoAhRA9IIPeaDHtxZYZjMSJ6QpLbhAaQq10oSkJF7X7qv8rkmW9hYyFHQpsSXCFa7DX0SVOqFieHVVwpewUE5LNQ4hGoPOp6g/Ik61/1Qabt74PN5PJtJx8JSoUVoIbKChKdSiVKIGoeA8qCnwP+A21mcqeC3kpgsHxc4uW/okGvnZDaGsjIyrou1i4zr/Hlr06UjzuatcntvOJ23i8TEiKcWFLkzLKSLOq4ISbq5hJtRE23nIe1JkZuIoz8g+hC2wU3Sw36rk6rcVXHnQL22oi8ruOI2569b3WeJ7Qi7qr/AG2pu+p8AKiw8in8TSywvxCxrT7Ck+2vjYu3MjipcufkYymlIa0MI9KlLKjqVpCVc/Tbzpf3rOzUvIp+ZsqiNBJVFilQOlsm2o6SfUbcaDv+nglSJLrapzrEKGA+qMhRSlwk+9+UaePfXPtuM3uPdz0iU2HY6i9JcbV+EpJ0oSfsKhU+3/8AbNmZfJn0uyyIrR7bW0XH7Q+yurYC4+Mx0zKyASp91EaOhIutakjUUoHiVD2Ut461c5urM5nNvaQ2r2vtptClrx7ASkFSjp5AcTSrtObjcvmg0zhorCI4L4fSCVp0EaCL8L3Ipl3ZkHIe2Zbyx03nm+ilAN7Kd9BF/AE1R/TCDohzJ6hxdWllB8GxqV7Sr7qIePe8qKPe8qKAHIUifU9t0MxHviClsktpigEBR/EpxRv2WSLWp7HIVmP1LndfMMw0n0xGgVD87p1H+qE0HJsTCLyeWEkuFtqApDq7D8ZJ9KL3Fr6Tevnd0PO43KvvynXOhKcW4y62pXTIUb6OfApHZTf9OIPw+BVKULLmOqUD+RH6tP3hVdu6s3gIUNyJlAJSnU8IaeKz3KP6H2+ygTsHgGs1EL7OdcZcaTqkMOJIU13m/VF0+NR/LMQXOkndClrJ0hKWXl3N7WTpUb+VL5gzVRncixGdRA1lHU4qSkE8Eldhe3fTz9O39vFHSQ2G8wAdS3SFKcT/AOk9g7wOP20DJg8a1gMSpMiSXQCp5+S7dHC3csnSAkCsv3VmG8zmnpjN/hwEtsauB0IFr28Tc1pe7cW1kMY6uVLdjw4yFvONNaQHCgahqKgb2twFZPiIZn5SJDAuH3UIV/NJ9R9lAy7nPy7a2Fw44LcSZTyfEi4v5uH2VK0o4v5M24D04jbUlaPzPq6y/O1h5Vz7pJzO80Y9vi2hbURNuwXuv2FRq03o/F+dx4TIBf6CUaUcTqUohtuw7bVj2y/Xp4vLs/n69c/RJ7Ok1nWOb4te/U7IJVGgQm1akukyFW5FIGlB89Rpm2nB+A29CYIstTYdX36nf1nH7L2rPMsy7kdzw8QpWsxwxCURxHosXf8AxKleytaSAkBKRYAWA8BW52cmpJqyXmS2S/MHveVFHveVFEA5CqTMYLbgblZafDS6tCFOvLJVqVoT/OA7LVdjkKo94P49GHXGnyzCalqDfUSguqNjrI0p79NBT4ffONedi4iBjnWkOKSy0kKTZAUeJ7+HOqTc83E4rNOw4uLjSOkEqdcfLq1lxQ1m56nHmKsdmYXAHLiZj8gua5EQVFCmFNJGsFF9SvtNVGSj7TnT5Mt7NudR9xS1ARlkC55A9woGvA7sxUvEp+avQ4q1lSPhE+lCWh6QFIUTz/kqNLP04QsOIXFStJCkqS6oEEG4IsrhSh8s2d++3f8ASrqWJgtqTJLUWPmXVvPKCG0/DKF1K4czQaLlchgvlo+ZPNmFLRdAUqweSAF+m3E9lZpB3O1Fmtvw8VBjvBVm3VdX0avTckudxpm+ouLYRi4sovFCYgTHjRwkWUVWuSq/6CPupP2xgTn8kYZcLLaG1OOOAarAWA4XHMmg0Bl7YTE35g2/GEwqUsvdRROty+tViojjqNew39hQZKpcd+MJKiVF5bhcXc8yFOKUR5Uo5Dbm18bLchS8y4h9q2tIjqVbUAocUkjkascd9PcZk4iJsPJuLjuX0KLOm+klJ4KUDzFBfxFbGRkkzIrsc5BxwlCw4pSlOOkg2BURc6qZqUsL9P4mKyTM8ylSCwSpDakBI1EEA31Hle9NtB573lRR73lRQA5CkrfE3bTkxiFl1TC5HQVpTF6egdX9Lqdvpp1HIVim5Z3zDPTZIN0qdKGz+Rv9Wn7k0DxhF7cw+3JmXiCWmJIIaWp3R1zY9MdPTZPNZpW/6B/yn9zWgxNuQXtuwsTPbK22kIWtAUpH62xUrigg/iUag/gHa3+UV+1d/t0CL/0D/lP7mrvaMXaUjNNrxaZypMdKnQZHT6QFtFzo4+9wqi3rAxeMywg4xrpJabSXrqUsla7q98n3bUyfS+BpjTMiocXFpZbPgga1e0qHsoJ975HbjkhnG5cy9TI6wEXRpuvgNXU7QB99VmC3Hs7ALechNzlrfCUqU6GlEBNzZOlSe+uTLbi2vOyL8iViHJDpVpLwkrQFBHoSQlPAcBVbLyW13IzrcXDLZkKSQ06qStYQo+9pPO1B3zpmxp8x6bI+Z9Z9ZWu3RsCrsF+wVfQN/bax8NmFHZldFhIQjUlBUQO02c5ms8iLjtyWlymy9HSoF1pKtBWke7q7L1efNdn/ALic/wBW5QaXgs9FzsdyTEadbabX09ToCdSrAnTpUrlerOlnZOUizoLjECAYMKKoJQS51Na13WoXIvw8e+mag897yoo97yooOHNTDBw8uWm5W00otgcTrI0o5fmIrI9vYt6dm4Udbaump1KnCUm2hHrV9wrZozyJDDbyDdLiQRUtAV5y4mvaKDEc09IyOWlzemspedUpHpP4L2R2fogVq21ceIO3ocZabLU31HQeep31kH7L2q4ooKr+F9u/u6P+zFJn1Bx+OhJiRcbBQ06sqddW03Y6R6Ui47zf2VpFFBmn0+2/HmuTJORjB1ptKW20OpuNSjqUQD3AD207fwvt393R/wBmKtaKCCHBhwWehDZQw1cq0NgJGo8zwqeiig897yorn+NZ+P8AgrjqdPX9/L7bcaKCi2980sehp+Ev6upe1/yW43pkGrtteiig99XhR6vCiigPV4UerwoooD1eFHq8KKKA9XhR6vCiigPV4VzTfj+ifgun1Pz3+7s9tFFAnf43433/AIzX/T10UUUH/9k="

/***/ }),

/***/ "4mcu":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "52gC":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "5QVw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("BwfY"), __esModule: true };

/***/ }),

/***/ "5VQ+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "7+uW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.17
 * (c) 2014-2018 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it... e.g.
 * PhantomJS 1.x. Technically we don't need this anymore since native bind is
 * now more performant in most browsers, but removing it would be breaking for
 * code that was able to run in PhantomJS 1.x, so this must be kept for
 * backwards compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
})

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  if (!getter && arguments.length === 2) {
    val = obj[key];
  }
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'can only contain alphanumeric characters and the hyphen, ' +
      'and must start with a letter.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both microtasks and (macro) tasks.
// In < 2.4 we used microtasks everywhere, but there are some scenarios where
// microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using (macro) tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use microtask by default, but expose a way to force (macro) task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine microtask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a (macro) task instead of a microtask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$1 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$1; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject).filter(function (key) {
        /* istanbul ignore next */
        return Object.getOwnPropertyDescriptor(inject, key).enumerable
      })
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */




// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    hooks[key] = componentVNodeHooks[key];
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    // reset _rendered flag on slots for duplicate slot check
    if (false) {
      for (var key in vm.$slots) {
        // $flow-disable-line
        vm.$slots[key]._rendered = false;
      }
    }

    if (_parentVnode) {
      vm.$scopedSlots = _parentVnode.data.scopedSlots || emptyObject;
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
}

var builtInComponents = {
  KeepAlive: KeepAlive
}

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.5.17';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
}

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
}

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
]

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
}

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
}

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
  el.plain = false;
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
  el.plain = false;
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = {
    value: value.trim()
  };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally'
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
}

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
}

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
}

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {}

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
]

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
}

var platformDirectives = {
  model: directive,
  show: show
}

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
}

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
}

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
}

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
}

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
}

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
}

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([^]*?)\s+(?:in|of)\s+([^]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;



function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function closeElement (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints (el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      closeElement(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var res;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp)
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '');
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          true
        );
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$2 = {
  preTransformNode: preTransformNode
}

var modules$1 = [
  klass$1,
  style$1,
  model$2
]

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
}

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  esc: 'Escape',
  tab: 'Tab',
  enter: 'Enter',
  space: ' ',
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  'delete': ['Backspace', 'Delete']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    /* istanbul ignore if */
    return ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : handler.value;
    /* istanbul ignore if */
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
}

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  var fn = "function(" + (String(el.slotScope)) + "){" +
    "return " + (el.tag === 'template'
      ? el.if
        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  return ("{key:" + key + ",fn:" + fn + "}")
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    /* istanbul ignore if */
    {
      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
    }
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (
  ident,
  type,
  text,
  errors
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
    }
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
      );
    } else {
      errors.push(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n"
      );
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn$$1(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (false) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("162o").setImmediate))

/***/ }),

/***/ "77Pl":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "7GwW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var settle = __webpack_require__("21It");
var buildURL = __webpack_require__("DQCr");
var parseHeaders = __webpack_require__("oJlt");
var isURLSameOrigin = __webpack_require__("GHBc");
var createError = __webpack_require__("FtD3");
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__("thJu");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("p1b6");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "7KvD":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "7UMu":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("R9M2");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "880/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("hJx8");


/***/ }),

/***/ "94VQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("Yobk");
var descriptor = __webpack_require__("X8DO");
var setToStringTag = __webpack_require__("e6n0");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("hJx8")(IteratorPrototype, __webpack_require__("dSzd")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "9bBU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("mClu");
var $Object = __webpack_require__("FeBl").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "BO1k":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("fxRn"), __esModule: true };

/***/ }),

/***/ "BwfY":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("fWfb");
__webpack_require__("M6a0");
__webpack_require__("OYls");
__webpack_require__("QWe/");
module.exports = __webpack_require__("FeBl").Symbol;


/***/ }),

/***/ "C4MV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("9bBU"), __esModule: true };

/***/ }),

/***/ "Cdx3":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("sB3e");
var $keys = __webpack_require__("lktj");

__webpack_require__("uqUo")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "D2L2":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "DQCr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "Dd8w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "DuR2":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "EGZi":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "EqjI":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "FeBl":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "FtD3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("t8qj");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "GHBc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "Ibhu":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("D2L2");
var toIObject = __webpack_require__("TcQ7");
var arrayIndexOf = __webpack_require__("vFc/")(false);
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "JP+z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "KCLY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("cGG2");
var normalizeHeaderName = __webpack_require__("5VQ+");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("7GwW");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("7GwW");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "Kh4W":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("dSzd");


/***/ }),

/***/ "Kh5d":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("sB3e");
var $getPrototypeOf = __webpack_require__("PzxK");

__webpack_require__("uqUo")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "LKZe":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("NpIQ");
var createDesc = __webpack_require__("X8DO");
var toIObject = __webpack_require__("TcQ7");
var toPrimitive = __webpack_require__("MmMw");
var has = __webpack_require__("D2L2");
var IE8_DOM_DEFINE = __webpack_require__("SfB7");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("+E39") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "M6a0":
/***/ (function(module, exports) {



/***/ }),

/***/ "MU5D":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("R9M2");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "MmMw":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("EqjI");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "NpIQ":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "O4g8":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "ON07":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
var document = __webpack_require__("7KvD").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "OYls":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("crlp")('asyncIterator');


/***/ }),

/***/ "PP/d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__funcs__ = __webpack_require__("Y5vi");



/**
 * Created by xinjundong on 2017/11/20.
 * 检查页面滑动方向: 向上滑 还是 向下滑
 */

window.__CheckEvent__ = {};
window.__CheckManager__ = {};

var _class = function () {
  function _class(downCallback, upCallback) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.downCallback = downCallback;
    this.upCallback = upCallback;
    this.prePos = 0;
    this.newPos = 0;
    this.dir = null;
    this.preDir = null;
    this.init();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'init',
    value: function init() {
      var k = this;
      k.addEvent('touchstart', function (e) {
        k.dir = null;
        if (k.dir) {
          k.preDir = k.dir;
        }
        k.prePos = e.changedTouches[0].pageY;
      });
      k.addEvent('touchmove', function (e) {
        k.newPos = e.changedTouches[0].pageY;
        var len = Math.abs(k.newPos - k.prePos);
        if (len >= 10) {
          if (k.newPos <= k.prePos) {
            k.dir = 'down';
          } else {
            k.dir = 'up';
          }
        } else {
          k.dir = null;
        }
      });
      k.addEvent('touchend', function (e) {
        if (k.dir === k.preDir) {
          return;
        }
        k.set(k.dir);
      });
      k.addEvent('touchcancel', function (e) {
        if (k.dir === k.preDir) {
          return;
        }
        k.set(k.dir);
      });
    }
  }, {
    key: 'set',
    value: function set(dir) {
      var k = this;
      switch (dir) {
        case 'down':
          k.downCallback();
          break;
        case 'up':
          k.upCallback();
      }
    }
  }, {
    key: 'addEvent',
    value: function addEvent(type, func) {
      var key = Object(__WEBPACK_IMPORTED_MODULE_3__funcs__["b" /* getRandomStr */])(type);
      window.__CheckEvent__[key] = func;
      if (!window.__CheckManager__[type]) {
        window.__CheckManager__[type] = [];
      }
      window.__CheckManager__[type].push(window.__CheckEvent__[key]);
      document.addEventListener(type, window.__CheckEvent__[key]);
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      for (var type in window.__CheckManager__) {
        var tempArr = window.__CheckManager__[type];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(tempArr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var func = _step.value;

            document.removeEventListener(type, func);
            func = null;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        window.__CheckManager__[type] = null;
      }
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),

/***/ "PzxK":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("D2L2");
var toObject = __webpack_require__("sB3e");
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "QRG4":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("UuGF");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "QWe/":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("crlp")('observable');


/***/ }),

/***/ "R4wc":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("kM2E");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("To3L") });


/***/ }),

/***/ "R9M2":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "RPLV":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7KvD").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "RY/4":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("R9M2");
var TAG = __webpack_require__("dSzd")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "Re3r":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "Rrel":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("TcQ7");
var gOPN = __webpack_require__("n0T6").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "S82l":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "SfB7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("+E39") && !__webpack_require__("S82l")(function () {
  return Object.defineProperty(__webpack_require__("ON07")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "TNV1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "TcQ7":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("MU5D");
var defined = __webpack_require__("52gC");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "To3L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("lktj");
var gOPS = __webpack_require__("1kS7");
var pIE = __webpack_require__("NpIQ");
var toObject = __webpack_require__("sB3e");
var IObject = __webpack_require__("MU5D");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("S82l")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "UuGF":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "V3tA":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("R4wc");
module.exports = __webpack_require__("FeBl").Object.assign;


/***/ }),

/***/ "VU/8":
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "W2nU":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "X8DO":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "Xc4G":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("lktj");
var gOPS = __webpack_require__("1kS7");
var pIE = __webpack_require__("NpIQ");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "XmWM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("KCLY");
var utils = __webpack_require__("cGG2");
var InterceptorManager = __webpack_require__("fuGk");
var dispatchRequest = __webpack_require__("xLtR");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "Y5vi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/api/utils/address.js
/**
 * Created by xinjundong on 2017/11/23.
 */
var androidUrl = '//autoapp.auto.sohu.com/public/landing.html?from=huiliuye';
var iosUrl = 'https://itunes.apple.com/app/apple-store/id631115095?pt=217229&ct=huiliuye&mt=8';
var androidWXURL = '//a.app.qq.com/o/simple.jsp?pkgname=com.sohu.auto.sohuauto';
// EXTERNAL MODULE: ./src/api/utils/dom.js
var dom = __webpack_require__("fu20");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/define-property.js
var define_property = __webpack_require__("C4MV");
var define_property_default = /*#__PURE__*/__webpack_require__.n(define_property);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var json_stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(json_stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/get-prototype-of.js
var get_prototype_of = __webpack_require__("Zx67");
var get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(get_prototype_of);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/symbol/iterator.js
var iterator = __webpack_require__("Zzip");
var iterator_default = /*#__PURE__*/__webpack_require__.n(iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/symbol.js
var symbol = __webpack_require__("5QVw");
var symbol_default = /*#__PURE__*/__webpack_require__.n(symbol);

// CONCATENATED MODULE: ./src/api/video/inc-all.js







/* sohutv 2017-05-18 15:03:47 */!function (e) {
    function t(n) {
        if (i[n]) return i[n].exports;
        var a = i[n] = {
            exports: {},
            id: n,
            loaded: !1
        };
        return e[n].call(a.exports, a, a.exports, t), a.loaded = !0, a.exports;
    }
    var i = {};
    t.m = e, t.c = i, t.p = "", t(0);
}([function (e, t, i) {
    "use strict";

    var n = i(47);
    window.playerFactory = n, function (e, t) {
        var i = document,
            n = i.head || i.getElementsByTagName("head")[0] || i.documentElement,
            a = i.createElement("link");
        a.type = "text/css", a.rel = "stylesheet", a.href = e, t && (a.charset = t), n.insertBefore(a, n.firstChild);
    }("//css.tv.itc.cn/m/player.css");
}, function (e, t) {
    "use strict";

    var i = navigator.userAgent,
        n = navigator.platform,
        a = i.toLowerCase(),
        o = {},
        r = {},
        s = {},
        d = i.match(/Web[kK]it[\/]{0,1}([\d.]+)/),
        l = i.match(/(Android);?[\s\/]+([\d.]+)?/),
        c = !!i.match(/\(Macintosh\; Intel /),
        h = i.match(/(iPad).*OS\s([\d_]+)/),
        u = i.match(/(iPod)(.*OS\s([\d_]+))?/),
        p = !h && i.match(/(iPhone\sOS)\s([\d_]+)/),
        m = i.match(/(webOS|hpwOS)[\s\/]([\d.]+)/),
        f = /Win\d{2}|Windows/.test(n),
        v = i.match(/Windows Phone ([\d.]+)/),
        g = m && i.match(/TouchPad/),
        y = i.match(/Kindle\/([\d.]+)/),
        w = i.match(/Silk\/([\d._]+)/),
        b = i.match(/(BlackBerry).*Version\/([\d.]+)/),
        x = i.match(/(BB10).*Version\/([\d.]+)/),
        T = i.match(/(RIM\sTablet\sOS)\s([\d.]+)/),
        P = i.match(/PlayBook/),
        D = i.match(/Chrome\/([\d.]+)/) || i.match(/CriOS\/([\d.]+)/),
        S = i.match(/Firefox\/([\d.]+)/),
        C = i.match(/\((?:Mobile|Tablet); rv:([\d.]+)\).*Firefox\/[\d.]+/),
        k = i.match(/MSIE\s([\d.]+)/) || i.match(/Trident\/[\d](?=[^\?]+).*rv:([0-9.].)/),
        _ = !D && i.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/),
        L = _ || i.match(/Version\/([\d.]+)([^S](Safari)|[^M]*(Mobile)[^S]*(Safari))/);
    (r.webkit = !!d) && (r.version = d[1]), l && (o.android = !0, o.version = l[2]), p && !u && (o.ios = o.iphone = !0, o.version = p[2].replace(/_/g, ".")), h && (o.ios = o.ipad = !0, o.version = h[2].replace(/_/g, ".")), u && (o.ios = o.ipod = !0, o.version = u[3] ? u[3].replace(/_/g, ".") : null), v && (o.wp = !0, o.version = v[1]), m && (o.webos = !0, o.version = m[2]), g && (o.touchpad = !0), b && (o.blackberry = !0, o.version = b[2]), x && (o.bb10 = !0, o.version = x[2]), T && (o.rimtabletos = !0, o.version = T[2]), P && (r.playbook = !0), y && (o.kindle = !0, o.version = y[1]), w && (r.silk = !0, r.version = w[1]), !w && o.android && i.match(/Kindle Fire/) && (r.silk = !0), D && (r.chrome = !0, r.version = D[1]), S && (r.firefox = !0, r.version = S[1]), C && (o.firefoxos = !0, o.version = C[1]), k && (r.ie = !0, r.version = k[1]), L && (c || o.ios || f) && (r.safari = !0, o.ios || (r.version = L[1])), _ && (r.webview = !0), c && (o.osx = !0), o.tablet = !!(h || P || l && !i.match(/Mobile/) || S && i.match(/Tablet/) || k && !i.match(/Phone/) && i.match(/Touch/)), o.phone = !(o.tablet || o.ipod || !(l || p || m || b || x || D && i.match(/Android/) || D && i.match(/CriOS\/([\d.]+)/) || S && i.match(/Mobile/) || k && i.match(/Touch/)));
    var E,
        A = i.toLowerCase().match(/\bm?qqbrowser\/([0-9.]+)/),
        I = i.match(/SogouMobileBrowser/i),
        M = a.match(/\bmiuibrowser\/([0-9.]+)/),
        B = i.match(/baidubrowser/i),
        F = i.match(/baiduboxapp/i),
        U = i.match(/SohuVideoMobile/i),
        O = a.match(/\bmicromessenger\/([\d.]+)/);
    E = a.indexOf("ucbrowser/") >= 0 ? a.match(/\bucbrowser\/([0-9.]+)/) : a.indexOf("ubrowser/") >= 0 ? a.match(/\bubrowser\/([0-9.]+)/) : /\buc\/[0-9]/.test(a) ? a.match(/\buc\/([0-9.]+)/) : a.indexOf("ucweb") >= 0 ? a.match(/\bucweb([0-9.]+)?/) : a.match(/\b(?:ucbrowser|uc)\b/);
    var q = i.match(/Windows\sPad/i);
    A && (r.qq = !0, r.version = A[1]), I && (r.sogou = !0), M && (r.mi = !0, r.version = M[1]), B && (r.baidu = !0), F && (r.baiduboxapp = !0), U && (r.sohuVideoApp = !0), O && (r.weixin = !0, r.wx = !0, r.version = O[1]), E && (r.uc = !0, r.version = E[1]), q && (o.winpad = !0);
    var N,
        R,
        V = a.match(/\bcoolpad[_ ]?([a-z0-9]+)/),
        M = a.match(/\bmi[ \-]?([a-z0-9 ]+(?= build|\)))/);
    N = -1 !== a.indexOf("samsung") ? a.match(/\bsamsung(?:[ \-](?:sgh|gt|sm))?-([a-z0-9]+)/) : a.match(/\b(?:sgh|sch|gt|sm)-([a-z0-9]+)/), R = /\bhtc[a-z0-9 _\-]+(?= build\b)/.test(a) ? a.match(/\bhtc[ _\-]?([a-z0-9 ]+(?= build))/) : a.match(/\bhtc[ _\-]?([a-z0-9 ]+)/), V && (s.coolpad = !0, s.version = V[1]), M && (s.mi = !0, s.version = M[1]), N && (s.samsung = !0, s.version = N[1]), R && (s.htc = !0, s.version = R[1]), o.pixelRatio = function () {
        var e = 1;
        try {
            e = window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI ? window.screen.systemXDPI / window.screen.logicalXDPI : (window.devicePixelRatio, undefined, window.devicePixelRatio), e = parseFloat(e) || 1;
        } catch (t) {}
        return e;
    }(), o.screenSizeCorrect = 1, o.android && (window.screen.width / window.innerWidth).toFixed(2) === o.pixelRatio.toFixed(2) && (o.screenSizeCorrect = 1 / o.pixelRatio), o.androidpad = o.androidPad = function () {
        var e = /\bpad\b|XiaoMi\/MiPad|lepad|YOGA|MediaPad|GT-P|SM-T|GT-N5100|sch-i800|HUAWEI\s?[MTS]\d+-\w+|Nexus\s7|Nexus\s8|Nexus\s11|Kindle Fire HD|Tablet|tab/i,
            t = 1,
            n = !1,
            a = (o.screenSizeCorrect || 1) * o.pixelRatio,
            r = Math.floor(window.screen.width * a),
            s = Math.floor(window.screen.height * a),
            d = 1;
        try {
            t = parseFloat(Math.sqrt(r * r + s * s)), d = parseFloat(t / (160 * o.pixelRatio));
        } catch (c) {}
        if ("ontouchstart" in window && o.android) {
            var l = !!e.test(i);
            /mobile/i.test(i) && !l ? n = !1 : l ? n = !0 : !n && (t >= 2500 || d > 7) && (n = !0);
        }
        return n;
    }(), o.type = function () {
        if (o.ios) return "ios";
        if (o.android) return "android";
        if (o.wp) return "Windows phone";
        if (o.osx) return "Mac";
        var e = navigator.platform,
            t = "X11" == e && !o.win && !o.osx,
            n = String(navigator.platform).indexOf("Linux") > -1;
        return t ? "Unix" : n ? "Linux" : o.win ? i.indexOf("Windows NT 5.0") > -1 || i.indexOf("Windows 2000") > -1 ? "Win2000" : i.indexOf("Windows NT 5.1") > -1 || i.indexOf("Windows XP") > -1 ? "WinXP" : i.indexOf("Windows NT 5.2") > -1 || i.indexOf("Windows 2003") > -1 ? "Win2003" : i.indexOf("Windows NT 6.0") > -1 || i.indexOf("Windows Vista") > -1 ? "WinVista" : i.indexOf("Windows NT 6.1") > -1 || i.indexOf("Windows 7") > -1 ? "Win7" : i.indexOf("Windows NT 6.2") > -1 || i.indexOf("Windows 8") > -1 ? "Win8" : "windows" : "other";
    }(), o.platform = function () {
        return o.ipad ? "ipad" : o.iphone ? "iphone" : o.ipod ? "ipod" : o.android ? "android" : o.androidPad ? "androidpad" : o.wp ? "windowsphone" : o.win ? (plat64 = i.indexOf("WOW64") > -1 || i.indexOf("Win64") > -1) ? "Win64" : "Win32" : navigator.platform;
    }(), r.protocol = window.location.protocol, e.exports = {
        os: o,
        browser: r,
        device: s
    };
}, function (e, t) {
    "use strict";

    var i = "function" == typeof symbol_default.a && "symbol" == typeof_default()(iterator_default.a) ? function (e) {
        return typeof e === "undefined" ? "undefined" : typeof_default()(e);
    } : function (e) {
        return e && "function" == typeof symbol_default.a && e.constructor === symbol_default.a && e !== symbol_default.a.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : typeof_default()(e);
    },
        n = function h(e, t, n) {
        if (n && h(e, n), t && "object" == (void 0 === t ? "undefined" : i(t))) for (var a in t) {
            e[a] = t[a];
        }return e;
    },
        a = function a(e, t) {
        if (e) for (var i in t) {
            "undefined" == typeof e[i] && (e[i] = t[i]);
        }return e;
    },
        o = function o(e) {
        return function (t) {
            return {}.toString.call(t) == "[object " + e + "]";
        };
    },
        r = o("Object"),
        s = o("Function"),
        d = Array.isArray || o("Array"),
        l = o("String"),
        c = function c(e, t, i) {
        var a = function a() {};
        a.prototype = t.prototype, e.prototype = new a(), e.prototype.constructor = e, e.prototype.superClass = t.prototype, e.superClass = t.prototype, i = i || {}, n(e.prototype, i), t.prototype.constructor === Object.prototype.constructor && (t.prototype.constructor = t);
    };
    e.exports = {
        extend: n,
        applyIf: a,
        isObject: r,
        isFunction: s,
        isArray: d,
        isString: l,
        inherit: c
    };
}, function (e, t, i) {
    "use strict";

    function n(e) {
        return null == e ? String(e) : S[C.call(e)] || "object";
    }
    function a(e, t, i) {
        if (i && a(e, i), t && "object" == (void 0 === t ? "undefined" : P(t))) for (var n in t) {
            e[n] = t[n];
        }return e;
    }
    function o(e, t) {
        var i, n;
        if (d(e)) {
            for (i = 0; i < e.length; i++) {
                if (!1 === t.call(e[i], i, e[i])) return e;
            }
        } else for (n in e) {
            if (!1 === t.call(e[n], n, e[n])) return e;
        }return e;
    }
    function r(e) {
        return null != e && e == e.window;
    }
    function s(e) {
        return E(e) && !r(e) && get_prototype_of_default()(e) == Object.prototype;
    }
    function d(e) {
        return "number" == typeof e.length;
    }
    function l(e) {
        return "http:" == B ? e : (o(F, function (t, i) {
            if (-1 != e.indexOf(i)) return e = e.replace("http:", B), !1;
        }), e);
    }
    function c(e, t) {
        var i = t.context;
        if (!1 === t.beforeSend.call(i, e, t)) return !1;
    }
    function h(e, t, i, n) {
        var a = i.context;
        i.success.call(a, e, "success", t), n({
            data: e,
            status: "success",
            xhr: t
        }), p("success", t, i);
    }
    function u(e, t, i, n, a) {
        var o = n.context;
        n.error.call(o, i, t, e), a({
            xhr: i,
            type: t,
            error: e
        }), p(t, i, n);
    }
    function p(e, t, i) {
        var n = i.context;
        i.complete.call(n, t, e);
    }
    function m() {}
    function f(e) {
        return e && (e = e.split(";", 2)[0]), e && (e == V ? "html" : e == R ? "json" : q.test(e) ? "script" : N.test(e) && "xml") || "text";
    }
    function v(e, t) {
        return "" == t ? e : (e + "&" + t).replace(/[&?]{1,2}/, "?");
    }
    function g(e, t) {
        var i = [];
        return i.add = function (e, t) {
            A(t) && (t = t()), null == t && (t = ""), this.push($(e) + "=" + $(t));
        }, y(i, e, t), i.join("&").replace(/%20/g, "+");
    }
    function y(e, t, i, a) {
        var r,
            d = I(t),
            l = s(t);
        o(t, function (t, o) {
            r = n(o), a && (t = i ? a : a + "[" + (l || "object" == r || "array" == r ? t : "") + "]"), !a && d ? e.add(o.name, o.value) : "array" == r || !i && "object" == r ? y(e, o, i, t) : e.add(t, o);
        });
    }
    function w(e) {
        e.processData && e.data && !M(e.data) && (e.data = g(e.data, e.traditional)), !e.data || e.type && "GET" != e.type.toUpperCase() || (e.url = v(e.url, e.data), e.data = undefined);
    }
    function b(e) {
        var t,
            i,
            n = a({}, e || {});
        for (k in W) {
            n[k] === undefined && (n[k] = W[k]);
        }n.crossDomain || (t = O.createElement("a"), t.href = n.url, t.href = t.href, n.crossDomain = H.protocol + "//" + H.host != t.protocol + "//" + t.host), n.url || (n.url = window.location.toString()), (i = n.url.indexOf("#")) > -1 && (n.url = n.url.slice(0, i)), n.url = l(n.url), w(n);
        var o = n.dataType,
            r = /\?.+=\?/.test(n.url);
        if (r && (o = "jsonp"), !1 !== n.cache && (e && !0 === e.cache || "script" != o && "jsonp" != o) || (n.url = v(n.url, "_=" + Date.now())), "jsonp" == o) return r || (n.url = v(n.url, n.jsonp ? n.jsonp + "=?" : !1 === n.jsonp ? "" : "callback=?")), x(n);
        var s,
            d = n.accepts[o],
            p = {},
            g = function g(e, t) {
            p[e.toLowerCase()] = [e, t];
        },
            y = /^([\w-]+:)\/\//.test(n.url) ? RegExp.$1 : window.location.protocol,
            b = n.xhr(),
            T = b.setRequestHeader;
        if (n.crossDomain || g("X-Requested-With", "XMLHttpRequest"), g("Accept", d || "*/*"), (d = n.mimeType || d) && (d.indexOf(",") > -1 && (d = d.split(",", 2)[0]), b.overrideMimeType && b.overrideMimeType(d)), (n.contentType || !1 !== n.contentType && n.data && "GET" != n.type.toUpperCase()) && g("Content-Type", n.contentType || "application/x-www-form-urlencoded"), n.headers) for (_ in n.headers) {
            g(_, n.headers[_]);
        }return b.setRequestHeader = g, new D(function (e, t) {
            if (b.onreadystatechange = function () {
                if (4 == b.readyState) {
                    b.onreadystatechange = m, clearTimeout(s);
                    var i,
                        a = !1;
                    if (b.status >= 200 && b.status < 300 || 304 == b.status || 0 == b.status && "file:" == y) {
                        o = o || f(n.mimeType || b.getResponseHeader("content-type")), i = b.responseText;
                        try {
                            "script" == o ? (0, eval)(i) : "xml" == o ? i = b.responseXML : "json" == o && (i = j.test(i) ? null : JSON.parse(i));
                        } catch (r) {
                            a = r;
                        }
                        a ? u(a, "parsererror", b, n, t) : h(i, b, n, e);
                    } else u(b.statusText || null, b.status ? "error" : "abort", b, n, t);
                }
            }, !1 === c(b, n)) return b.abort(), void u(null, "abort", b, n, t);
            if (n.xhrFields) for (_ in n.xhrFields) {
                b[_] = n.xhrFields[_];
            }var i = !("async" in n) || n.async;
            b.open(n.type, n.url, i, n.username, n.password);
            for (_ in p) {
                T.apply(b, p[_]);
            }n.timeout > 0 && (s = setTimeout(function () {
                b.onreadystatechange = m, b.abort(), u(null, "timeout", b, n, t);
            }, n.timeout)), b.send(n.data ? n.data : null);
        });
    }
    function x(e, t) {
        return "type" in e ? new D(function (t, i) {
            function n() {
                d.onload = d.onreadystatechange = null, O.head.removeChild(d), d = null, clearTimeout(o), h(a && a.length ? a[0] : null, m, e, t), window[s] = l, a && A(l) && l(a[0]), l = a = undefined;
            }
            var a,
                o,
                r = e.jsonpCallback,
                s = (A(r) ? r() : r) || "jsonpx" + new Date().getTime() + "_" + Math.ceil(100 * Math.random()) + "_" + ++U,
                d = O.createElement("script"),
                l = window[s],
                p = function p(e) {
                i({
                    errorType: e
                });
            },
                m = {
                abort: p
            };
            if (!1 === c(m, e)) return void p("abort");
            "onload" in d ? d.onload = n : d.onreadystatechange = function () {
                /loaded|complete/.test(d.readyState) && n();
            }, d.onerror = function () {
                u(null, "error", m, e, i);
            }, window[s] = function () {
                a = arguments;
            }, d.src = e.url.replace(/\?(.+)=\?/, "?$1=" + s), O.head.appendChild(d), e.timeout > 0 && (o = setTimeout(function () {
                p("timeout");
            }, e.timeout));
        }) : b(e);
    }
    function T(e, t, i, n) {
        return A(t) && (n = i, i = t, t = undefined), A(i) || (n = i, i = undefined), {
            url: e,
            data: t,
            success: i,
            dataType: n
        };
    }
    var P = "function" == typeof symbol_default.a && "symbol" == typeof_default()(iterator_default.a) ? function (e) {
        return typeof e === "undefined" ? "undefined" : typeof_default()(e);
    } : function (e) {
        return e && "function" == typeof symbol_default.a && e.constructor === symbol_default.a && e !== symbol_default.a.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : typeof_default()(e);
    },
        D = i(8),
        S = {},
        C = S.toString;
    o("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (e, t) {
        S["[object " + t + "]"] = t.toLowerCase();
    });
    var k,
        _,
        L = function L(e) {
        return function (t) {
            return {}.toString.call(t) == "[object " + e + "]";
        };
    },
        E = L("Object"),
        A = L("Function"),
        I = Array.isArray || L("Array"),
        M = L("String"),
        B = window.location.protocol,
        F = ["http://tv.sohu.com", "http://m.tv.sohu.com", "http://api.tv.sohu.com", "http://gslb.tv.sohu.com", "http://count.vrs.sohu.com", "http://rc.vrs.sohu.com", "http://m.aty.sohu.com", "http://vstat.v.blog.sohu.com"],
        U = 0,
        O = window.document,
        q = /^(?:text|application)\/javascript/i,
        N = /^(?:text|application)\/xml/i,
        R = "application/json",
        V = "text/html",
        j = /^\s*$/,
        H = O.createElement("a");
    H.href = window.location.href;
    var $ = encodeURIComponent,
        W = {
        type: "GET",
        beforeSend: m,
        success: m,
        error: m,
        complete: m,
        context: null,
        global: !0,
        xhr: function xhr() {
            return new window.XMLHttpRequest();
        },
        accepts: {
            script: "text/javascript, application/javascript, application/x-javascript",
            json: R,
            xml: "application/xml, text/xml",
            html: V,
            text: "text/plain"
        },
        crossDomain: !1,
        timeout: 0,
        processData: !0,
        cache: !0
    };
    b.get = function () {
        return b(T.apply(null, arguments));
    }, b.post = function () {
        var e = T.apply(null, arguments);
        return e.type = "POST", b(e);
    }, b.getJSON = function () {
        var e = T.apply(null, arguments);
        return e.dataType = "json", b(e);
    }, b.getScript = function (e, t) {
        return e = l(e), new D(function (i, n) {
            function a() {
                o.onload = o.onreadystatechange = null, r.removeChild(o), o = null, i();
            }
            var o = O.createElement("script"),
                r = O.head || O.getElementsByTagName("head")[0] || O.documentElement;
            o.type = "text/javascript", o.async = !0, t && (o.charset = t), o.src = e, "onload" in o ? o.onload = a : o.onreadystatechange = function () {
                /loaded|complete/.test(o.readyState) && a();
            }, r.insertBefore(o, r.firstChild);
        });
    }, e.exports = b;
}, function (e, t, i) {
    "use strict";

    var n = "function" == typeof symbol_default.a && "symbol" == typeof_default()(iterator_default.a) ? function (e) {
        return typeof e === "undefined" ? "undefined" : typeof_default()(e);
    } : function (e) {
        return e && "function" == typeof symbol_default.a && e.constructor === symbol_default.a && e !== symbol_default.a.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : typeof_default()(e);
    },
        a = i(1).browser,
        o = i(1).os,
        r = i(5),
        s = i(6),
        d = navigator.userAgent,
        l = {
        pingback: function pingback(e) {
            if (e) for (var t = e.split("|"), i = 0, n = t.length; i < n; i++) {
                new Image().src = t[i];
            }
        },
        formatURL: function formatURL(e) {
            return e += "", e = e.replace(/^https?:\/\/(my\.|v\.)?tv\./i, "http://m.tv.").replace("http://s.", "http://m.s.").replace("http://m.s.", "http://m.tv.").replace(/^http:\/\/(video\.)?2012/i, "http://m.s");
        },
        makePlayUrl: function makePlayUrl(e, t) {
            var i = "//" + location.host;
            return e.vid && (e.site = e.site || 1, 1 === e.site ? i += "/v" : i += "/u/vw/", i += e.vid + ".shtml", t && (i += "?channeled=" + t)), i;
        },
        getSohuDefaultApplink: function getSohuDefaultApplink(e) {
            if (e && "string" == typeof e) return e;
            var t = "//m.tv.sohu.com/app";
            return o.android && (t = o.androidPad ? "//upgrade.m.tv.sohu.com/channels/hdv/5.0.0/SohuTVPad_5.0.0_1369_201507271523.apk" : "//upgrade.m.tv.sohu.com/channels/hdv/5.0.0/SohuTV_5.0.0_680_201506111914.apk"), o.iphone && (t = "https://itunes.apple.com/cn/app/sou-hu-shi-pin-gao-qing/id458587755?mt=8"), o.ipad && (t = "https://itunes.apple.com/cn/app/sou-hu-shi-pin-hd/id414430589?mt=8"), o.wp && (t = "//www.windowsphone.com/zh-CN/apps/403faf93-d22c-4331-ac32-9560ee9fac94"), o.winpad && (t = "//apps.microsoft.com/windows/zh-CN/app/c5ae3c2a-5573-45c2-ac63-7d67e01de6bb"), o.weixin && !o.iphone && (t = "//a.app.qq.com/o/simple.jsp?pkgname=com.sohu.sohuvideo&g_f=991881"), t;
        },
        getConnectionType: function getConnectionType() {
            var e,
                t = window.navigator.connection,
                i = "";
            return t && (e = t.type, e === t.CELL_2G ? i = "2g" : e === t.CELL_3G ? i = "3g" : e === t.WIFI && (i = "wifi")), i;
        },
        getUserPt: function getUserPt() {
            var e = 1;
            if ("undefined" != typeof navigator.platform) for (var t = ["Win32", "Win64", "Windows", "Mac68K", "MacPC", "Macintosh", "MacIntel"], i = 0, n = t.length; i < n; i++) {
                if (navigator.platform === t[i]) {
                    e = 1;
                    break;
                }
            }return o.ipad && (e = 2), o.iphone && (e = 3), o.android && (e = 5, !/mobile/i.test(d) && /tv/i.test(d) && (e = 6)), o.androidPad && (e = 4), o.winpad && (e = 7), o.wp && (e = 8), e;
        },
        getChanneled: function getChanneled() {
            var e = window.__videoData || {},
                t = (r.getQueryString("src") || r.getQueryString("SRC") || "").replace("|", "").replace("%7C", ""),
                i = r.getQueryString("channeled") || "";
            return i || (e.channeled ? i = e.channeled : 1 == e.site ? i = "1211010000" : 2 == e.site && (i = "1211020000"), i = i || "0", t && (i = "1212130001"), a.weixin && "121111" !== i.substr(0, 6) && (i = "1211110001"), "sogou" == r.getQueryString("from") && (i = "1200150001"), 1 != this.checkOutset() && (i = "1212130001")), i;
        },
        getLQD: function getLQD() {
            return r.getQueryString("lqd") || s("_LQD") || "";
        },
        getLCODE: function getLCODE() {
            return r.getQueryString("lcode") || s("_LCODE") || "";
        },
        formatCount: function formatCount(e) {
            if ("number" != typeof (e = parseInt(e))) return e;
            var t = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g;
            return e >= 1e8 ? (e = Math.round(10 * parseFloat(e / 1e8)) / 10, e = e.toString().replace(t, "$1,") + "\u4EBF") : e = e >= 1e5 ? parseInt(e / 1e4).toString().replace(t, "$1,") + "\u4E07" : e.toString().replace(t, "$1,"), e;
        },
        addUrlParam: function addUrlParam(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
            if (!e) return "";
            if ("object" == (void 0 === t ? "undefined" : n(t))) {
                var i = [];
                for (var a in t) {
                    i.push(a + "=" + t[a]);
                }t = i.join("&");
            }
            return e.indexOf("?") > 0 ? e += "&" + t : e += "?" + t, e;
        },
        checkOutset: function checkOutset() {
            try {
                var e = window.parent.document.domain;
            } catch (t) {
                return "3";
            }
            return window.parent.location.href !== window.location.href ? "3" : -1 == e.indexOf("m.tv.sohu.com") ? "2" : "1";
        },
        ellipsis: function ellipsis(e, t, i) {
            var n, a, o, r;
            n = e.offsetWidth, a = t, o = e.innerHTML.length, r = ~~(n / a) * i, o > r && (e.innerHTML = e.innerHTML.substring(0, r - 2) + "...");
        },
        cdTimeout: null,
        countDownSecond: function countDownSecond(e, t) {
            var i;
            i = e.innerHTML.slice(0, -1), this.cdTimeout = i > 1 ? setTimeout(function () {
                e.innerHTML = i - 1 + "\u79D2", this.countDownSecond(e, t);
            }.bind(this), 1e3) : setTimeout(function () {
                clearTimeout(this.cdTimeout), this.cdTimeout = null, t();
            }, 1e3);
        },
        removeProtocol: function removeProtocol() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            return e && (e = document.location.protocol + e.replace(/^https?:/, "")), e;
        },
        getOrientation: function getOrientation() {
            var e = 1;
            return 0 != window.orientation && 180 != window.orientation || (e = 2), e;
        }
    };
    l.covert2mUrl = l.formatURL, e.exports = l;
}, function (e, t) {
    "use strict";

    var i = {
        getQueryData: function getQueryData(e) {
            e = e.replace(/^\?+/, "").replace(/&amp;/, "&");
            for (var t, i = e.split("&"), n = 0, a = {}; n < i.length;) {
                if (t = i[n].split("="), t[0]) {
                    var o = t[1] || "";
                    try {
                        o = decodeURIComponent(o);
                    } catch (r) {
                        o = unescape(o);
                    }
                    o = "null" === o ? null : o, a[decodeURIComponent(t[0])] = o;
                }
                n++;
            }
            return a;
        },
        getQueryString: function getQueryString(e) {
            var t,
                n = window.location.search.substring(1).replace(/[\?&]sohuaction=(.*)/, "");
            return t = i.getQueryData(n), e in t ? t[e] : null;
        },
        getParam: function getParam(e, t) {
            var i, n;
            void 0 === t ? (n = window.location.href, i = new RegExp("(^|&?)" + e + "=([^&]*)(&|$)", "i")) : (n = e, i = new RegExp("(^|&?)" + t + "=([^&]*)(&|$)", "i"));
            var a = n.match(i);
            return null !== a ? decodeURIComponent(a[2]) : null;
        },
        stringify: function stringify(e) {
            var t,
                i,
                n = [];
            for (t in e) {
                i = e[t];
                var a = Object.prototype.toString.call(i);
                "[object Array]" === a ? n.push(t + "=" + stringify_default()(i)) : "[object Object]" === a ? n.push(t + "=" + stringify_default()(i)) : n.push(t + "=" + encodeURIComponent(void 0 === i ? "" : i));
            }
            return n.join("&");
        }
    };
    e.exports = i;
}, function (e, t) {
    "use strict";

    function i(e, t, i) {
        if (void 0 === t) {
            var n = new RegExp("(?:^|; )" + e + "=([^;]*)").exec(document.cookie);
            return n ? n[1] || "" : "";
        }
        i = i || {}, null === t && (t = "", i.expires = -1);
        var a = "";
        if (i.expires && ("number" == typeof i.expires || i.expires.toUTCString)) {
            var o;
            "number" == typeof i.expires ? (o = new Date(), o.setTime(o.getTime() + 24 * i.expires * 60 * 60 * 1e3)) : o = i.expires, a = "; expires=" + o.toUTCString();
        }
        var r = i.path ? "; path=" + i.path : "",
            s = i.domain ? "; domain=" + i.domain : "",
            d = i.secure ? "; secure" : "";
        document.cookie = [e, "=", t, a, r, s, d].join("");
    }
    i.isEnable = function () {
        var e = !0,
            t = "____test";
        return i(t, 1), 1 != i(t) && (e = !1), i(t, null), e;
    }, e.exports = i;
},, function (e, t) {
    (function (t) {
        "use strict";

        function i(e) {
            return d(e) && l(e.then);
        }
        function n(e) {
            function t(e) {
                if (n.__status == a) {
                    n.__status = o, n.__value = e;
                    for (var t, i = n.__resolveList; t = i.shift();) {
                        t(e);
                    }
                }
            }
            function i(e) {
                if (n.__status == a) {
                    n.__status = r, n.__value = e;
                    for (var t, i = n.__rejectList; t = i.shift();) {
                        t(e);
                    }
                }
            }
            this.__status = a, this.__resolveList = [], this.__rejectList = [];
            var n = this;
            e(t, i);
        }
        var a = "pending",
            o = "resolved",
            r = "rejected",
            s = function s(e) {
            return function (t) {
                return {}.toString.call(t) == "[object " + e + "]";
            };
        },
            d = s("Object"),
            l = s("Function"),
            c = Array.isArray || s("Array");
        n.prototype.then = function (e, t) {
            var a = this;
            return new n(function (n, s) {
                var d = function d(t) {
                    try {
                        var a = e ? e(t) : t;
                    } catch (o) {
                        return o instanceof Error || (o = new Error(o)), o._code = -1e4, window.console && console.log && console.log(o), void s(o);
                    }
                    i(a) ? a.then(function (e) {
                        n(e);
                    }) : n(a);
                },
                    l = function l(e) {
                    if (e instanceof Error && !t) s(e);else {
                        try {
                            t && t(e);
                        } catch (i) {
                            return i instanceof Error || (i = new Error(i)), i._code = -1e4, window.console && console.log && console.log(i), void s(i);
                        }
                        n();
                    }
                };
                a.__status == o ? d(a.__value) : a.__status == r ? l(a.__value) : (a.__resolveList.push(d), a.__rejectList.push(l));
            });
        }, n.prototype["catch"] = function (e) {
            var t = this;
            return new n(function (i, n) {
                var a = function a(n) {
                    if (n instanceof Error && -1e4 == n._code) {
                        var a = e ? e(n) : n;
                        i(a);
                    } else i(t.__value);
                };
                t.__status == o ? i(t.__value) : t.__status == r ? a(t.__value) : (t.__resolveList.push(i), t.__rejectList.push(a));
            });
        }, n.resolve = function (e) {
            return new n(i(e) ? function (t, i) {
                e.then(t, i);
            } : function (t) {
                t(e);
            });
        }, n.reject = function (e) {
            return new n(i(e) ? function (t, i) {
                e.then(t, i);
            } : function (t, i) {
                i(e);
            });
        }, n.all = function (e) {
            if (!c(e)) throw "arguments must be an array in Promise.all";
            return new n(function (t, a) {
                for (var o, r = 0, s = e.length, d = 0, l = []; r < s; r++) {
                    o = e[r], i(o) || (o = n.resolve(o)), function (e) {
                        o.then(function (i) {
                            l[e] = i, (d += 1) == s && t(l);
                        }, a);
                    }(r);
                }
            });
        }, n.race = function (e) {
            if (!c(e)) throw "arguments must be an array in Promise.race";
            return new n(function (t, a) {
                for (var o, r = 0, s = e.length; r < s; r++) {
                    o = e[r], i(o) || (o = n.resolve(o)), o.then(t, a);
                }
            });
        }, "undefined" != typeof window && window.Promise ? e.exports = window.Promise : void 0 !== t && t.Promise ? e.exports = t.Promise : e.exports = n;
    }).call(t, function () {
        return this;
    }());
}, function (e, t, i) {
    "use strict";

    function n() {
        var e = 1;
        return s.ipad ? e = 2 : s.iphone ? e = 3 : s.android ? (e = 5, /tv/i.test(l) && (e = 6)) : s.androidPad ? e = 4 : s.winpad ? e = 7 : s.wp && (e = 8), e;
    }
    var a,
        o = i(5),
        r = i(1).browser,
        s = i(1).os,
        d = i(6),
        l = navigator.userAgent;
    a = {
        API_KEY: "f351515304020cad28c92f70f002261c",
        REQUEST_MAX_COUNT: 3,
        ENABLE_DEBUG: o.getQueryString("debug") || o.getQueryString("DEBUG"),
        IS_EXTERNAL_PLAYER: location.href.match(/player=1/i) || location.host.indexOf("m.sohu.com") > -1,
        ScreenSizeCorrect: 1,
        PixelRatio: function () {
            var e = 1;
            try {
                e = window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI ? window.screen.systemXDPI / window.screen.logicalXDPI : (window.devicePixelRatio, undefined, window.devicePixelRatio), e = parseFloat(e) || 1;
            } catch (t) {}
            return e;
        }(),
        createUUID: function createUUID() {
            var e = Math.floor(window.screen.width),
                t = Math.floor(window.screen.height),
                i = Math.floor(Math.sqrt(e * e + t * t)) || 0,
                a = Math.round(n()) || 1;
            return 1e3 * +new Date() + a + i + Math.round(1e3 * Math.random());
        }
    }, r.android && (window.screen.width / window.innerWidth).toFixed(2) === a.PixelRatio.toFixed(2) && (a.ScreenSizeCorrect = 1 / a.PixelRatio), a.ScreenSize = Math.floor(window.screen.width * a.ScreenSizeCorrect) + "x" + Math.floor(window.screen.height * a.ScreenSizeCorrect), a.uid = function () {
        var e = d("SUV");
        if (!e) {
            e = a.createUUID();
            var t = document.domain;-1 != t.indexOf("sohu.com") && (t = "sohu.com"), d("SUV", e, {
                domain: t,
                path: "/",
                expires: 300
            });
        }
        return e;
    }(), a.muid = function () {
        var e = d("_muid_");
        if (!e) {
            e = a.createUUID();
            var t = document.domain;-1 != t.indexOf("sohu.com") && (t = "sohu.com"), d("_muid_", e, {
                domain: t,
                path: "/",
                expires: 300
            });
        }
        return e;
    }(), a.is56 = -1 != document.domain.indexOf("56.com"), a.issohu = -1 != document.domain.indexOf("sohu.com"), a.isExternal = function () {
        return !(-1 != document.domain.indexOf("tv.sohu.com") || a.is56);
    }(), e.exports = a;
}, function (e, t) {
    "use strict";

    e.exports = window.console;
}, function (e, t, i) {
    "use strict";

    var n = i(1).browser,
        a = i(1).os,
        o = i(4),
        r = i(9),
        s = (i(10), i(6), i(15)),
        d = i(13),
        l = i(5),
        c = {
        pingback: function pingback(e, t) {
            e = e || "", t = t || {};
            var i = window.__videoData || {},
                c = o.getChanneled(),
                h = i.vid || "",
                u = i.plid || i.aid || i.sid || "",
                p = location.href,
                m = {},
                f = l.getParam("columnid");
            f && (t.columnId = f);
            try {
                n.weixin && "121111" !== c.substr(0, 6) && (c = "1211110001"), 1 != o.checkOutset() && (c = "1212130002"), m = {
                    t: +new Date(),
                    uid: r.uid,
                    position: e,
                    op: "click",
                    details: stringify_default()(t),
                    nid: i.nid || "",
                    url: encodeURIComponent(p),
                    refer: l.getParam("landingrefer") || encodeURIComponent(document.referrer),
                    screen: r.ScreenSize,
                    os: a.type,
                    platform: a.platform,
                    passport: s.getPassport(),
                    vid: h || "",
                    pid: u || "",
                    channeled: c,
                    MTV_SRC: encodeURIComponent(d.getSrc())
                };
            } catch (v) {
                console.log("trace click exception ", v);
            }
            o.pingback("//z.m.tv.sohu.com/h5_cc.gif?" + l.stringify(m));
        }
    };
    e.exports = c;
}, function (e, t, i) {
    "use strict";

    function n(e) {
        this.content = e || "", this.helper = new r();
    }
    var a = "function" == typeof symbol_default.a && "symbol" == typeof_default()(iterator_default.a) ? function (e) {
        return typeof e === "undefined" ? "undefined" : typeof_default()(e);
    } : function (e) {
        return e && "function" == typeof symbol_default.a && e.constructor === symbol_default.a && e !== symbol_default.a.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : typeof_default()(e);
    },
        o = i(2),
        r = i(26),
        s = {
        h: {
            name: "helper",
            dir: "helper"
        }
    },
        d = "".trim ? function (e) {
        return e.trim();
    } : function (e) {
        return (e || "").replace(/(^\s*)|(\s*$)/g, "");
    };
    o.extend(n, {
        render: function render(e, t) {
            return new n(e).render(t);
        },
        registHelper: function registHelper() {
            var e = {},
                t = [].slice.call(arguments);
            2 == t.length && "string" == typeof t[0] ? e[t[0]] = t[1] : "1" == t.length && "object" == a(t[0]) && (e = t[0]), e && o.extend(r.prototype, e);
        }
    }), o.extend(n.prototype, {
        version: "1.0",
        setContent: function setContent(e) {
            this.fn = null, this.directive = null, this.content = e;
        },
        render: function render(e) {
            this.compile();
            var t,
                i,
                n = this.directive || {};
            for (var a in s) {
                if (i = s[a], t = "undefined" == typeof n[a] ? i.name : n[a], e[t]) throw new Error("\u6307\u4EE4{ " + t + " }\u51B2\u7A81...");
                e[t] = this[i.dir];
            }
            var o = this.fn(e);
            for (a in s) {
                i = s[a], t = "undefined" == typeof n[a] ? i.name : n[a], delete e[t];
            }return o;
        },
        compile: function compile() {
            if (!this.fn) {
                this.directive = {};
                var e = this,
                    t = this.content.replace(/[\r\t\n]/g, " ").replace(/<%@(.*?)%>/g, function (t, i) {
                    return i && (t = i.split(":")) && t.length && (e.directive[d(t[0])] = d(t[1])), "";
                }).replace(/<%!--(.*?)--%>/g, "").split("<%").join("\t").replace(/((^|%>)[^\t]*)'/g, "$1\r").replace(/\t=(.*?)%>/g, "',$1,'").split("\t").join("');").split("%>").join("p.push('").split("\r").join("\\'"),
                    i = "var p = [];with(obj){p.push('" + t + "');}return p.join('');";
                this.fn = new Function("obj", i);
            }
            return this;
        },
        registHelper: function registHelper() {
            var e = this[s.h.dir],
                t = [].slice.call(arguments);
            2 == t.length && "string" == typeof t[0] ? e[t[0]] = t[1] : "1" == t.length && "object" == a(t[0]) && o.extend(e, t[0]);
        }
    }), e.exports = n;
}, function (e, t, i) {
    "use strict";

    function n(e) {
        var t = e || document.referrer,
            i = t.match(/.*:\/\/([^\/]*).*/i),
            n = "";
        return i && (n = i[1]), !/(\d+).(\d+).(\d+).(\d+)/i.test(n) && n || (n = ""), n;
    }
    function a(e) {
        var t = e || "",
            i = t.match(/.*:\/\/([^\/]*).*/i),
            n = "";
        return i && (n = i[1]), n;
    }
    function o(e, t) {
        var i = "";
        try {
            e = e.replace(/^http:\/\//, "").replace(/^https:\/\//, "");
            var n = t;
            void 0 === n && (n = g.srcSettings);
            for (var a in n) {
                var o = n[a];
                if (o && e && o.test(e)) {
                    i = a;
                    break;
                }
            }
        } catch (r) {
            console.log(r);
        }
        return i;
    }
    var r = i(1).browser,
        s = i(1).os,
        d = i(2),
        l = i(4),
        c = i(3),
        h = i(6),
        u = i(5),
        p = i(9),
        m = i(8),
        f = i(10),
        v = function () {
        var e = {
            domain: "sohu.com",
            path: "/"
        };
        return p.is56 && (e = {
            domain: "56.com",
            path: "/"
        }), e;
    }(),
        g = {
        openTime: 500,
        updateTime: 36e5,
        maxSaveCounts: 10,
        srcSettings: {
            1106: /^tv\.sohu\.com$|^pad\.tv\.sohu\.com$/i,
            1107: /^my\.tv\.sohu\.com$/i,
            1108: /^sports\.sohu\.com$/i,
            1105: /^(m|wap|s|3g)\.(tv|s)\.sohu\.com$|^(t|t1|t2)\.m\.tv\.sohu\.com$|^sohutv\.hao3608\.com$/i,
            1109: /^(news|auto|media|www|yule|mil)\.sohu\.com$/i,
            1001: /^m\.sohu\.com$|^(3g|zhibo|wap)\.sohu\.com$|^(.*)m\.sohu\.com$|^m\.club\.sohu\.com$|^api\.k\.sohu\.com$/i,
            1110: /^(.*)\.baidu\.com$|^(.*)baidu\.mobi$|^webapp\.cbs\.baidu\.com$/i,
            1112: /^(.*)hao123\.com$/i,
            1113: /^v\.m\.liebao\.cn$|^v\.duba\.com$/i,
            1114: /^(.*)2345\.com$/i,
            1115: /^v\.sogou\.com$|^m\.kan\.sogou\.com$|^tv\.sogou\.com$/i,
            1068: /^sogou\.com$|^(.*)\.sogou\.com$/i,
            1116: /^(.*)sm\.cn$|^(.*)uodoo\.com$/i,
            1006: /^tv\.uc\.cn$/i,
            1007: /^hao\.uc\.cn$/i,
            1117: /^(news|inews)\.uc\.cn$/i,
            1033: /^m\.video\.so\.com$/i,
            1075: /^(.*)(so|haosou)\.com$/i,
            1118: /^(.*)weibo\.com$|^(.*)weibo\.cn$/i,
            1119: /^(.*)qzone\.qq\.com$/i,
            1120: /^(.*)10086\.cn$/i,
            1123: /^(.*)(google|g).(.*)$/i,
            1121: /^(.*)wapreach\.com$|^(.*)\.app111\.com$|^(.*)homeinns\.cc$|^(hao|hao123|m)\.xiaomi\.com$/i,
            1122: /^video\.wapreach\.com$|^video\.browser\.miui\.com$|^v\.html5\.qq\.com$|^kanpian\.easou\.com$|^video\.nearme\.com\.cn$/i,
            1124: /^(.*)soso\.com$|^(.*)easou\.com$|^(.*)bing\.com$/i
        },
        getLocalData: function getLocalData(e) {
            var t = null,
                i = [];
            try {
                t = localStorage.getItem("localChannelInfo");
            } catch (r) {
                f.log("\u4E0D\u652F\u6301localStorage-->", r);
            }
            if (t && (i = JSON.parse(t)), void 0 === e) return i;
            for (var n, a = 0, o = i.length; a < o; a++) {
                if (n = i[a], n.channelSrc == e && Date.now() < n.time + this.updateTime) return n;
            }return null;
        },
        setLocalData: function setLocalData(e) {
            var t = d.extend({}, e);
            t.time = Date.now();
            for (var i, n = this.getLocalData() || [], a = !1, o = 0, r = n.length; o < r; o++) {
                if (i = n[o], i.channelSrc == t.channelSrc) {
                    a = !0, n[o] = t;
                    break;
                }
            }a || n.unshift(t), n.length > this.maxSaveCounts && (saveList.length = this.maxSaveCounts);
            try {
                localStorage.setItem("localChannelInfo", stringify_default()(n));
            } catch (s) {
                f.log("\u4E0D\u652F\u6301localStorage-->", s);
            }
        },
        loadChannelInfo: function loadChannelInfo(e) {
            var t = this,
                e = e || {},
                i = e.channelSrc || this.getSrc();
            (i + "").length > 4 && (i = i.substr(0, 4));
            var n = {
                appointUrl: l.getSohuDefaultApplink(),
                startapp: "1",
                channelSrc: i,
                cover: 1,
                isClosed: 0,
                timeLimit: 0,
                channelNum: 680,
                cid: "",
                quality: "nor,hig,sup"
            };
            return new m(function (e, a) {
                if (i = parseInt(i, 10), null !== t.getLocalData(i)) {
                    var o = t.getLocalData(i);
                    "undefined" == typeof o.cover && (o.cover = 1, o.isClosed = 0, o.timeLimit = 0, o.quality = "nor,hig,sup", o.channelNum = 680), "undefined" == typeof o.cid && (o.cid = ""), e(o);
                } else {
                    i = parseInt(i, 10), isNaN(i) && (i = "0");
                    var d = "//m.tv.sohu.com/h5/cooperation/" + i + ".json?pos=1&platform=" + l.getUserPt() + "&callback=?";
                    f.log("\u83B7\u53D6\u6E20\u9053\u4FE1\u606Fajax:", d);
                    var h = new Date();
                    h.setHours(0), h.setMinutes(0), h.setSeconds(0), c.getJSON(d, {
                        t: h.getTime()
                    }).then(function (i) {
                        if (i = i || {}, i = i.data || {}, i.records && i.records.length > 0) {
                            var a = i.records[0];
                            s.ipad || s.iphone || r.weixin || (n.appointUrl = a.link), n.startapp = "undefined" != typeof a.startapp ? a.startapp + "" : "1", n.cover = a.cover, n.isClosed = a.isClosed, n.cid = a.cid || "", n.limitIds = a.limit_ids || "", n.cid2 = a.cid2 || "", n.limitIds2 = a.limit_ids2 || "", n.limitPlays = ~~a.limit_plays || 0, n.timeLimit = a.time_limit, n.quality = a.quality, n.channelNum = a.num, n.time = Date.now(), t.setLocalData(n);
                        }
                        e(n);
                    }, function () {
                        e(n);
                    });
                }
            });
        },
        getDownloadUrl: function getDownloadUrl(e, t) {
            t = t || function () {};
            var i = this;
            return new m(function (n, a) {
                if (e && e.downUrl) t(e.downUrl), n(e.downUrl);else {
                    var o = e && e.channelSrc || i.getSrc(),
                        r = i.getLocalData(o);
                    null !== r ? (t(r.appointUrl), n(r.appointUrl)) : i.loadChannelInfo(e).then(function (e) {
                        t(e.appointUrl), n(e.appointUrl);
                    });
                }
            });
        },
        getSrc: function getSrc() {
            var e;
            if (r.wx && /^wx\.m\.tv\.sohu\.com$/i.test(document.domain)) e = "11040001";else {
                var t = u.getParam("landingrefer") || document.referrer || "",
                    i = n(t) || a(window.location.href) || "";
                e = (u.getQueryString("src") || u.getQueryString("SRC") || h("MTV_SRC") || "").replace("|", "").replace("%7C", ""), e || (i && (e = o(i, this.srcSettings), e.length < 8 && e.length >= 4 && (e = e.substring(0, 4) + "0001")), e || (e = "11050001"));
            }
            return (/iqiyi|qqlive|letv|youku/gim.test(navigator.userAgent) && (e = "12540001"), e
            );
        },
        setSrc: function setSrc() {
            var e = this.getSrc();
            h("MTV_SRC", e, v);
        },
        setLM: function setLM() {
            var e = u.getQueryString("lqd"),
                t = u.getQueryString("lcode"),
                i = u.getQueryString("lmcc"),
                n = function () {
                var e = {
                    domain: "tv.sohu.com",
                    path: "/"
                };
                return p.is56 && (e = {
                    domain: "m.56.com",
                    path: "/"
                }), e;
            }();
            1 == i || function () {
                for (var e = ["360kan.com", "baidu.com", "baidu.mobi", "baidu.cn", "hao123.com", "360.cn", "3600.com", "c.360webcache.com", "so.com", "duba.net", "duba.com", "rising.cn", "sogou.com", "soso.com", "2345.com", "2345x.com", "2345y.com"], t = !1, i = 0, n = e.length, a = u.getParam("landingrefer") || document.referrer; i < n; i++) {
                    if (-1 != a.indexOf(e[i])) {
                        t = !0;
                        break;
                    }
                }return t;
            }() ? (h("_LQD", null, n), h("_LCODE", null, n)) : (e && h("_LQD", e, n), t && h("_LCODE", t, n));
        }
    };
    g.setSrc(), g.setLM(), window.channelFetcher = g, e.exports = g;
}, function (e, t) {
    "use strict";

    function i() {
        this.__events = {};
    }
    function n(e) {
        return d(e, {
            __emitter: new i(),
            on: function on(e, t, i) {
                this.__emitter.on(e, t, i);
            },
            off: function off(e, t) {
                this.__emitter.off(e, t);
            },
            one: function one(e, t) {
                this.__emitter.one(e, t);
            },
            emit: function emit(e, t) {
                this.__emitter.emit(e, t);
            }
        }), e;
    }
    var a = "function" == typeof symbol_default.a && "symbol" == typeof_default()(iterator_default.a) ? function (e) {
        return typeof e === "undefined" ? "undefined" : typeof_default()(e);
    } : function (e) {
        return e && "function" == typeof symbol_default.a && e.constructor === symbol_default.a && e !== symbol_default.a.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : typeof_default()(e);
    },
        o = function o(e) {
        return function (t) {
            return {}.toString.call(t) == "[object " + e + "]";
        };
    },
        r = o("Object"),
        s = o("Function"),
        d = function d(e, t) {
        if (t && "object" == (void 0 === t ? "undefined" : a(t))) for (var i in t) {
            e[i] = t[i];
        }
    };
    d(i.prototype, {
        addEventListener: function addEventListener(e, t, i) {
            if (e && t) {
                this.__events[e] = this.__events[e] || [];
                for (var n, a, o = this.__events[e], r = o.length - 1; r >= 0; r--) {
                    if (n = o[r], n.h == t) {
                        a = !0;
                        break;
                    }
                }a || o.push({
                    h: t,
                    one: i
                });
            }
        },
        removeEventListener: function removeEventListener(e, t) {
            if (!e && !t) return void (this.__events = {});
            if (!t) return void delete this.__events[e];
            for (var i, n = this.__events[e] || [], a = 0; a < n.length;) {
                i = n[a], t === i.h ? n.splice(a, 1) : a++;
            }
        },
        emit: function emit(e, t) {
            if (e) for (var i, n, a = this.__events[e] || [], o = 0; o < a.length;) {
                i = a[o], n = i.h, s(n) ? n.call(null, t, e) : r(n) && s(n.handleEvent) && n.handleEvent.call(n, e, t), i.one ? a.splice(o, 1) : o++;
            }
        },
        one: function one(e, t) {
            this.addEventListener(e, t, !0);
        }
    }), i.prototype.on = i.prototype.addEventListener, i.prototype.off = i.prototype.removeEventListener, e.exports = {
        EventEmitter: i,
        addEventEmitter: n
    };
}, function (e, t) {
    "use strict";

    var i = function i() {
        this.logoutTimes = 0, this.loginTimes = 0;
    };
    i.prototype = {
        getAppid: function getAppid() {
            return this.getInfo().appid || "";
        },
        getPassport: function getPassport() {
            return this.getInfo().userid || "";
        },
        getUid: function getUid() {
            return this.getInfo().uid || "";
        },
        getUUID: function getUUID() {
            return this.getInfo().uuid || "";
        },
        getQname: function getQname() {
            return this.getInfo().uniqname || "";
        }
    }, i.prototype.b64_423 = function (e) {
        for (var t = new Array("A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "-", "_"), i = "", n = 0; n < e.length; n++) {
            for (var a = 0; a < 64; a++) {
                if (e.charAt(n) == t[a]) {
                    var o = a.toString(2);
                    i += ("000000" + o).substr(o.length);
                    break;
                }
            }if (64 == a) return 2 == n ? i.substr(0, 8) : i.substr(0, 16);
        }
        return i;
    }, i.prototype.b2i = function (e) {
        for (var t = 0, i = 128, n = 0; n < 8; n++, i /= 2) {
            "1" == e.charAt(n) && (t += i);
        }return String.fromCharCode(t);
    }, i.prototype.b64_decodex = function (e) {
        var t,
            i = [],
            n = "";
        for (t = 0; t < e.length; t += 4) {
            n += this.b64_423(e.substr(t, 4));
        }for (t = 0; t < n.length; t += 8) {
            i += this.b2i(n.substr(t, 8));
        }return i;
    }, i.prototype.utf8to16 = function (e) {
        var t, i, n, a, o, r, s, d, l;
        for (t = [], a = e.length, i = n = 0; i < a;) {
            switch ((o = e.charCodeAt(i++)) >> 4) {
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                    t[n++] = e.charAt(i - 1);
                    break;
                case 12:
                case 13:
                    r = e.charCodeAt(i++), t[n++] = String.fromCharCode((31 & o) << 6 | 63 & r);
                    break;
                case 14:
                    r = e.charCodeAt(i++), s = e.charCodeAt(i++), t[n++] = String.fromCharCode((15 & o) << 12 | (63 & r) << 6 | 63 & s);
                    break;
                case 15:
                    switch (15 & o) {
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                            r = e.charCodeAt(i++), s = e.charCodeAt(i++), d = e.charCodeAt(i++), l = (7 & o) << 18 | (63 & r) << 12 | (63 & s) << 6 | (63 & d) - 65536, t[n] = 0 <= l && l <= 1048575 ? String.fromCharCode(l >>> 10 & 1023 | 55296, 1023 & l | 56320) : "?";
                            break;
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                            i += 4, t[n] = "?";
                            break;
                        case 12:
                        case 13:
                            i += 5, t[n] = "?";
                    }
            }
            n++;
        }
        return t.join("");
    }, i.prototype.selectInfo = function () {
        var e,
            t,
            i,
            n = ["ppinf", "ppinfo", "passport"];
        for (e = 0, t = n.length; e < t; e++) {
            if ((i = new RegExp("\\b" + n[e] + "\\b=(.*?)(?:$|;)").exec(document.cookie)) && i.length) {
                i = i[1];
                break;
            }
        }return i;
    }, i.prototype.decodeInfo = function (e) {
        var t;
        try {
            return e = unescape(e).split("|"), "1" != e[0] && "2" != e[0] || (t = this.utf8to16(this.b64_decodex(e[3]))), t;
        } catch (i) {}
    }, i.prototype.analyzeInfo = function (e) {
        e = e || "";
        var t,
            i,
            n,
            a = {};
        try {
            for (e = e.split("|"), t = 0, i = e.length; t < i; t++) {
                n = e[t].split(":"), n.length > 1 && (a[n[0]] = n[2]);
            }
        } catch (o) {}
        return a;
    }, i.prototype.getInfo = function () {
        return this.analyzeInfo(this.decodeInfo(this.selectInfo()));
    }, e.exports = new i();
}, function (e, t, i) {
    "use strict";

    function n() {
        var e = l.getSrc();
        return e.length > 4 && (e = e.substr(0, 4)), e = parseInt(e, 10), isNaN(e) ? "0" : e;
    }
    var a = i(1).browser,
        o = i(1).os,
        r = i(5),
        s = i(6),
        d = i(11),
        l = i(13),
        c = i(10),
        h = i(2),
        u = i(4),
        p = navigator.userAgent,
        m = i(8),
        f = {
        URLProtocol: "sohuvideo" + (o.ipad ? "hd" : "") + "://",
        openTime: o.ios ? 800 : 1e3,
        appChanneled: 1000120001,
        maxEffectiveTime: 72e5,
        URLGlobalParams: {},
        outset: u.checkOutset(),
        gotoDownload: function gotoDownload(e) {
            if (a.sohuVideoApp) return !1;
            var t = this;
            l.getDownloadUrl(e).then(function (i) {
                if (i) {
                    var n = e && e.delayTime ? e.delayTime : t.openTime;
                    setTimeout(function () {
                        window.location.href = i;
                    }, n);
                }
            });
        },
        openIos: function openIos(e) {
            var t = this;
            if (e) return new m(function (i, n) {
                c.log("\u53D1\u9001\u884C\u4E3A\u7EDF\u8BA1\u70B9: app2_ios_action"), d.pingback("app2_ios_action");
                var r,
                    s,
                    l = function l(e) {
                    window.removeEventListener("pagehide", h, !0), window.removeEventListener("pageshow", h, !0), i(e);
                },
                    h = function h() {
                    clearTimeout(r), l(!1);
                };
                if (window.addEventListener("pagehide", h, !0), window.addEventListener("pageshow", h, !0), o.version && parseFloat(o.version) >= 9 && !t.isUniversalBlackList() && !a.sohuVideoApp) {
                    if (i(!1), s = a.weixin ? "//s1.h5.itc.cn/app/phone.html?action=" : "//s1.h5.itc.cn/app/phone.html?download=1&action=", 3 == t.outset) try {
                        window.parent.location.href = s + e;
                    } catch (p) {
                        location.href = s + e;
                    } else location.href = s + e;
                } else location.href = e;
                var u = +new Date();
                r = setTimeout(function () {
                    var e = +new Date();
                    l(!(e - u > 1300));
                }, 1200);
            });
        },
        openAndroid: function openAndroid(e, t) {
            if (e) {
                -1 === e.indexOf("svawebsocket") && (c.log("\u53D1\u9001\u884C\u4E3A\u7EDF\u8BA1\u70B9: app1_android_action"), d.pingback("app1_android_action"));
                var i = r.getQueryData(location.search.substring(1)),
                    n = !1,
                    a = !1;
                return t && ("click" === t && (n = !0), "try" === t && (a = !0)), new m(function (t, o) {
                    if (i.startClient && "1" === i.startClient && i.clientType || !a && (i.startClient && "2" !== i.startClient || n) && f.isIntentList() && !/UCBrowser/i.test(p) && -1 === e.indexOf("svawebsocket")) window.location.href = e, setTimeout(function () {
                        t(!0);
                    }, 500);else {
                        var r = document.createElement("iframe");
                        r.style.display = "none", r.src = e;
                        var s = document.body;
                        s.appendChild(r), setTimeout(function () {
                            s.removeChild(r), r.onload = null, r = null, t(!0);
                        }, 200);
                    }
                });
            }
        },
        isIntentList: function isIntentList() {
            var e = !1;
            return o.android && /(SAMSUNG[\s\-_]+)?SM[\s\-_]+(N90|G90|T|P6)+|Nexus/i.test(p) && (e = !0), e;
        },
        isUniversalBlackList: function isUniversalBlackList() {
            var e = !1;
            return (/MQQBrowser/gim.test(p) && (e = !0), e
            );
        },
        isForceIntent: function isForceIntent() {
            var e = !1;
            return o.android && this.isIntentList() && !/UCBrowser/i.test(p) && !/QQBrowser/i.test(p) && (e = !0), e;
        },
        getAppChanneled: function getAppChanneled() {
            var e = window.__videoData || {},
                t = r.getQueryString("channeled") || e.channeled || f.appChanneled,
                i = window.location.href || "http://m.tv.sohu.com/";
            try {
                (i.indexOf("hots") > -1 || i.indexOf("/x") > -1) && (t = e.channeled || r.getQueryString("channeled") || f.appChanneled);
            } catch (n) {
                t = f.appChanneled, c.log(n);
            }
            return t;
        },
        makeActionParam: function makeActionParam(e) {
            var t = this,
                i = window.__videoData || {},
                n = {};
            if (n.action = e.action, -1 !== ["71", "72", "73", "74", "75", "76"].indexOf(e.cid) && (e.cid = "28", e.cateCode = "9009"), "1.1" === n.action && (n.sid = e.sid, n.cid = e.cid, n.cateCode = e.cateCode, n.enterid = e.enterid, n.site = e.site, n.dataType = e.dataType || "", e.vid && "" !== e.vid && (n.vid = e.vid), e.ex1 && "1" !== e.ex1 && "" !== e.ex1 && (n.ex1 = e.ex1), e.ex2 && "" !== e.ex2 && (n.ex2 = e.ex2), e.ex3 && "" !== e.ex3 && (n.ex3 = e.ex3), e.appname && "" !== e.appname && "none" !== e.appname ? n.appname = e.appname : n.backpage = "0", e.more && !o.ios && (n.more = e.more), o.wp && (n.site = e.site)), "1.2" !== n.action && "2.4" !== n.action || (o.ios ? (n.action = "2.4", n.ex1 = e.ex1, window.location.href.indexOf("/hots") > -1 ? (n.cid = e.cid, n.ex2 = e.ex2) : (n.cid = e.cateCode, n.ex2 = e.cid)) : (n.action = "1.2", n.cid = e.cid, n.cateCode = e.cateCode)), "1.17" === n.action && (n.ex1 = e.ex1, "1" === e.ex1 ? (n.vid = e.vid, n.cid = e.cid) : "3" === e.ex1 && (n.ex2 = e.ex2, n.ex3 = e.ex3)), "1.18" === n.action && (n.urls = e.urls, "" !== e.share && (n.share = e.share), "" !== e.ex1 && (n.ex1 = e.ex1), "" !== e.ex2 && (n.ex2 = e.ex2), "" !== e.ex3 && (n.ex3 = e.ex3), "" !== e.bit0 && (n.bit0 = e.bit0), "" !== e.bit1 && (n.bit1 = e.bit1)), "1.21" === n.action && (n.more = e.more, n.type = e.type), "2.6" === e.action) {
                var a = e.more.sourcedata,
                    r = a.callbackAction || "";
                if (!a.callbackAction || "" === a.callbackAction) {
                    var s = {};
                    s.action = "1.18", s.urls = e.urls || window.location.href, s.channeled = e.channeled, s.share = e.share || "0", s.more = {
                        description: "",
                        getad: 0,
                        sourcedata: {
                            enterid: e.enterid || "4",
                            params: "uid&passport&token&plat&clientVer&clientType&gid",
                            preid: window.location.href
                        }
                    }, r = t.makeActionUrl(s), a.callbackAction = r;
                }
                a.loginFrom = a.loginFrom || 17, a.callbackAction = r, a.closeWebView = "undefined" != typeof a.closeWebView ? a.closeWebView : 1;
            }
            return n.more = {
                sourcedata: {
                    enterid: e.enterid || "4",
                    channeled: e.channeled,
                    preid: window.location.href
                }
            }, i.vWidth && i.vHeight && (n.more.videoSize = {
                vWidth: parseInt(i.vWidth),
                vHeight: parseInt(i.vHeight)
            }), h.extend(n.more, e.more), n.more = stringify_default()(n.more), n;
        },
        formatArgs: function formatArgs(e) {
            var t = e.cateCode || "",
                i = e.channeled || this.getAppChanneled();
            t = t.toString().split(",")[0] || "", t = t.split(";")[0] || "";
            var a = {
                action: e.action || "1.1",
                vid: e.vid || "",
                sid: e.sid || "",
                cid: e.cid || "",
                cateCode: t,
                dataType: e.dataType || "",
                share: e.share || "",
                urls: e.urls || "",
                ex1: e.ex1 || "1",
                ex2: e.ex2 || "",
                ex3: e.ex3 || "",
                site: e.site || "",
                enterid: "4_" + i + "_" + n(),
                bit0: e.bit0 || "",
                bit1: e.bit1 || "",
                type: e.type || 6,
                appname: "none",
                channeled: i,
                more: e.more || {}
            };
            return "1.1" === e.action && (9001 !== e.cid && "2" !== e.site || (a.ex3 = 2, a.site = "2", a.cid = 9001)), a;
        },
        makeActionUrl: function makeActionUrl(e) {
            var t = this.formatArgs(e),
                i = this.makeActionParam(t),
                n = "",
                o = this.URLGlobalParams,
                d = "";
            return d = o.clientType && "1" === o.startClient || !s.isEnable() ? "sohuvideo" : "1" !== o.startClient && !this.isForceIntent() || a.sohuVideoApp ? "sohuvideo" : "intent", d.indexOf("intent") > -1 ? (n = "intent://", n += "?" + r.stringify(i).replace(/index\.html%2C/, "index.html"), n += "#Intent;scheme=sohuvideo;package=com.sohu.sohuvideo;end", c.log("android intent 1:", stringify_default()(i))) : (n = f.URLProtocol, n += "action.cmd", n += "?" + r.stringify(i).replace(/index\.html%2C/, "index.html"), c.log("sohovideo:", stringify_default()(i))), c.log("makeActionUrl : " + n), n;
        },
        getIframe: function getIframe() {
            var e = document.querySelector("#j_redirectNativeFrame");
            return e || (e = document.createElement("iframe"), e.id = "j_redirectNativeFrame", e.style.display = "none", document.body.appendChild(e)), e;
        },
        sendAction: function sendAction(e) {
            var t = n();
            "" !== t && "0" !== t && (c.log("\u53D1\u9001\u884C\u4E3A\u7EDF\u8BA1\u70B9: app_channel_action"), d.pingback("app_channel_action"));
            var i = this.makeActionUrl(e),
                a = r.getQueryData(location.search.substring(1));
            return "1" === a.startClient && (c.log("\u53D1\u9001\u884C\u4E3A\u7EDF\u8BA1\u70B9: appdownload_jump1"), d.pingback("appdownload_jump1")), "2" === a.startClient && (c.log("\u53D1\u9001\u884C\u4E3A\u7EDF\u8BA1\u70B9: appdownload_jump2"), d.pingback("appdownload_jump2")), e.isHike && (c.log("\u53D1\u9001\u884C\u4E3A\u7EDF\u8BA1\u70B9: appdownload_jump0"), d.pingback("appdownload_jump0")), o.android ? "undefined" != typeof e.type ? this.openAndroid(i, e.type) : this.openAndroid(i) : o.ios ? this.openIos(i) : (c.log("\u53D1\u9001\u884C\u4E3A\u7EDF\u8BA1\u70B9: app3_others_action"), d.pingback("app3_others_action"), void (this.getIframe().src = i));
        },
        parserUrls: function parserUrls() {
            for (var e, t = ["clientType", "clientVer", "actionVer", "startClient", "actionId", "player", "vid", "vids", "site", "srcUrl", "poster", "title"], i = t.length, n = r.getQueryData(location.search.substring(1)), a = {}; i--;) {
                e = t[i], n.hasOwnProperty(e) && n[e] && (a[e] = n[e]);
            }f.URLGlobalParams = a;
        },
        parserAttributes: function parserAttributes(e, t) {
            for (var i = ["vid", "cid", "sid", "plid", "cateCode", "site", "dataType"], n = i.length, a = f.URLGlobalParams, o = e || window.__videoData || {}, r = {}; n--;) {
                var s = i[n];
                o && o[s] && (r[s] = o[s]), a && a.hasOwnProperty(s) && a[s] && (r[s] = a[s]);
            }
            "undefined" != typeof r.site && (r.site = r.site + "");
            var d = a.channeled || this.getAppChanneled();
            d = d.toString().replace("|", "").replace("%7C", "");
            var l = (r.vid, f.URLProtocol),
                h = r.downUrl || "";
            r.actionId || r.actionVer;
            return o.site && "2" === o.site ? (r.action = "1.1", r.ex3 = "2") : o.liveId ? (r.action = "1.17", r.ex1 = "3", r.ex2 = o.liveId, r.ex3 = o.urls.length ? o.urls[0].url : "", r.more = {
                type: 2
            }) : (r.action = "1.1", r.ex1 = "1"), r = this.formatArgs(r), r.scheme = l, r.downUrl = h, c.log("parserAttributes:", stringify_default()(r)), r;
        },
        init: function init() {
            this.parserUrls();
        }
    };
    f.init(), window.Action = f, e.exports = f;
}, function (e, t) {
    "use strict";

    e.exports = {};
}, function (e, t, i) {
    "use strict";

    var n = i(1).browser,
        a = i(1).os,
        o = i(1).device,
        r = i(5),
        s = i(25),
        d = (navigator.userAgent, {
        m3u8: function m3u8() {
            if (s.isInBlackList("m3u8")) return !1;
            if (o.samsung && n.chrome || o.htc) return !1;
            if (a.ios || "m3u8" === r.getQueryString("srcType")) return !0;
            var e = document.getElementsByTagName("video")[0] || document.createElement("video");
            if ("function" == typeof e.canPlayType) {
                var t = e.canPlayType("application/vnd.apple.mpegURL"),
                    i = e.canPlayType("application/x-mpegURL"),
                    d = /probably|maybe/;
                return d.test(t) || d.test(i);
            }
            return !1;
        },
        mp4: function mp4() {
            if (s.isInBlackList("mp4")) return !1;
            if (a.wp || "mp4" === r.getQueryString("srcType")) return !0;
            var e = document.getElementsByTagName("video")[0] || document.createElement("video");
            return "function" != typeof e.canPlayType || "" !== e.canPlayType('video/mp4; codecs="mp4v.20.8"') && "" !== e.canPlayType('video/mp4; codecs="avc1.42E01E"') && "" !== e.canPlayType('video/mp4; codecs="avc1.42E01E, mp4a.40.2"');
        },
        autoplay: function () {
            var e,
                t,
                i,
                r,
                s = !0,
                d = navigator.userAgent,
                l = [/MI[\s\-_]+/i, /SM\-N90/i, /HUAWEI/i, /Coolpad/i, /E7/i, /GT\-I95/i, /GT\-N71/i, /M032.*JRO03H/i, /Android\/?\s?4\.0/i];
            if (n.wx) {
                for (e = l, t = 0, i = e.length; t < i; t++) {
                    if (r = e[t], r.test(d)) {
                        s = !1;
                        break;
                    }
                }(a.ipad || a.androidpad) && (s = !1);
            } else (a.ios && !n.qq && !n.uc || a.wp || a.android && (n.baiduboxapp || n.qq) || o.mi && 2 == o.version) && (s = !1), a.androidpad && (s = !1);
            return function () {
                return s;
            };
        }(),
        pjax: function () {
            return !(!window.history || !history.pushState);
        }(),
        adv: function adv() {
            var e = !0;
            return a.android && 0 == (a.version || "").indexOf("2.3") && (e = !1), e;
        }
    });
    e.exports = d;
}, function (e, t, i) {
    "use strict";

    var n = i(9);
    e.exports = {
        SVP_URL: "//m.tv.sohu.com/",
        API_KEY: n.API_KEY,
        API_URL: "/api/",
        API_PARAMS: {
            api_key: n.API_KEY,
            plat: "17",
            sver: "1.0",
            partner: "1"
        }
    };
},,, function (e, t, i) {
    "use strict";

    function n(e) {
        var t = "count" + +new Date(),
            i = "//count.vrs.sohu.com/count/query.action?type=2&videoId=" + e + "&jsonp=" + t;
        return new o(function (e, n) {
            r({
                url: i,
                dataType: "jsonp"
            }).then(function () {
                try {
                    e(window[t].videos[0].count);
                } catch (i) {
                    n(i);
                }
            }, n);
        });
    }
    function a(e) {
        var t = "//vstat.v.blog.sohu.com/dostat.do?callback=?&method=getVideoPlayCount&v=" + e;
        return new o(function (e, i) {
            r.getJSON(t).then(function (t) {
                try {
                    e(t.data[0].count);
                } catch (n) {
                    i(n);
                }
            }, i);
        });
    }
    var o = i(8),
        r = i(3);
    i(10), i(2);
    e.exports = function (e) {
        var t = e.vid;
        return 1 == e.site ? n(t) : a(t);
    };
}, function (e, t, i) {
    "use strict";

    var n = i(9),
        a = i(2),
        o = {
        1: "\u4E0B\u8F7D\u4E2D\u65AD\uFF0C\u8BF7\u5237\u65B0\u9875\u9762\u91CD\u8BD5",
        2: "\u4E0B\u8F7D\u9519\u8BEF\uFF0C\u8BF7\u5237\u65B0\u9875\u9762\u91CD\u8BD5",
        3: "\u89E3\u7801\u9519\u8BEF\uFF0C\u8BF7\u4F7F\u7528\u641C\u72D0\u89C6\u9891APP\u89C2\u770B\u6B64\u89C6\u9891",
        4: "\u7CFB\u7EDF\u4E0D\u652F\u6301\u6B64\u683C\u5F0F\u7684\u89C6\u9891\uFF0C\u8BF7\u4F7F\u7528\u641C\u72D0\u89C6\u9891APP\u89C2\u770B",
        100: "\u60A8\u6240\u5728\u7684\u56FD\u5BB6\u6216\u5730\u533A\uFF0C\u6CA1\u6709\u6B64\u89C6\u9891\u7684\u64AD\u653E\u7248\u6743\uFF0C\u53BB\u770B\u770B\u5176\u4ED6\u89C6\u9891\u5427",
        101: "\u8BE5\u89C6\u9891\u7248\u6743\u5DF2\u5230\u671F\uFF0C\u53BB\u770B\u770B\u5176\u4ED6\u89C6\u9891\u5427",
        102: "\u672C\u96C6\u4E3A\u4ED8\u8D39\u89C6\u9891\uFF0C\u8BF7\u4F7F\u7528\u641C\u72D0\u89C6\u9891APP\u89C2\u770B",
        103: "\u672C\u96C6\u4E3AAPP\u4E13\u4EAB\u89C6\u9891\uFF0C\u8BF7\u4F7F\u7528\u641C\u72D0\u89C6\u9891APP\u89C2\u770B",
        200: "\u6570\u636E\u5904\u7406\u5B8C\u6210",
        201: "\u65E0\u6548\u89C6\u9891\u6570\u636E,\u8BF7\u5237\u65B0\u91CD\u8BD5",
        202: "\u65E0\u6548\u89C6\u9891\u6570\u636E",
        203: "\u6570\u636E\u7ED3\u6784\u9519\u8BEF",
        204: "\u89E3\u6790\u6570\u636E\u51FA\u9519",
        300: "\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u64AD\u653E\u529F\u80FD\uFF0C\u8BF7\u4F7F\u7528\u641C\u72D0\u89C6\u9891\u5BA2\u6237\u7AEF",
        301: "\u8BE5\u89C6\u9891\u76EE\u524D\u53EA\u652F\u63015\u5206\u949F\u89C2\u770B\uFF0C\u89C2\u770B\u5B8C\u6574\u89C6\u9891\uFF0C\u8BF7\u4F7F\u7528\u641C\u72D0\u89C6\u9891\u5BA2\u6237\u7AEF",
        302: "UC\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u64AD\u653E\u529F\u80FD\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u7CFB\u7EDF\u6D4F\u89C8\u5668\u6216\u8BF7\u4F7F\u7528\u641C\u72D0\u89C6\u9891\u5BA2\u6237\u7AEF",
        303: "\u76F4\u64AD\u8BF7\u4F7F\u7528\u641C\u72D0\u89C6\u9891\u5BA2\u6237\u7AEF",
        304: "\u672C\u7247\u4EC5\u4F9B\u8BD5\u770B\uFF0C\u5982\u679C\u9700\u8981\u89C2\u770B\u66F4\u591A\u5185\u5BB9\uFF0C\u8BF7\u4E0B\u8F7D\u641C\u72D0\u89C6\u9891App",
        305: "\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u76F4\u64AD\u529F\u80FD\uFF0C\u8BF7\u4F7F\u7528\u641C\u72D0\u89C6\u9891\u5BA2\u6237\u7AEF",
        306: "\u64AD\u653E\u5730\u5740\u65E0\u6548\uFF0C\u5982\u679C\u9700\u8981\u89C2\u770B\u66F4\u591A\u5185\u5BB9\uFF0C\u8BF7\u4E0B\u8F7D\u641C\u72D0\u89C6\u9891App",
        400: "\u7F51\u7EDC\u8D85\u65F6\uFF0C\u8BF7\u786E\u4FDD\u7F51\u7EDC\u7A33\u5B9A\u540E\u5237\u65B0\u91CD\u8BD5",
        401: "\u89C6\u9891\u6B63\u5728\u4E0A\u4F20\u6216\u89C6\u9891\u65E0\u6548\uFF0C\u5148\u770B\u770B\u5176\u4ED6\u89C6\u9891\u5427",
        402: "\u6CA1\u6709\u89C6\u9891ID\uFF0C\u53BB\u770B\u770B\u5176\u4ED6\u89C6\u9891\u5427",
        403: "\u65E0\u6CD5\u83B7\u53D6\u89C6\u9891\u4FE1\u606F\uFF0C\u53BB\u770B\u770B\u5176\u4ED6\u89C6\u9891\u5427",
        404: "\u6E20\u9053\u63A5\u53E3\u8BF7\u6C42\u9519\u8BEF\uFF0C\u8BF7\u5237\u65B0\u91CD\u8BD5",
        405: "\u6E20\u9053\u63A5\u53E3\u53C2\u6570\u9519\u8BEF\uFF0C\u8BF7\u5237\u65B0\u91CD\u8BD5",
        406: "\u6E20\u9053\u63A5\u53E3\u8D85\u65F6\uFF0C\u8BF7\u5237\u65B0\u91CD\u8BD5",
        407: "\u7248\u6743\u63A5\u53E3\u8BF7\u6C42\u9519\u8BEF\uFF0C\u53BB\u770B\u770B\u5176\u4ED6\u89C6\u9891\u5427",
        408: "56\u89C6\u9891\u4FE1\u606F\u8BF7\u6C42\u9519\u8BEF\uFF0C\u53BB\u770B\u770B\u5176\u4ED6\u89C6\u9891\u5427",
        500: "\u8D44\u6E90\u52A0\u8F7D\u5931\u8D25\uFF0C\u53BB\u770B\u770B\u5176\u4ED6\u89C6\u9891\u5427"
    };
    n.is56 && a.extend(o, {
        3: "\u89E3\u7801\u9519\u8BEF\uFF0C\u8BF7\u4F7F\u7528\u641C56\u89C6\u9891APP\u89C2\u770B\u6B64\u89C6\u9891",
        4: "\u7CFB\u7EDF\u4E0D\u652F\u6301\u6B64\u683C\u5F0F\u7684\u89C6\u9891\uFF0C\u8BF7\u4F7F\u752856\u89C6\u9891APP\u89C2\u770B",
        102: "\u672C\u96C6\u4E3A\u4ED8\u8D39\u89C6\u9891\uFF0C\u8BF7\u4F7F\u752856\u89C6\u9891APP\u89C2\u770B"
    }), e.exports = o;
}, function (e, t, i) {
    "use strict";

    var n = i(2),
        a = (i(25), {});
    a.RESOLUTION_MODE = {
        nor: "\u6D41\u7545",
        hig: "\u9AD8\u6E05",
        sup: "\u8D85\u6E05",
        ori: "\u539F\u753B",
        app: "\u8D85\u6E05app"
    };
    var o = {
        autoplay: !0,
        playType: "vod",
        resolutionType: "nor",
        resolutionTypeList: ["nor", "hig", "sup", "ori", "app"],
        posterType: "horizon",
        timeLimit: 0,
        adClose: "0",
        appid: "tv",
        channeled: "",
        fullscreenType: 0,
        showCount: !0
    };
    a.initConfig = function (e) {
        return n.extend({}, e, o);
    }, e.exports = a;
}, function (e, t, i) {
    "use strict";

    var n = (i(2), i(5)),
        a = i(1).browser,
        o = i(1).os,
        r = i(1).device,
        s = navigator.userAgent,
        d = {};
    d.FORCE_USE_DOWNLOADURL_LIST = [/M032.*JRO03H/i], d.FORCE_USE_M3U8_LIST = [], d.SERVICE_BLACK_LIST = {
        ios: [],
        android: [],
        winPhone: []
    }, d.M3U8_BLACK_LIST = {
        ios: [],
        android: [/HM\sNOTE/i, /Build\/HM.*XiaoMi\/MiuiBrowser/i, /vivo/i, /ZTE/i, /TCL/i, /Coolpad/i, /M032.*JRO03H/i, /MQQBrowser(\/4\.|\s4\.)+/i],
        winPhone: []
    }, d.MP4_BLACK_LIST = {
        ios: [],
        android: [],
        winPhone: []
    }, d.VIDEO_DOWNLOAD_SRC_LIST = ["1000", "1102"], d.VIDEO_M3U8_SRC_LIST = ["1080", "1128"];
    var l = function l(e, t) {
        for (var i, n = !1, o = t[e] || [], r = 0, d = o.length; r < d; r++) {
            if (i = o[r], i.test(s)) {
                n = !a.qq || -1 !== i.toString().indexOf("QQBrowser");
                break;
            }
        }return n;
    },
        c = function c() {
        var e = n.getQueryString("src") || n.getQueryString("SRC") || "";
        return "" !== e && e.length >= 4 && (e = e.substr(0, 4)), e;
    };
    d.isInBlackList = function (e) {
        var t = "",
            i = !1;
        return o.ios ? t = "ios" : o.android ? t = "android" : o.wp && (t = "winPhone"), "m3u8" === e && (l(t, d.SERVICE_BLACK_LIST) || l(t, d.M3U8_BLACK_LIST)) ? i = !0 : "mp4" === e && (l(t, d.SERVICE_BLACK_LIST) || l(t, d.MP4_BLACK_LIST)) && (i = !0), i;
    }, d.isForceUseM3u8 = function () {
        var e = !1,
            t = c();
        if (this.VIDEO_M3U8_SRC_LIST.indexOf(t) >= 0 && (e = !0), !e) for (var i, n = d.FORCE_USE_M3U8_LIST, a = 0, o = n.length; a < o; a++) {
            if (i = n[a], i.test(s)) {
                e = !0;
                break;
            }
        }return e;
    }, d.isForceUseDownloadUrl = function () {
        var e = !1,
            t = c();
        if (this.VIDEO_DOWNLOAD_SRC_LIST.indexOf(t) >= 0 && (e = !0), !e) {
            for (var i, n = d.FORCE_USE_DOWNLOADURL_LIST, l = 0, h = n.length; l < h; l++) {
                if (i = n[l], i.test(s)) {
                    e = !0;
                    break;
                }
            }(r.coolpad && a.uc || o.android && 0 == (o.version || "").indexOf("2.3")) && (e = !0);
        }
        return e;
    }, e.exports = d;
}, function (e, t, i) {
    "use strict";

    function n() {}
    var a = i(2),
        o = "".trim ? function (e) {
        return e.trim();
    } : function (e) {
        return (e || "").replace(/(^\s*)|(\s*$)/g, "");
    };
    a.extend(n.prototype, {
        trim: o,
        dateFormat: function dateFormat(e, t) {
            "[object Date]" != {}.toString.call(e) && (e = new Date(parseInt(e)));
            var i = {
                "y+": e.getFullYear(),
                "M+": e.getMonth() + 1,
                "d+": e.getDate(),
                "h+": e.getHours(),
                "m+": e.getMinutes(),
                "s+": e.getSeconds()
            };
            for (var n in i) {
                new RegExp("(" + n + ")").test(t) && (t = t.replace(RegExp.$1, ("00" + i[n]).substr(1 + ~RegExp.$1.length)));
            }return t;
        },
        timeFormat: function timeFormat(e, t) {
            e /= 1;
            var i = {
                "m+": Math.floor(e / 60),
                "s+": e % 60
            };
            t = t.replace(/(m+)/, function (e, t) {
                var n = t,
                    a = ("" + i["m+"]).length;
                return t && a > t.length && (n = new Array(a + 1).join("m")), n;
            });
            for (var n in i) {
                new RegExp("(" + n + ")").test(t) && (t = t.replace(RegExp.$1, ("00" + i[n]).slice(1 + ~RegExp.$1.length)));
            }return t;
        },
        truncate: function truncate(e, t, i, n) {
            return e = e || "", e.length <= t ? e : (e = e.substr(0, t), i && (e += n || "..."), e);
        },
        truncateCN: function truncateCN(e, t, i, n) {
            e = e || "";
            var a = /[^\x00-\xff]/g;
            if (i = i || !1, n = n || "...", t > 0 && e.replace(a, "mm").length > t) for (var o = Math.floor(t / 2), r = o; r < e.length; r++) {
                if (e.substr(0, r).replace(a, "mm").length >= t) return e.substr(0, r) + (i ? n : "");
            }return e;
        },
        numberGroup: function numberGroup(e, t, i) {
            if (e = e || "1234567345345.000", t = t || 3, i = i || ",", e = "" + e, !/^(\+|-)?(\d+)(\.\d+)?$/.test(e)) return e;
            for (var n = RegExp.$1, a = RegExp.$2, o = RegExp.$3, r = new RegExp("(\\d+)(\\d{" + t + "})(" + i + "|$)"); r.test(a);) {
                a = a.replace(r, "$1" + i + "$2$3");
            }return n + a + o;
        },
        escapeXSS: function escapeXSS(e) {
            return (e || "").replace(/</g, "&lt;").replace(/>/g, "&gt;");
        },
        removeProtocol: function removeProtocol() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            return e && (e = document.location.protocol + e.replace(/^https?:/, "")), e;
        }
    }), e.exports = n;
},, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(1).os,
        a = navigator.userAgent,
        o = (a.toLowerCase(), function () {
        var e = !1;
        return (/MQQBrowser/gim.test(a) && (e = !0), e
        );
    });
    t["default"] = {
        open: function open() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.__videoData || window.videoData,
                t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "play",
                i = this.makeAction(e, t);
            n.ios && parseFloat(n.version) >= 9 && !o() ? (location.href = "http://www.56.com/help/download/index.html?action=" + i, setTimeout(function () {
                location.reload();
            }, 1e3)) : this.openByAction(e, t);
        },
        openByAction: function openByAction() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "play",
                i = this.makeAction(e, t);
            if (n.ios) location.href = i;else {
                var a = document.createElement("iframe");
                a.style.display = "none", a.src = i;
                var o = document.body;
                o.appendChild(a), setTimeout(function () {
                    o.removeChild(a), a.onload = null, a = null;
                }, 200);
            }
            setTimeout(function () {
                location.href = "http://a.app.qq.com/o/simple.jsp?pkgname=com.Android56&ckey=CK1356521354532";
            }, 1e3);
        },
        makeAction: function makeAction() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "play",
                i = "";
            return "play" == t && (i = "fivesixapp://action.cmd?action=1.1&enterid=4", e.vid && (i += "&vid=" + e.vid), e.plid && (i += "&aid=" + e.plid), "undefined" != typeof e.site && (i += "&site=" + e.site)), i;
        }
    };
}, function (e, t, i) {
    "use strict";

    var n = i(45),
        a = i(44),
        o = i(30),
        r = i(37),
        s = i(13),
        d = i(10),
        l = (i(6), i(8)),
        c = {
        loadData: function loadData(e) {
            var t = a(e).then(function () {
                return new l(function (t, i) {
                    e.liveId ? n.loadData({
                        liveId: e.liveId,
                        appid: e.appid
                    }).then(t) : e.vid ? o.loadData({
                        vid: e.vid,
                        site: e.site,
                        appid: e.appid
                    }).then(t) : t({
                        code: "402"
                    });
                });
            }),
                i = t.then(function (e) {
                return e = e || {}, r.check(e.data);
            }),
                c = new l(function (e, t) {
                s.loadChannelInfo().then(function (t) {
                    e({
                        code: t.code || "200",
                        data: t
                    });
                });
            });
            return new l(function (e, n) {
                l.all([t, i, c]).then(function (t) {
                    var i = t[0],
                        n = t[1],
                        a = t[2];
                    d.log("\u89C6\u9891\u4FE1\u606F-->", i), d.log("\u7248\u6743\u4FE1\u606F-->", n), d.log("\u6E20\u9053\u4FE1\u606F-->", a);
                    var t = {
                        code: "200",
                        msg: "",
                        data: {
                            mcode: i.mcode || "",
                            videoData: i.data,
                            channelInfo: a.data
                        }
                    };
                    if ("200" !== n.code) return t.code = n.code, e(t);
                    if (i.data) {
                        var o = i.data,
                            r = a.data,
                            s = r.cid2 || "",
                            l = r.limitIds2 || "",
                            c = r.limitPlays,
                            h = o.plid || o.aid || o.sid || "";
                        if (s = s.replace(/\s/g, "").replace(/\uff0c/g, ","), l = l.replace(/\s/g, "").replace(/\uff0c/g, ","), (-1 != s.split(",").indexOf("" + o.cid) || -1 != l.split(",").indexOf("" + h)) && c && c > 0) {
                            var u = o.video_order,
                                p = o.latest_video_count || o.videoCount;
                            c = p - c, c <= 0 ? a.code = "103" : u > c && c <= p && (a.code = "103");
                        }
                    }
                    return "200" !== a.code ? (t.code = a.code, e(t)) : "200" !== i.code ? (t.code = i.code, e(t)) : void e(t);
                });
            });
        }
    };
    e.exports = c;
}, function (e, t, i) {
    "use strict";

    function n(e) {
        e = e || {};
        var t = r.getChanneled(),
            i = e.vid || "",
            n = e.plid || e.aid || e.sid || "",
            a = "//z2.m.tv.sohu.com/pv.gif?";
        h.is56 && (a = "//ce.56.com/pv.gif?"), a = a + "url=" + encodeURIComponent(location.href) + "&refer=" + (m.getParam("landingrefer") || encodeURIComponent(document.referrer || "//m.tv.sohu.com/")) + "&uid=" + u("SUV") + "&webtype=" + r.getConnectionType() + "&screen=" + h.ScreenSize + "&catecode=" + (e.cateCode || e.cate_code || "") + "&plid=" + n + "&vid=" + i + "&os=" + d.type + "&platform=" + d.platform + "&passport=" + l.getPassport() + "&channeled=" + t + "&MTV_SRC=" + encodeURIComponent(v.getSrc());
        try {
            u("SOHUSVP") || y.pingback("play_fail_cookie");
        } catch (o) {}
        return new f(function (e, t) {
            function i() {
                if (!o) {
                    if ((r += 1) > 10) return e(), void y.pingback("play_fail_10cookie");
                    var t = a + "&_=" + new Date().getTime(),
                        s = setTimeout(i, 300);
                    n = new Image(), n.onload = n.onabort = n.onerror = function (t) {
                        clearTimeout(s), o || n.complete && (o = !0, e());
                    }, n.src = t;
                }
            }
            var n,
                o = !1,
                r = 0;
            i();
        });
    }
    function a(e) {
        return s.extend(e, {
            tvid: e.tvid || e.tv_id || "",
            sid: e.sid || e.aid,
            plid: e.plid || e.aid,
            tvname: e.tvname || e.video_name,
            videoName: e.tvname || e.video_name,
            videoCount: e.videoCount || e.total_video_count,
            videoOrder: e.videoOrder || e.video_order,
            totalSet: e.totalSet || e.total_video_count,
            cateCode: e.cateCode || e.cate_code,
            startTime: e.startTime || e.start_time || 0,
            endTime: e.endTime || e.end_time || 0,
            playCount: e.playCount || e.play_count || 0,
            ipLimit: e.ipLimit || e.ip_limit || 0,
            mobileLimit: e.mobileLimit || e.mobile_limit || 0,
            h5Limit: e.h5Limit || e.h5_limit || 0,
            areaId: e.areaId || e.area_id || 6,
            verHighPic: e.verHighPic || e.ver_high_pic || e.video_big_pic || e.ver_big_pic || "",
            horHighPic: e.horHighPic || e.hor_high_pic || e.video_big_pic || e.hor_big_pic || "",
            dataType: e.dataType || e.data_type || 0
        }), e;
    }
    function o(e) {
        for (var t, i, n = [], a = 0, o = {}, r = {}, s = {}, d = {
            1: "hig",
            2: "nor",
            21: "sup",
            31: "original",
            51: "mobile"
        }, l = e.playinfo || [], c = 0, h = l.length; c < h; c++) {
            t = l[c], i = d[t.versionCode], n = n.concat(t.downloadUrl), a = t.totalLength, i && (o[i] = [t.m3u8PlayUrl], r[i] = t.mp4PlayUrl, s[i] = t.lengths);
        }return {
            duration: a,
            durations: s,
            urls: {
                downloadUrl: n,
                m3u8: o,
                mp4: r
            }
        };
    }
    var r = i(4),
        s = i(2),
        d = i(1).os,
        l = i(15),
        c = i(19),
        h = i(9),
        u = i(6),
        p = i(3),
        m = i(5),
        f = i(8),
        v = i(13),
        g = i(16),
        y = (i(10), i(11)),
        w = i(9).REQUEST_MAX_COUNT;
    e.exports = {
        loadData: function loadData(e) {
            var t = {
                code: "200",
                data: null
            },
                i = "//m.tv.sohu.com/phone_playinfo?callback=?";
            return e = s.applyIf(e, c.API_PARAMS), e.uid = h.uid, e.muid = h.muid, e._c = u.isEnable() ? 1 : 0, e.pt = r.getUserPt(), e.qd = "undefined" != typeof g.channelNum && "0" !== g.channelNum ? g.channelNum : "680", e.src = v.getSrc(), e.appid = e.appid || "tv", "undefined" == typeof e.site && (e.site = 1), h.is56 && (e.SOHUSVP = u("SOHUSVP")), new f(function (o, r) {
                function s() {
                    d += 1, p.getJSON(i, e).then(function (r) {
                        r = r.data || {}, r.data && 200 === r.status ? (t.data = a(r.data), t.mcode = r.mCode || "", n(t.data).then(function () {
                            o(t);
                        })) : (e.site = 1 == e.site ? 2 : 1, p.getJSON(i, e).then(function (e) {
                            e = e.data || {}, e.data && 200 === e.status ? (t.data = a(e.data), t.mcode = e.mCode || "", n(t.data).then(function () {
                                o(t);
                            })) : (t.code = "401", o(t));
                        }, function () {
                            t.code = "401", o(t);
                        }));
                    }, function () {
                        d >= w ? (t.code = "403", o(t)) : s();
                    });
                }
                if (!e.vid || !e.uid || !e.muid) return t.code = "402", void o(t);
                var d = 0;
                s();
            });
        },
        loadVideoSrc: function loadVideoSrc(e) {
            e = e || {};
            var t = {
                code: "200",
                data: null
            },
                i = "//api.my.tv.sohu.com/v2/video/play.do?callback=?";
            return e = s.applyIf(e), e.id = window.videoData.vid || "59632328", e.isenc = 0, new f(function (n, a) {
                if (!e.id) return t.code = "402", void n(t);
                !function () {
                    p.getJSON(i, e).then(function (e) {
                        e = e.data || {}, e.playinfo ? (t.data = o(e), n(t)) : (t.code = e.errorCode, n(t));
                    });
                }();
            });
        }
    };
}, function (e, t) {
    "use strict";

    function i(e, t) {
        s ? e.style.filters = "alpha(opacity=" + 100 * t + ")" : e.style.opacity = t;
    }
    function n(e) {
        e = e.toLowerCase().split("-");
        for (var t = e[0], i = 1, n = e.length; i < n; i++) {
            t += e[i].replace(/\b(\w)|\s+(\w)/g, function (e) {
                return e.toUpperCase();
            });
        }return t;
    }
    function a(e, t) {
        t = t.toLowerCase();
        var i = n(t),
            a = null;
        return e.style[i] ? a = e.style[i] : e.currentStyle ? a = e.currentStyle[i] : document.defaultView && document.defaultView.getComputedStyle && (a = document.defaultView.getComputedStyle(e, null)) && (a = a.getPropertyValue(t)), a;
    }
    function o() {
        if (!(arguments.length <= 1)) {
            var e = arguments[0],
                t = arguments[1],
                o = {};
            if ("object" === (void 0 === t ? "undefined" : r(t))) for (var s in t) {
                o[s] = a(e, s), "opacity" == s.toLowerCase() ? i(e, t[s]) : e.style[n(s)] = t[s];
            } else o[arguments[1]] = a(e, arguments[1]), "opacity" == arguments[1].toLowerCase() ? i(e, arguments[2]) : e.style[n(arguments[1])] = arguments[2];
            return o;
        }
    }
    var r = "function" == typeof symbol_default.a && "symbol" == typeof_default()(iterator_default.a) ? function (e) {
        return typeof e === "undefined" ? "undefined" : typeof_default()(e);
    } : function (e) {
        return e && "function" == typeof symbol_default.a && e.constructor === symbol_default.a && e !== symbol_default.a.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : typeof_default()(e);
    },
        s = !!window.ActiveXObject,
        d = {
        hide: function hide(e) {
            e && (e.style.display = "none");
        },
        show: function show(e, t) {
            e && (t = t || "block", e.style.display = t);
        },
        hasClass: function hasClass(e, t) {
            var i = e.classList;
            if (i) return i.contains(t);
            var n = e.className;
            return !(!n || !t) && (n == t || -1 != n.search(new RegExp("\\b" + t + "\\b")));
        },
        addClass: function addClass(e, t) {
            this.hasClass(e, t) || (e.classList ? e.classList.add(t) : (e.className && (t = " " + t), e.className = e.className + t));
        },
        removeClass: function removeClass(e, t) {
            e.classList ? e.classList.remove(t) : e.className && t && (e.className = e.className.replace(new RegExp("\\b" + t + "\\b", "g"), ""));
        },
        css: function css() {
            var e = Array.prototype.slice.call(arguments);
            if (!(e.length <= 1)) return 2 == e.length && "string" == typeof e[1] ? a.apply(null, e) : o.apply(null, e);
        },
        width: function width() {
            var e = Array.prototype.slice.call(arguments);
            if (!(e.length < 1)) {
                var t = e[0];
                if (1 == e.length) {
                    if ("none" != this.css(t, "display")) return t.offsetWidth || parseInt(this.css(t, "width"));
                    var i = this.css(t, {
                        display: "",
                        visibility: "hidden",
                        position: "absolute"
                    }),
                        n = t.clientWidth || parseInt(this.css(t, "width"));
                    return this.css(t, i), n;
                }
                var n = "" + e[1];
                /^\d+$/.test(n) && (n += "px"), css.css(t, "width", n);
            }
        }
    };
    e.exports = d;
},,,, function (e, t, i) {
    "use strict";

    function n(e, t) {
        this.superClass.constructor.call(this), this.selector = e, this.el = document.querySelector(this.selector), this.originalConfig = t, this.config = f.initConfig(t);
        var i = this.config.list;
        this.config.data ? this.videoData = this.config.data || {} : i && i.length && (this.videoData = i[0]), this.playList = new w(this, {
            list: i
        }), delete this.config.data, delete this.config.list, this.statis = new y(this, {
            autoplay: this.config.autoplay
        }), o.ios ? this.adv = new v(this, this.config) : this.adv = new g(this, this.config), this.config.nativeui ? this.ui = new c(this, this.config) : this.videoData.liveId ? (this.videoData.vid = this.videoData.liveId, this.ui = new l(this, this.config), this.config.playType = "live") : (this.ui = new d(this, this.config), this.config.playType = "vod"), a.extend(this, {
            isStarted: !1,
            mixAd: !1,
            isPlayingAD: !1,
            videoActived: !1,
            lastCurrentTime: 0,
            timelimited: !1,
            segmentEndTimer: null,
            bufferCount: -1,
            isBufferBySeek: !1,
            bufferDelayTime: 3e3,
            bufferDelayTimer: null,
            bufferCountInMinitus: 0,
            bufferCountInMinitusTimer: null
        }), this.init();
    }
    var a = i(2),
        o = i(1).os,
        r = i(18),
        s = i(14).EventEmitter,
        d = i(53),
        l = i(51),
        c = i(52),
        h = i(17),
        u = i(9),
        p = i(29),
        m = i(46),
        f = i(24),
        v = i(42),
        g = i(41),
        y = i(50),
        w = i(49),
        b = i(11),
        x = i(10),
        T = i(22),
        P = i(38),
        D = i(48),
        S = i(4),
        C = function C() {},
        k = {
        canplay: "onCanplay",
        canplaythrough: "onCanplaythrough",
        durationchange: "onDurationchange",
        emptied: "onEmptied",
        loadstart: "onLoadstart",
        ratechange: "onRatechange",
        seeked: "onSeeked",
        seeking: "onSeeking",
        suspend: "onSuspend",
        volumechang: "onVolumechang",
        waiting: "onWaiting",
        playing: "onPlaying",
        loadedmetadata: "onLoadedmetadata",
        timeupdate: "onTimeupdate",
        progress: "onProgress",
        pause: "onPause",
        play: "onPlay",
        ended: "onEnded",
        error: "onError",
        abort: "onAbort"
    },
        _ = {};
    keys_default()(k).forEach(function (e) {
        _[k[e]] = C;
    }), window.videoData && (window.__videoData = window.videoData), a.inherit(n, s, a.extend({}, {
        init: function init() {
            var e = this;
            this.video = this.el.querySelector("video"), this.initEvent(), this.videoData && this.videoData.vid && (this.config.pjax && r.pjax && history.replaceState(this.videoData, null), this.doPlay(this.videoData)), this.fullscreen = new D(this), (this.config.autoplay && r.autoplay() || this.videoActived) && "undefined" != typeof wx && document.addEventListener("WeixinJSBridgeReady", function () {
                e.video.play();
            }, !1);
        },
        initEvent: function initEvent() {
            for (var e in k) {
                var t = k[e];
                this.video.addEventListener(e, this[t].bind(this), !1);
            }
            this.adv.on("adv.loaded", this.start.bind(this)), this.adv.on("adv.timeout", this.start.bind(this)), this.on("ended", function () {
                this.dataModel && this.dataModel.timeLimit ? (this.exitFullscreen(), P(this.videoData).then(function (e) {
                    e.forEach(function (e) {
                        -1 == e.videoUrl.indexOf("?") ? e.videoUrl += "?channeled=1211010004" : e.videoUrl += "&channeled=1211010004";
                    }), this.emit("recommend.loaded", e);
                }.bind(this), function (e) {
                    x.log("\u83B7\u53D6\u540E\u63A8\u8350\u5931\u8D25-->", e);
                })) : this.playList.hasNext() ? this.playNext() : (this.emit("list.ended"), window.nextUrl && b.pingback("video_play_nextout"));
            }.bind(this)), this.on("adv.ended", this.autoSeek.bind(this)), window.addEventListener("popstate", this.onPopstate.bind(this), !1);
        },
        autoSeek: function autoSeek() {
            if (!this.dataModel.timeLimit) {
                var e = location.hash.replace("#", "").replace(/sohuaction=(.*)/, "");
                /^\d+$/.test(e) && (e = parseInt(e), !isNaN(e) && e > 0 && this.seek(e));
            }
        },
        playNext: function playNext() {
            var e = this.playList.getNext();
            "undefined" == typeof e.site && (e.site = this.videoData.site), 1 == this.videoData.site ? this.playByData(a.extend(e, {
                url: e.url + (-1 == e.url.indexOf("?") ? "?channeled=1211010010" : "&channeled=1211010010")
            })) : this.playByData(a.extend(e, {
                url: e.url + (-1 == e.url.indexOf("?") ? "?channeled=1211020010" : "&channeled=1211020010")
            }));
        },
        playByData: function playByData(e) {
            if (e) {
                var t = S.removeProtocol(e.url);
                t ? this.config.pjax && r.pjax && "live" !== this.config.playType ? (history.pushState(e, e.name || "", t), this.reset(), this.doPlay(e), b.pingback("video_play_nextin")) : (b.pingback("video_play_nextout"), setTimeout(function () {
                    location.href = t;
                }, 500)) : (this.reset(), this.doPlay(e), b.pingback("video_play_nextin"));
            }
        },
        start: function start() {
            x.log("\u5E7F\u544A\u5BF9\u8C61-->", this.adv), this.adv.isEnd || this.adv.isEmpty() ? this.emit("adv.ended") : this.isPlayingAD = !0, this.setVideoUrl();
        },
        setVideoUrl: function setVideoUrl() {
            if (this.resetBuffer(), this.isPlayingAD) this.setADVideoUrl();else {
                var e = this.dataModel.getMediaByIndex();
                this.video.src = e.url;
            }
            this.video.play();
            setTimeout(function () {
                this.video.play();
            }.bind(this), 500);
        },
        setADVideoUrl: function setADVideoUrl() {
            if (o.ios) {
                var e = this.dataModel.getMediaByIndex(),
                    t = this.adv.getVidList(),
                    i = e.url;
                i += "&ads=" + t.join(","), x.log("\u89C6\u9891\u64AD\u653E\u5730\u5740-->", i), this.mixAd = !0, this.video.src = i;
            } else {
                var n = this.adv.getDataByIndex();
                x.log("\u5E7F\u544A\u64AD\u653E\u5730\u5740-->", n.media.url), this.video.src = n.media.url;
            }
        },
        doPlay: function doPlay(e) {
            this.videoData = e, this.emit("data.loading"), h.playerLoadMediaDataStartTime = Date.now(), p.loadData(this.videoData).then(function (e) {
                h.playerLoadMediaDataEndTime = Date.now(), x.log("\u89C6\u9891\u6570\u636E\u83B7\u53D6\u5B8C\u6210, \u8017\u65F6--->" + (h.playerLoadMediaDataEndTime - h.playerLoadMediaDataStartTime) / 1e3), this.emit("data.loaded", e), 200 == e.code ? (this.videoData = e.data.videoData, this.channelInfo = e.data.channelInfo, this.mcode = e.data.mcode, this.videoData.plevel ? (window.videoData = this.videoData, this.emit("play.plevel", this.videoData.plevel)) : this.nextdoPlay()) : (this.emit("data.exception", e), b.pingback("play_fail_data"), b.pingback("play_fail_" + e.code)), this.emit("playvideo", this.videoData);
            }.bind(this));
        },
        nextdoPlay: function nextdoPlay(e) {
            if (e && a.extend(this.videoData, e), u.issohu || u.is56) {
                try {
                    this.videoData.channeled = window.videoData.channeled, this.videoData.order = window.videoData.order;
                } catch (t) {}
                window.videoData = this.videoData;
            }
            window.__videoData = this.videoData, this.dataModel = new m(this, this.config, this.videoData, this.channelInfo, this.mcode), x.log("dataModel--\x3e", this.dataModel), this.emit("data.ok"), (this.config.autoplay && r.autoplay() || this.videoActived) && this.play(), this.dataModel.timeLimit && this.emit("timelimit", this.dataModel.timeLimit), this.config.showCount && T(this.videoData).then(function (e) {
                this.emit("playcount.loaded", e);
            }.bind(this), function (e) {
                x.log("\u83B7\u53D6\u64AD\u653E\u6570\u5931\u8D25-->", e);
            });
        },
        play: function play(e) {
            if (e) this.enableVideoTag(), this.playByData(e);else if (this.isStarted) this.video.play();else {
                if (!this.dataModel) return;
                this.isStarted = !0, this.enableVideoTag(), this.adv.loadData(), this.emit("player.start"), b.pingback("ad_request_new");
            }
        },
        pause: function pause() {
            this.video.pause();
        },
        switchResolution: function switchResolution(e) {
            var t = this.dataModel;
            if (t.hasResolution(e)) {
                t.switchResolution(e);
                var i = this.getCurrentTime();
                this.isStarted ? (this.setVideoUrl(), this.seek(i)) : this.play();
            }
        },
        requestFullscreen: function requestFullscreen() {
            this.fullscreen.requestFullscreen(), this.emit("requestFullscreen");
        },
        exitFullscreen: function exitFullscreen() {
            this.fullscreen.exitFullscreen(), this.emit("exitFullscreen");
        },
        isNativeFullscreen: function isNativeFullscreen() {
            return this.fullscreen.isNativeFullscreen();
        },
        seek: function seek(e) {
            if (this.isPlayingAD) return void this.seekTo(e);
            if (!(e / 1 > this.getDuration())) {
                var t,
                    i = e,
                    n = this.dataModel;
                "segment" == n.playMode ? (t = n.getMediaByTime(i), t && t.change && (t.media, n.setIndex(t.index), this.setVideoUrl()), i = t.offset) : this.mixAd && (i += this.adv.duration), this.seekTo(i), this.play();
            }
        },
        seekTo: function seekTo(e) {
            this.switchSeekTimer && clearTimeout(this.switchSeekTimer);
            var t = this.getVideoDuration(),
                i = this.video.seekable;
            if (1 == i.length && e <= i.end(0)) try {
                e >= t && (e = t - 1), this.isBufferBySeek = !0, this.video.currentTime = e;
            } catch (n) {
                x.log("seek error", n);
            } else this.switchSeekTimer = setTimeout(function () {
                this.seekTo(e);
            }.bind(this), 100);
        },
        enableVideoTag: function enableVideoTag() {
            if (!this.videoActived) {
                var e = this.video.play();
                try {
                    e["catch"](function (e) {
                        x.log("avoidless error--\x3e", e);
                    });
                } catch (t) {}
            }
        },
        delayBufferCount: function delayBufferCount() {
            clearTimeout(this.bufferDelayTimer), this.bufferDelayTimer = setTimeout(function () {
                this.bufferDelayTimer = null;
            }.bind(this), this.bufferDelayTime);
        },
        onPopstate: function onPopstate(e) {
            var t = e.state;
            t && t.vid && (this.reset(), this.doPlay(t));
        },
        onLoadedmetadata: function onLoadedmetadata() {
            this.emit("loadedmetadata");
        },
        onWaiting: function onWaiting() {
            !this.video.src || this.isPlayingAD || this.isBufferBySeek || this.bufferDelayTimer || (this.bufferCountInMinitus += 1, this.bufferCountInMinitusTimer || (this.bufferCountInMinitusTimer = setTimeout(function () {
                this.bufferCountInMinitusTimer = null;
                var e = !1;
                1 == this.bufferCountInMinitus && (this.bufferCount += 1, e = !0), this.bufferCountInMinitus = 0, e && this.emit("buffer", this.bufferCount);
            }.bind(this), 1e3))), this.emit("waiting");
        },
        onPlaying: function onPlaying() {
            this.isPlayingAD || (this.isBufferBySeek = !1, this.delayBufferCount()), this.emit("playing");
        },
        onTimeupdate: function onTimeupdate() {
            if (this.videoActived = !0, this.dataModel) {
                var e, t;
                if (this.isPlayingAD) {
                    if ((e = this.getVideoCurrentTime()) - this.lastCurrentTime > 2) return void this.seek(this.lastCurrentTime);
                    this.lastCurrentTime = e;
                }
                if (this.emit("timeupdate"), this.isPlayingAD) if (o.ios) e = Math.floor(this.getVideoCurrentTime()), t = this.adv.duration, e > t && (this.isPlayingAD = !1, this.emit("adv.ended"));else try {
                    e = Math.floor(this.getVideoCurrentTime()), t = this.getVideoDuration(), !this.segmentEndTimer && Math.abs(t - e) < 1 && (this.segmentEndTimer = setTimeout(this.onEnded.bind(this), 1500));
                } catch (i) {}!this.isPlayingAD && this.dataModel.timeLimit && (e = this.getCurrentTime()) >= this.dataModel.timeLimit && (this.reset(), this.timelimited = !0, this.emit("ended"));
            }
        },
        onPlay: function onPlay() {
            this.emit("play");
        },
        onPause: function onPause() {
            this.emit("pause");
        },
        onEnded: function onEnded() {
            clearTimeout(this.segmentEndTimer), this.segmentEndTimer = null;
            var e = this.dataModel;
            if (this.isPlayingAD) o.ios || (this.emit("adv.segment.ended"), this.adv.isEnd && (this.isPlayingAD = !1, this.emit("adv.ended")), this.setVideoUrl());else {
                if (this.timelimited) return void (this.timelimited = !1);
                "segment" == e.playMode ? (this.emit("segment.ended"), e.getMediaByIndex() ? this.setVideoUrl() : (this.reset(), this.emit("ended"))) : (this.reset(), this.emit("ended"));
            }
        },
        onError: function onError() {
            this.video.src && (this.emit("error", this.video.error || {}), b.pingback("play_fail_video"), b.pingback("play_fail_" + this.video.error.code));
        },
        getCurrentTime: function getCurrentTime() {
            if (!this.isStarted) return 0;
            if (this.isPlayingAD) return 0;
            var e = this.dataModel;
            return this.mixAd ? this.getVideoCurrentTime() - this.adv.duration : "segment" == e.playMode ? this.getVideoCurrentTime() + e.getOffsetDuration() : this.getVideoCurrentTime();
        },
        getBufferedTime: function getBufferedTime() {
            if (!this.isPlayingAD) {
                var e = this.getVideoBufferedTime(),
                    t = this.dataModel,
                    i = this.adv.duration;
                if (t) return "segment" == t.playMode ? e += t.getOffsetDuration() : this.mixAd && (e = Math.max(0, e - i)), e;
            }
        },
        getVideoBufferedTime: function getVideoBufferedTime() {
            var e = this.video.buffered,
                t = 0;
            try {
                t = e.end(0);
            } catch (i) {}
            return t;
        },
        getVideoCurrentTime: function getVideoCurrentTime() {
            return this.video.currentTime;
        },
        getVideoDuration: function getVideoDuration() {
            return this.video.duration;
        },
        getDuration: function getDuration() {
            return this.dataModel ? this.dataModel.duration : 0;
        },
        resetBuffer: function resetBuffer() {
            this.bufferCount = -1, this.isBufferBySeek = !1, clearTimeout(this.bufferDelayTimer), this.bufferDelayTimer = null, this.bufferCountInMinitus = 0, clearTimeout(this.bufferCountInMinitusTimer), this.bufferCountInMinitusTimer = null;
        },
        reset: function reset() {
            this.pause(), this.isPlayingAD = !1, this.mixAd = !1, this.isStarted = !1, this.lastCurrentTime = 0, this.timelimited = !1, this.segmentEndTimer = null, this.resetBuffer(), this.emit("reset");
        },
        appendList: function appendList() {
            this.playList.append.apply(this.playList, arguments);
        },
        replaceList: function replaceList(e) {
            this.playList.replace(e);
        },
        clearList: function clearList() {
            this.playList.clear();
        },
        getADData: function getADData(e) {
            return this.adv.getDataByIndex(e);
        }
    }, _)), e.exports = n;
},, function (e, t, i) {
    "use strict";

    var n = i(19),
        a = (i(10), i(2)),
        o = i(8),
        r = i(3),
        s = i(1).os,
        d = i(9).REQUEST_MAX_COUNT,
        l = {
        isFee: function isFee(e) {
            return e = e || {}, "undefined" != typeof e.video_is_fee && 0 != e.video_is_fee;
        },
        check: function check(e) {
            var t = {
                code: "200"
            };
            return new o(function (i, o) {
                if (!e) return void i(t);
                if (e.iplimit = 3, 2 == e.mobileLimit || 1 == e.h5Limit) t.code = "100", i(t);else if (l.isFee(e)) t.code = 102, i(t);else if (2 == e.h5Limit) t.code = "101", i(t);else if (0 != e.ipLimit) {
                    var c = a.extend({}, n.API_PARAMS, {
                        from: "h5",
                        poid: "1",
                        sysver: s.version || "0",
                        limitType: e.ipLimit
                    }),
                        h = 0;
                    !function u() {
                        h += 1, r.getJSON("//api.tv.sohu.com/mobile_user/device/videolimit.json?callback=?", c).then(function (e) {
                            e = e || {}, e = e.data || {}, e = e.data || {}, !1 === e.islimit ? t.code = "100" : t.code = "200", i(t);
                        }, function () {
                            h < d ? u() : i(t);
                        });
                    }();
                } else i(t);
            });
        }
    };
    e.exports = l;
}, function (e, t, i) {
    "use strict";

    function n() {
        var e = 0,
            t = parseInt(100 * Math.random());
        return t < 25 ? e = 0 : t < 50 ? e = 1 : t < 75 ? e = 2 : t < 85 ? e = 3 : t < 95 ? e = 4 : t < 100 && (e = 5), e;
    }
    function a(e) {
        var t = "varsimilar" + +new Date(),
            i = "//rc.vrs.sohu.com/pgc/relate/video?&isH5=1&source=20&refer=" + (s.getParam("landingrefer") || encodeURIComponent(document.referrer)) + "&ab=" + n() + "&title=" + escape(escape(e.tvname || e.video_name || e.videoName)) + "&vid=" + e.vid + "&cid=" + e.cid + "&catecode=" + (e.cateCode || e.cate_code) + "&pageSize=3&var=" + t;
        return new o(function (e, n) {
            r({
                url: i,
                dataType: "jsonp"
            }).then(function () {
                window[t];
                try {
                    e(window[t].videos);
                } catch (i) {
                    n(i);
                }
            }, n);
        });
    }
    var o = i(8),
        r = i(3),
        s = i(5);
    i(10);
    e.exports = a;
}, function (e, t) {
    "use strict";

    var i = "function" == typeof symbol_default.a && "symbol" == typeof_default()(iterator_default.a) ? function (e) {
        return typeof e === "undefined" ? "undefined" : typeof_default()(e);
    } : function (e) {
        return e && "function" == typeof symbol_default.a && e.constructor === symbol_default.a && e !== symbol_default.a.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : typeof_default()(e);
    },
        n = {};
    n.MD5 = function (e) {
        function t(e) {
            var t = (e >>> 0).toString(16);
            return "00000000".substr(0, 8 - t.length) + t;
        }
        function n(e) {
            for (var t = [], i = 0; i < 8; i++) {
                t.push(255 & e), e >>>= 8;
            }return t;
        }
        function a(e, t) {
            return e << t & 4294967295 | e >>> 32 - t;
        }
        function o(e, t, i) {
            return e & t | ~e & i;
        }
        function r(e, t, i) {
            return i & e | ~i & t;
        }
        function s(e, t, i) {
            return e ^ t ^ i;
        }
        function d(e, t, i) {
            return t ^ (e | ~i);
        }
        function l(e, t) {
            return e[t + 3] << 24 | e[t + 2] << 16 | e[t + 1] << 8 | e[t];
        }
        function c(e) {
            for (var t = [], i = 0; i < e.length; i++) {
                if (e.charCodeAt(i) <= 127) t.push(e.charCodeAt(i));else for (var n = encodeURIComponent(e.charAt(i)).substr(1).split("%"), a = 0; a < n.length; a++) {
                    t.push(parseInt(n[a], 16));
                }
            }return t;
        }
        function h(e, i, n, a) {
            for (var o = "", r = 0, s = 0, d = 3; d >= 0; d--) {
                s = arguments[d], r = 255 & s, s >>>= 8, r <<= 8, r |= 255 & s, s >>>= 8, r <<= 8, r |= 255 & s, s >>>= 8, r <<= 8, r |= s, o += t(r);
            }return o;
        }
        function u(e) {
            for (var t = new Array(e.length), i = 0; i < e.length; i++) {
                t[i] = e[i];
            }return t;
        }
        function p(e, t) {
            return 4294967295 & e + t;
        }
        var m = null,
            f = null;
        return "string" == typeof e ? m = c(e) : e.constructor == Array ? 0 === e.length ? m = e : "string" == typeof e[0] ? m = function (e) {
            for (var t = [], i = 0; i < e.length; i++) {
                t = t.concat(c(e[i]));
            }return t;
        }(e) : "number" == typeof e[0] ? m = e : f = i(e[0]) : "undefined" != typeof ArrayBuffer ? e instanceof ArrayBuffer ? m = u(new Uint8Array(e)) : e instanceof Uint8Array || e instanceof Int8Array ? m = u(e) : e instanceof Uint32Array || e instanceof Int32Array || e instanceof Uint16Array || e instanceof Int16Array || e instanceof Float32Array || e instanceof Float64Array ? m = u(new Uint8Array(e.buffer)) : f = void 0 === e ? "undefined" : i(e) : f = void 0 === e ? "undefined" : i(e), f && alert("MD5 type mismatch, cannot process " + f), function () {
            function e(e, t, i, n) {
                var o = x;
                x = b, b = w, w = p(w, a(p(y, p(e, p(t, i))), n)), y = o;
            }
            var t = m.length;
            m.push(128);
            var i = m.length % 64;
            if (i > 56) {
                for (var c = 0; c < 64 - i; c++) {
                    m.push(0);
                }i = m.length % 64;
            }
            for (c = 0; c < 56 - i; c++) {
                m.push(0);
            }m = m.concat(n(8 * t));
            var u = 1732584193,
                f = 4023233417,
                v = 2562383102,
                g = 271733878,
                y = 0,
                w = 0,
                b = 0,
                x = 0;
            for (c = 0; c < m.length / 64; c++) {
                y = u, w = f, b = v, x = g;
                var T = 64 * c;
                e(o(w, b, x), 3614090360, l(m, T), 7), e(o(w, b, x), 3905402710, l(m, T + 4), 12), e(o(w, b, x), 606105819, l(m, T + 8), 17), e(o(w, b, x), 3250441966, l(m, T + 12), 22), e(o(w, b, x), 4118548399, l(m, T + 16), 7), e(o(w, b, x), 1200080426, l(m, T + 20), 12), e(o(w, b, x), 2821735955, l(m, T + 24), 17), e(o(w, b, x), 4249261313, l(m, T + 28), 22), e(o(w, b, x), 1770035416, l(m, T + 32), 7), e(o(w, b, x), 2336552879, l(m, T + 36), 12), e(o(w, b, x), 4294925233, l(m, T + 40), 17), e(o(w, b, x), 2304563134, l(m, T + 44), 22), e(o(w, b, x), 1804603682, l(m, T + 48), 7), e(o(w, b, x), 4254626195, l(m, T + 52), 12), e(o(w, b, x), 2792965006, l(m, T + 56), 17), e(o(w, b, x), 1236535329, l(m, T + 60), 22), e(r(w, b, x), 4129170786, l(m, T + 4), 5), e(r(w, b, x), 3225465664, l(m, T + 24), 9), e(r(w, b, x), 643717713, l(m, T + 44), 14), e(r(w, b, x), 3921069994, l(m, T), 20), e(r(w, b, x), 3593408605, l(m, T + 20), 5), e(r(w, b, x), 38016083, l(m, T + 40), 9), e(r(w, b, x), 3634488961, l(m, T + 60), 14), e(r(w, b, x), 3889429448, l(m, T + 16), 20), e(r(w, b, x), 568446438, l(m, T + 36), 5), e(r(w, b, x), 3275163606, l(m, T + 56), 9), e(r(w, b, x), 4107603335, l(m, T + 12), 14), e(r(w, b, x), 1163531501, l(m, T + 32), 20), e(r(w, b, x), 2850285829, l(m, T + 52), 5), e(r(w, b, x), 4243563512, l(m, T + 8), 9), e(r(w, b, x), 1735328473, l(m, T + 28), 14), e(r(w, b, x), 2368359562, l(m, T + 48), 20), e(s(w, b, x), 4294588738, l(m, T + 20), 4), e(s(w, b, x), 2272392833, l(m, T + 32), 11), e(s(w, b, x), 1839030562, l(m, T + 44), 16), e(s(w, b, x), 4259657740, l(m, T + 56), 23), e(s(w, b, x), 2763975236, l(m, T + 4), 4), e(s(w, b, x), 1272893353, l(m, T + 16), 11), e(s(w, b, x), 4139469664, l(m, T + 28), 16), e(s(w, b, x), 3200236656, l(m, T + 40), 23), e(s(w, b, x), 681279174, l(m, T + 52), 4), e(s(w, b, x), 3936430074, l(m, T), 11), e(s(w, b, x), 3572445317, l(m, T + 12), 16), e(s(w, b, x), 76029189, l(m, T + 24), 23), e(s(w, b, x), 3654602809, l(m, T + 36), 4), e(s(w, b, x), 3873151461, l(m, T + 48), 11), e(s(w, b, x), 530742520, l(m, T + 60), 16), e(s(w, b, x), 3299628645, l(m, T + 8), 23), e(d(w, b, x), 4096336452, l(m, T), 6), e(d(w, b, x), 1126891415, l(m, T + 28), 10), e(d(w, b, x), 2878612391, l(m, T + 56), 15), e(d(w, b, x), 4237533241, l(m, T + 20), 21), e(d(w, b, x), 1700485571, l(m, T + 48), 6), e(d(w, b, x), 2399980690, l(m, T + 12), 10), e(d(w, b, x), 4293915773, l(m, T + 40), 15), e(d(w, b, x), 2240044497, l(m, T + 4), 21), e(d(w, b, x), 1873313359, l(m, T + 32), 6), e(d(w, b, x), 4264355552, l(m, T + 60), 10), e(d(w, b, x), 2734768916, l(m, T + 24), 15), e(d(w, b, x), 1309151649, l(m, T + 52), 21), e(d(w, b, x), 4149444226, l(m, T + 16), 6), e(d(w, b, x), 3174756917, l(m, T + 44), 10), e(d(w, b, x), 718787259, l(m, T + 8), 15), e(d(w, b, x), 3951481745, l(m, T + 36), 21), u = p(u, y), f = p(f, w), v = p(v, b), g = p(g, x);
            }
            return h(g, v, f, u).toUpperCase();
        }();
    }, e.exports = function (e) {
        return n.MD5(e);
    };
},, function (e, t, i) {
    "use strict";

    function n(e, t) {
        this.superClass.constructor.call(this), this.player = e, this.config = d.extend({}, t || {}, g), d.extend(this, {
            isEnd: !1,
            duration: 0,
            currentTime: 0,
            appid: this.config.appid || "",
            index: 0,
            mediaData: [],
            resData: {
                count: 0,
                emptyCount: 0
            }
        }), this.init();
    }
    var a = i(1).os,
        o = (i(1).browser, i(18)),
        r = (i(9), i(5)),
        s = i(6),
        d = i(2),
        l = i(4),
        c = i(3),
        h = i(43),
        u = i(10),
        p = i(17),
        m = i(13),
        f = i(8),
        v = i(14).EventEmitter,
        g = {
        adClose: "0",
        debug: !1,
        timeout: 3e3,
        urls: {
            adrMedia: "//m.aty.sohu.com/h",
            adrMediaDebug: "//60.28.168.195/h"
        }
    };
    d.inherit(n, v, {
        init: function init() {
            this.initEvent();
        },
        initEvent: function initEvent() {
            this.player.on("timeupdate", this.onTimeupdate.bind(this)), this.player.on("adv.segment.ended", this.onAdvSegmentEnd.bind(this)), this.player.on("loadedmetadata", this.onLoadedmetadata.bind(this)), this.player.on("reset", this.reset.bind(this));
        },
        getPlatId: function getPlatId() {
            return a.android || a.androidpad ? "h6" : a.iphone ? "h3" : a.ipad ? "h1" : "unknowm";
        },
        getVc: function getVc() {
            var e = this.player.videoData,
                t = e.cateCode || e.cate_code || e.cid || "";
            return t = "" + t, t && t.indexOf(";") > -1 && (t = t.replace(/.*?;/, "")), t;
        },
        getPn: function getPn() {
            var e = this.getPlatId();
            return "h6" === e ? "androidphone" : "h3" === e ? "iphone" : "h16" === e ? "androidpad" : "h1" === e ? "ipad" : "unknowm";
        },
        getAdParam: function getAdParam() {
            var e = this.player.videoData,
                t = this.player.dataModel.duration || 0,
                i = this.config,
                n = {
                pt: "oad",
                plat: this.getPlatId(),
                sver: "",
                sysver: a.version,
                c: "tv",
                vc: this.getVc(),
                pn: this.getPn(),
                al: e.plid || e.sid || e.aid || "",
                du: t,
                vid: e.vid || "",
                tvid: e.tvid || "",
                tuv: s("MUV") || s("SUV") || "",
                vu: "",
                prot: "vast",
                cat: "1",
                ar: e.areaId || e.area_id || 6,
                json: "std",
                appid: this.appid,
                pageUrl: window.location.href,
                type: e.site && 2 === e.site || e.cid && "9001" === e.cid ? "my" : "vrs",
                ag: "",
                st: "",
                partner: r.getQueryString("src") || r.getQueryString("SRC") || s("MTV_SRC") || "-2"
            };
            return "0" != i.adClose && (n.adClose = i.adClose), n.partner = n.partner.substr(0, 4), n;
        },
        toString: function toString(e) {
            var t = [];
            for (var i in e) {
                t.push(i + "=" + encodeURIComponent(e[i]));
            }return t.join("&");
        },
        repOrAddParams: function repOrAddParams(e) {
            try {
                if ("" !== e && e.indexOf("mmg.aty.sohu.com") > -1) {
                    var t = e.match(/partner=([a-zA-Z0-9\-_\|]*)/i),
                        i = r.getQueryString("src") || r.getQueryString("SRC") || s("MTV_SRC") || "-2";
                    (null === t || t.length >= 2 && "" === t[1]) && (e = e + "&partner=" + i);
                }
            } catch (d) {
                u.log(d);
            }
            var n = e.match(/urldomain=([a-zA-Z0-9\-_\|]*)/i);
            (null === n || n.length >= 2 && "" === n[1]) && (e = e + "&urldomain=" + window.location.host);
            var a = l.getLQD(),
                o = l.getLCODE();
            return -1 != e.indexOf("?") ? e += "&oth=" + a + "&cd=" + o : e += "?oth=" + a + "&cd=" + o, e += "&src=" + m.getSrc();
        },
        pingback: function pingback(e) {
            if (e) for (var e, t = e.split("|"), i = 0, n = t.length, a = this.player.dataModel; i < n; i++) {
                e = t[i], e = l.removeProtocol(this.repOrAddParams(e)), a.ugcode && (e = -1 == e.indexOf("?") ? e + "?ugcode2=" + a.ugcode + "&ugu2=" + a.ugu : e + "&ugcode2=" + a.ugcode + "&ugu2=" + a.ugu);
                var o = new Image();
                u.log("\u4E0A\u62A5\u7EDF\u8BA1URL", e), o.src = e;
            }
        },
        compileData: function compileData(e) {
            for (var t, i, n, a, o, r, s = e || [], d = 0, l = s.length, c = 0, h = 0, u = [], p = {}, m = {}; d < l; d++) {
                n = [], a = [], o = [], r = [], t = s[d].InLine, m = {
                    duration: t.Duration || 0,
                    clickurl: t.ClickThrough
                }, (t.ClickTracking || []).forEach(function (e) {
                    n.push(e.ClickTracking || "");
                }), m.cp = n.join("|"), h += m.duration, m.duration || (c += 1), i = t.MediaFile[0], i.url = this.compileQueryAdVideoURL(i.MediaFile);
                var f = t.Tracking || [],
                    v = 0,
                    g = f.length;
                for ((t.Imp || []).forEach(function (e) {
                    e.monitorServer && e.monitorServer.Impression && a.push(e.monitorServer.Impression);
                }); v < g; v++) {
                    "progress" == f[v].event ? r.push({
                        v: f[v].Tracking,
                        t: f[v].offset
                    }) : "complete" == f[v].event && o.push({
                        v: f[v].Tracking,
                        t: f[v].offset
                    });
                }m.sp = a, m.mp = r, m.ep = o, m.media = i, u.push(m);
            }
            return p = {
                count: l,
                emptyCount: c
            }, {
                mediaData: u,
                resData: p,
                duration: h
            };
        },
        compileQueryAdVideoURL: function compileQueryAdVideoURL(e) {
            if (!e) return e;
            var t = this.player.videoData,
                i = t.cateCode || t.cate_code || "",
                n = "vid=" + t.vid + "&uid=" + (s("SUV") || "") + "&plat=17&eye=0&cateCode=" + (i.split(";")[0] || "") + "&advEFId=" + t.advEFId + "&ca=4&SOHUSVP=" + s("SOHUSVP") + "&oth=" + l.getLQD() + "&cd=" + l.getLCODE() + "&src=" + m.getSrc();
            return e += (e.match(/\?/) ? "&" : "?") + n;
        },
        loadAndroidAdInfo: function loadAndroidAdInfo(e) {
            var t,
                i = this.config;
            return i.debug ? (t = i.urls.adrMediaDebug + "?" + this.toString(e), u.log("android\u5E7F\u544A\u8BF7\u6C42:" + t)) : t = i.urls.adrMedia, new f(function (n, a) {
                c({
                    url: t,
                    data: e,
                    dataType: "jsonp",
                    timeout: i.timeout
                }).then(function (e) {
                    var t = e.data;
                    t = h.decode(t), n(t);
                }, function () {
                    n({
                        timeout: !0
                    });
                });
            });
        },
        loadData: function loadData() {
            if (!o.adv()) return this.isEnd = !0, void this.emit("adv.loaded");
            var e = this.config,
                t = this.player.channelInfo || {},
                i = this;
            "undefined" != typeof t.isClosed && (e.adClose = t.isClosed);
            var n = this.getAdParam();
            p.loadAdDataStartTime = Date.now(), this.loadAndroidAdInfo(n).then(function (t) {
                if (t = t || {}, t.timeout) u.log("android\u5E7F\u544A\u8BF7\u6C42\u8D85\u65F6"), this.emit("adv.timeout");else {
                    p.loadAdDataEndTime = Date.now(), u.log("\u83B7\u53D6android\u5E7F\u544A\u5B8C\u6210, \u8017\u65F6--->" + (p.loadAdDataEndTime - p.loadAdDataStartTime) / 1e3);
                    var n = this.compileData(t);
                    if (this.mediaData = n.mediaData, this.resData = n.resData, this.duration = n.duration, 0 != e.adClose || 0 == this.duration) {
                        this.isEnd = !0, 0 != e.adClose ? u.log("\u5E7F\u544A\u5DF2\u7ECF\u83B7\u53D6\u6210\u529F\uFF0C\u4F46\u662F\u5E7F\u544A\u88AB\u5C4F\u853D") : 0 == this.duration && u.log("\u5E7F\u544A\u5DF2\u7ECF\u83B7\u53D6\u6210\u529F\uFF0C\u4F46\u662F\u5E7F\u544A\u4E3A\u7A7A");
                        (this.mediaData || []).forEach(function (e, t) {
                            if (e._spEnd || (e._spEnd = !0, i.pingback(e.sp.join("|"))), 0 !== e.mp.length) {
                                var n = e.mp[0];
                                0 === n.v && (i.pingback(n.v), 0 !== e.duration ? u.log("\u5E7F\u544A\u4E0A\u62A5 v:" + n.v + ", curIndex: 0") : u.log("\u7A7A\u5E7F\u544A\u4E0A\u62A5 v: " + n.v + ", curIndex: 0"));
                            }
                        }.bind(this));
                    } else for (var a = 0, o = this.mediaData.length; a < o; a++) {
                        if (this.mediaData[a].duration) {
                            this.index = a;
                            break;
                        }
                        this.mediaData[a]._spEnd || (this.mediaData[a]._spEnd = !0, this.pingback(this.mediaData[a].sp.join("|")));
                    }
                    this.emit("adv.loaded");
                }
            }.bind(this));
        },
        isEmpty: function isEmpty() {
            return 0 === this.duration;
        },
        getDataByIndex: function getDataByIndex(e) {
            return void 0 === e && (e = this.index), this.mediaData[e];
        },
        getCurrentTime: function getCurrentTime() {
            for (var e = this.mediaData, t = this.index, i = 0, n = 0; i < t; i++) {
                n += e[i].duration;
            }return n + (this.player.getVideoCurrentTime() || 0);
        },
        onAdvSegmentEnd: function onAdvSegmentEnd() {
            var e = this.getDataByIndex();
            e._epEnd || (e._epEnd = !0, (e.ep || []).forEach(function (e) {
                this.pingback(e.v);
            }.bind(this)));
            for (var t, i = this.index + 1, n = this.mediaData.length; i < n && (t = this.mediaData[i], 0 == t.duration); i++) {
                t._spEnd || (t._spEnd = !0, (t.sp || []).forEach(function (e) {
                    this.pingback(e);
                }.bind(this)));
            }this.index = i, this.index >= n && (this.isEnd = !0);
        },
        onLoadedmetadata: function onLoadedmetadata() {
            if ("0" == this.config.adClose) {
                var e = this.getDataByIndex();
                e && (e._spEnd || (e._spEnd = !0, this.pingback(e.sp.join("|"))));
            }
        },
        onTimeupdate: function onTimeupdate() {
            this.mpingback();
        },
        mpingback: function mpingback() {
            if (!this.isEnd) {
                var e = this.getDataByIndex();
                if (e) for (var t, i = e.mp, n = Math.floor(this.player.getVideoCurrentTime() || 0), a = 0, o = i.length; a < o; a++) {
                    t = i[a], t.t != n || t._done || (t._done = !0, this.pingback(t.v));
                }
            }
        },
        reset: function reset() {
            this.isEnd = !1, this.duration = 0, this.currentTime = 0, this.index = 0, this.mediaData = [], this.resData = {
                count: 0,
                emptyCount: 0
            };
        }
    }), e.exports = n;
}, function (e, t, i) {
    "use strict";

    function n(e, t) {
        this.superClass.constructor.call(this), this.player = e, this.config = p.extend({}, t || {}, v), p.extend(this, {
            isEnd: !1,
            duration: 0,
            currentTime: 0,
            appid: this.config.appid || "",
            index: 0,
            mediaData: [],
            resData: {
                count: 0,
                emptyCount: 0
            }
        }), this.init();
    }
    var a = i(1).os,
        o = (i(1).browser, i(5)),
        r = i(6),
        s = i(18),
        d = i(10),
        l = (i(9), i(3)),
        c = i(17),
        h = i(14).EventEmitter,
        u = i(13),
        p = i(2),
        m = i(8),
        f = i(4),
        v = {
        adClose: "0",
        debug: !1,
        debugCurUrl: "",
        timeout: 3e3,
        dragCheckFlag: !0,
        urls: {
            iosMedia: "//m.aty.sohu.com/h",
            iosMediaDebug: "//60.28.168.195/h"
        }
    };
    p.inherit(n, h, {
        init: function init() {
            this.initEvent();
        },
        initEvent: function initEvent() {
            this.player.on("timeupdate", this.onTimeupdate.bind(this)), this.player.on("reset", this.reset.bind(this));
        },
        reset: function reset() {
            this.isEnd = !1, this.duration = 0, this.currentTime = 0, this.index = 0, this.mediaData = [], this.resData = {
                count: 0,
                emptyCount: 0
            };
        },
        getCurrentTime: function getCurrentTime() {
            return this.currentTime;
        },
        getAdParam: function getAdParam() {
            var e = this.player.videoData,
                t = this.player.dataModel.duration || 0,
                i = this.config,
                n = {
                pt: "oad",
                plat: this.getPlatId(),
                sysver: a.version,
                c: "tv",
                cat: "1",
                vc: this.getVc(),
                pn: this.getPn(),
                al: e.plid || e.sid || e.aid || "",
                ag: "",
                st: "",
                ar: e.areaId || e.area_id || 6,
                vu: "",
                tuv: r("MUV") || r("SUV") || "",
                appid: this.appid,
                type: e.site && 2 === e.site || e.cid && "9001" === e.cid ? "my" : "vrs",
                vid: e.vid || "",
                tvid: e.tvid || e.tv_id || "",
                pageUrl: window.location.href,
                du: t,
                partner: o.getQueryString("src") || o.getQueryString("SRC") || r("MTV_SRC") || "-2"
            };
            return "0" != i.adClose && (n.adClose = i.adClose), n.partner = n.partner.substr(0, 4), n;
        },
        getPlatId: function getPlatId() {
            return a.androidpad ? "h0" : a.iphone ? "h3" : a.ipad ? "h1" : a.android ? "h6" : "unknowm";
        },
        getVc: function getVc() {
            var e = this.player.videoData,
                t = e.cateCode || e.cate_code || e.cid || "";
            return t = "" + t, t && t.indexOf(";") > -1 && (t = t.replace(/.*?;/, "")), t;
        },
        getPn: function getPn() {
            var e = this.getPlatId();
            return "h6" === e ? "androidphone" : "h3" === e ? "iphone" : "h16" === e ? "androidpad" : "h1" === e ? "ipad" : "unknowm";
        },
        repOrAddParams: function repOrAddParams(e) {
            try {
                if ("" !== e && e.indexOf("mmg.aty.sohu.com") >= 1) {
                    var t = e.match(/partner=([a-zA-Z0-9\-_\|]*)/i),
                        i = o.getQueryString("src") || o.getQueryString("SRC") || r("MTV_SRC") || "-2";
                    i = i.substr(0, 4), (null === t || t.length >= 2 && "" === t[1]) && (e = e + "&partner=" + i);
                }
            } catch (l) {
                d.log(l);
            }
            var n = e.match(/urldomain=([a-zA-Z0-9\-_\|]*)/i);
            (null === n || n.length >= 2 && "" === n[1]) && (e = e + "&urldomain=" + window.location.host);
            var a = f.getLQD(),
                s = f.getLCODE();
            return -1 != e.indexOf("?") ? e += "&oth=" + a + "&cd=" + s : e += "?oth=" + a + "&cd=" + s, e += "&src=" + u.getSrc();
        },
        pingback: function pingback(e) {
            if (e) for (var e, t = e.split("|"), i = 0, n = t.length, a = this.player.dataModel; i < n; i++) {
                e = t[i];
                try {
                    e = f.removeProtocol(this.repOrAddParams(e)), a.ugcode && (e = -1 == e.indexOf("?") ? e + "?ugcode2=" + a.ugcode + "&ugu2=" + a.ugu : e + "&ugcode2=" + a.ugcode + "&ugu2=" + a.ugu);
                } catch (o) {}new Image().src = e, d.log("\u4E0A\u62A5\u7EDF\u8BA1URL", e);
            }
        },
        toString: function toString(e) {
            var t = [];
            for (var i in e) {
                t.push(i + "=" + encodeURIComponent(e[i]));
            }return t.join("&");
        },
        loadIosAdInfo: function loadIosAdInfo(e) {
            var t,
                i = this.config;
            return i.debug ? (t = i.urls.iosMediaDebug, d.log("ios\u5E7F\u544A\u8BF7\u6C42:" + t + "?" + this.toString(e))) : t = i.urls.iosMedia, new m(function (n, a) {
                l({
                    url: t,
                    data: e,
                    dataType: "jsonp",
                    timeout: i.timeout
                }).then(function (e) {
                    n(e);
                }, function () {
                    n({
                        timeout: !0
                    });
                });
            });
        },
        compileData: function compileData(e) {
            var t = {
                mediaData: [],
                resData: {},
                duration: 0
            };
            if (e && 1 === e.status) {
                var i,
                    n = e.data.oad || [],
                    a = 0,
                    o = n.length,
                    r = 0,
                    s = 0,
                    d = [],
                    l = {};
                for (l.count = o; a < o; a++) {
                    i = n[a], "h1" === this.getPlatId() ? (i.vid = i[12], i.duration = i[1], i.clickurl = i[2], i.sp = i[3] || "", i.ep = i[5] || "", i.cp = i[6] || "", i.mp = i[11] || []) : (i.sp = i.pingback || "", i.ep = i.finishedstatistics || "", i.cp = i.clickstatistics || "", i.mp = i.pingbacks || []), d.push(i), s += i.duration || 0, i.vid || (r += 1);
                }l.emptyCount = r, t = {
                    mediaData: d,
                    resData: l,
                    duration: s
                };
            }
            return t;
        },
        loadData: function loadData() {
            if (!s.adv()) return this.isEnd = !0, void this.emit("adv.loaded");
            var e = this.config,
                t = this.player.channelInfo || {},
                i = this;
            "undefined" != typeof t.isClosed && (e.adClose = t.isClosed);
            var n = this.getAdParam();
            c.loadAdDataStartTime = Date.now(), this.loadIosAdInfo(n).then(function (t) {
                if (t = t || {}, t.timeout) d.log("ios\u5E7F\u544A\u8BF7\u6C42\u8D85\u65F6"), this.emit("adv.timeout");else {
                    c.loadAdDataEndTime = Date.now(), d.log("\u83B7\u53D6ios\u5E7F\u544A\u5B8C\u6210, \u8017\u65F6--->" + (c.loadAdDataEndTime - c.loadAdDataStartTime) / 1e3);
                    var n = this.compileData(t.data);
                    if (this.mediaData = n.mediaData, this.resData = n.resData, this.duration = n.duration, 0 != e.adClose || 0 == this.duration) {
                        this.isEnd = !0, 0 != e.adClose ? d.log("\u5E7F\u544A\u5DF2\u7ECF\u83B7\u53D6\u6210\u529F\uFF0C\u4F46\u662F\u5E7F\u544A\u88AB\u5C4F\u853D", t) : 0 == this.duration && d.log("\u5E7F\u544A\u5DF2\u7ECF\u83B7\u53D6\u6210\u529F\uFF0C\u4F46\u662F\u5E7F\u544A\u4E3A\u7A7A", t);
                        (this.mediaData || []).forEach(function (e, t) {
                            if (i.pingback(e.sp), 0 !== e.duration ? d.log("ios\u5E7F\u544A\u4E0A\u62A5 start:" + e.pingback) : d.log("ios\u7A7A\u5E7F\u544A\u4E0A\u62A5 start:" + e.pingback), e.pingback = "", e.pingbacks = e.pingbacks || [], 0 !== e.pingbacks.length) {
                                var n = e.pingbacks[0];
                                0 === n.v && (i.pingback(n.v), 0 !== e.duration ? d.log("ios\u5E7F\u544A\u4E0A\u62A5 v:" + n.v + ", curIndex: 0") : d.log("ios\u7A7A\u5E7F\u544A\u4E0A\u62A5 v: " + n.v + ", curIndex: 0"));
                            }
                        }.bind(this));
                    } else for (var a = 0, o = this.mediaData.length; a < o; a++) {
                        if (this.mediaData[a].duration) {
                            this.index = a;
                            break;
                        }
                        this.pingback(this.mediaData[a].sp), this.mediaData[a]._spEnd = !0;
                    }
                    this.emit("adv.loaded");
                }
            }.bind(this));
        },
        isEmpty: function isEmpty() {
            return 0 === this.duration;
        },
        onTimeupdate: function onTimeupdate() {
            if (!this.player.isPlayingAD) return void this.startPingback();
            if (this.currentTime = this.player.getVideoCurrentTime(), this.currentTime > this.duration) this.endPingback(), this.overPingback(), this.isEnd = !0;else {
                this.startPingback();
                var e = this.calcIndex();
                void 0 !== e && e != this.index && (this.endPingback(), this.index = e, this.startPingback()), this.mpingback();
            }
        },
        calcIndex: function calcIndex() {
            for (var e, t, i, n = Math.ceil(this.player.getVideoCurrentTime()), a = this.mediaData, o = 0, r = a.length, s = 0; o < r; o++) {
                if (t = a[o], t.duration) {
                    if (0 <= (i = n - s) && i <= t.duration) {
                        e = o;
                        break;
                    }
                    s += t.duration;
                }
            }return e;
        },
        startPingback: function startPingback() {
            if (!this.isEnd && this.mediaData && this.mediaData.length) {
                for (var e, t, i = this.index - 1; i >= 0 && (e = this.getDataByIndex(i), !e.vid); i--) {
                    !e._spEnd && e.sp && (e._spEnd = !0, this.pingback(e.sp));
                }e = this.getDataByIndex(), t = e.sp, !e._spEnd && t && (e._spEnd = !0, this.pingback(t));
            }
        },
        endPingback: function endPingback() {
            if (!this.isEnd && this.mediaData && this.mediaData.length) {
                var e = this.getDataByIndex(),
                    t = e.ep;
                !e._epEnd && t && (e._epEnd = !0, this.pingback(t));
            }
        },
        overPingback: function overPingback() {
            if (!this.isEnd && this.mediaData && this.mediaData.length) for (var e, t = this.mediaData.length - 1; t >= 0 && (e = this.getDataByIndex(t), !e.vid); t--) {
                !e._spEnd && e.sp && (e._spEnd = !0, this.pingback(e.sp));
            }
        },
        mpingback: function mpingback() {
            if (!this.isEnd) {
                var e = Math.ceil(this.player.getVideoCurrentTime()),
                    t = this.index,
                    i = this.getDataByIndex();
                if (i) {
                    var n = i.mp;
                    if (n && n.length && !window.isNaN(e)) {
                        for (var a = 0, o = 0; o < t; o++) {
                            a += this.getDataByIndex(o).duration;
                        }a = Math.ceil(a);
                        var r;
                        n.forEach(function (t, i) {
                            if (e - a - t.t >= 0 && !t._done) return r = t, !1;
                        }), r && r.v && (r._done = !0, this.pingback(r.v));
                    }
                }
            }
        },
        getVidList: function getVidList() {
            for (var e, t = this.mediaData, i = 0, n = t.length, a = []; i < n; i++) {
                (e = t[i].vid) && a.push(e);
            }return a;
        },
        getDataByIndex: function getDataByIndex(e) {
            return void 0 === e && (e = this.index), this.mediaData[e];
        }
    }), e.exports = n;
}, function (e, t, i) {
    "use strict";

    var n = i(5),
        a = (i(17), i(6), i(10), {});
    a.decode = function (e) {
        var t = new Array(-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1),
            i = function (e) {
            var t, i, n, a, o, r;
            for (t = "", n = e.length, i = 0; i < n;) {
                switch ((a = e.charCodeAt(i++)) >> 4) {
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                        t += e.charAt(i - 1);
                        break;
                    case 12:
                    case 13:
                        o = e.charCodeAt(i++), t += String.fromCharCode((31 & a) << 6 | 63 & o);
                        break;
                    case 14:
                        o = e.charCodeAt(i++), r = e.charCodeAt(i++), t += String.fromCharCode((15 & a) << 12 | (63 & o) << 6 | (63 & r) << 0);
                }
            }return t;
        }(function (e) {
            var i, n, a, o, r, s, d;
            for (s = e.length, r = 0, d = ""; r < s;) {
                do {
                    i = t[255 & e.charCodeAt(r++)];
                } while (r < s && -1 == i);
                if (-1 == i) break;
                do {
                    n = t[255 & e.charCodeAt(r++)];
                } while (r < s && -1 == n);
                if (-1 == n) break;
                d += String.fromCharCode(i << 2 | (48 & n) >> 4);
                do {
                    if (61 == (a = 255 & e.charCodeAt(r++))) return d;
                    a = t[a];
                } while (r < s && -1 == a);
                if (-1 == a) break;
                d += String.fromCharCode((15 & n) << 4 | (60 & a) >> 2);
                do {
                    if (61 == (o = 255 & e.charCodeAt(r++))) return d;
                    o = t[o];
                } while (r < s && -1 == o);
                if (-1 == o) break;
                d += String.fromCharCode((3 & a) << 6 | o);
            }
            return d;
        }(e));
        return a.parseData(i);
    }, a.parseData = function (e) {
        function t(e) {
            var t = e.split(":");
            return 3600 * parseInt(t[0]) + 60 * parseInt(t[1]) + parseInt(t[2]);
        }
        var i,
            n,
            o = [];
        window.DOMParser ? (i = new DOMParser(), n = i.parseFromString(e, "text/xml")) : (n = new ActiveXObject("Microsoft.XMLDOM"), n.async = "true", n.loadXML(e));
        for (var r = n.getElementsByTagName("Ad"), s = 0; s < r.length; s++) {
            for (var d = {}, l = {}, c = r[s].getElementsByTagName("InLine"), h = 0; h < c.length; h++) {
                var u = c[h].tagName,
                    p = c[h].getElementsByTagName("AdSystem")[0].tagName,
                    m = c[h].getElementsByTagName("AdSystem")[0].childNodes[0].nodeValue;
                l[p] = m;
                var f = c[h].getElementsByTagName("AdTitle")[0].tagName,
                    v = c[h].getElementsByTagName("AdTitle")[0].childNodes[0].nodeValue;
                l[f] = v;
                var g = c[h].getElementsByTagName("Description")[0].tagName,
                    y = c[h].getElementsByTagName("Description")[0].childNodes[0].nodeValue;
                l[g] = y;
                for (var w = c[h].getElementsByTagName("Impression"), b = new Array(), x = 0; x < w.length; x++) {
                    var T = {},
                        P = {},
                        D = c[h].getElementsByTagName("Impression")[x].tagName,
                        S = c[h].getElementsByTagName("Impression")[x].childNodes[0].nodeValue,
                        S = S.replace(/\s/g, "");
                    T[D] = S;
                    P[c[h].getElementsByTagName("Impression")[x].getAttribute("id")] = T, b.push(P);
                }
                l.Imp = b, l.isImp = !1;
                for (var C = c[h].getElementsByTagName("Creatives")[0], k = C.getElementsByTagName("Creative"), _ = 0; _ < k.length; _++) {
                    var L = k[_].getElementsByTagName("Linear")[0],
                        E = L.getElementsByTagName("Duration")[0].tagName,
                        A = L.getElementsByTagName("Duration")[0].childNodes[0].nodeValue;
                    l[E] = t(A);
                    for (var I = L.getElementsByTagName("MediaFiles")[0], M = I.getElementsByTagName("MediaFile"), B = new Array(), F = 0; F < M.length; F++) {
                        var U = {};
                        if (M[F].hasChildNodes()) var O = M[F].tagName,
                            q = M[F].childNodes[0].nodeValue,
                            q = q.replace(/\s/g, "");else var q = null;
                        U[O] = q;
                        var N = M[F].getAttribute("width");
                        U.width = N;
                        var R = M[F].getAttribute("height");
                        U.height = R;
                        var V = M[F].getAttribute("type");
                        U.type = V;
                        var j = M[F].getAttribute("vid");
                        U.vid = j, B.push(U);
                    }
                    l.MediaFile = B;
                    for (var H = L.getElementsByTagName("VideoClicks")[0], $ = H.getElementsByTagName("ClickThrough"), W = 0; W < $.length; W++) {
                        var Q = $[W].tagName,
                            z = $[W].childNodes[0].nodeValue,
                            z = z.replace(/\s/g, "");
                        l[Q] = z;
                    }
                    var X = H.getElementsByTagName("ClickTracking"),
                        J = new Array();
                    if (H.hasChildNodes()) {
                        for (var K = 0; K < X.length; K++) {
                            var G = {},
                                Y = X[K].tagName,
                                Z = X[K].childNodes[0].nodeValue,
                                Z = Z.replace(/\s/g, "");
                            G[Y] = Z;
                            var ee = X[K].getAttribute("id");
                            G.id = ee, J.push(G);
                        }
                        l.ClickTracking = J;
                    }
                    var te = L.getElementsByTagName("TrackingEvents")[0];
                    if (te != undefined) {
                        for (var ie = te.getElementsByTagName("Tracking"), ne = new Array(), ae = 0; ae < ie.length; ae++) {
                            var oe = {},
                                re = ie[ae].tagName,
                                se = ie[ae].childNodes[0].nodeValue,
                                se = se.replace(/\s/g, "");
                            oe[re] = se;
                            var de = ie[ae].getAttribute("event"),
                                le = ie[ae].getAttribute("id"),
                                ce = ie[ae].getAttribute("offset");
                            oe.event = de, oe.id = le, oe.isTrack = !1, oe.offset = null != ce ? t(ce) : ce, ne.push(oe);
                        }
                        l.Tracking = ne;
                    }
                }
                for (var he = c[h].getElementsByTagName("Extensions")[0], ue = he.getElementsByTagName("Extension"), pe = 0; pe < ue.length; pe++) {
                    for (var me = ue[pe].getElementsByTagName("AdParams")[0], fe = (me.getAttribute("adStyle"), me.getAttribute("sequence"), me.getElementsByTagName("CallbackFun")), ve = 0; ve < fe.length; ve++) {}
                }d[u] = l;
            }
            o.push(d);
        }
        for (var ge = [], ye = {}, s = 0; s < o.length; s++) {
            var we = o[s].InLine.MediaFile[0].MediaFile,
                be = o[s].InLine.ClickThrough,
                xe = o[s].InLine.Duration,
                j = o[s].InLine.MediaFile[0].vid;
            null != we ? (ye.videoUrl = we, ye.clickUrl = be, ye.duration = xe, ye.vid = j, ye = a.cbDataProcess(ye, o[s].InLine), ge.push(ye), ye = {}) : (ye.videoUrl = "error", ye.clickUrl = "error", ye.duration = "error", ye.vid = "error", ye = a.cbDataProcess(ye, o[s].InLine), ge.push(ye), ye = {});
        }
        return o;
    }, a.cbDataProcess = function (e, t) {
        var i = t.Imp[0].monitorServer.Impression,
            a = n.getQueryData(i),
            o = a.p ? a.p.split(",") : [];
        return e.cnt = o.length, e;
    }, e.exports = a;
}, function (e, t, i) {
    "use strict";

    function n(e) {
        var t = {
            vid: e.vid || "",
            uid: e.uid || r.uid,
            pt: e.pt || o.getUserPt(),
            plid: e.plid || e.aid || e.sid
        };
        return new s(function (e, i) {
            if (r.is56) {
                var n = 0;
                !function o() {
                    n += 1, a.getJSON("//vxml.56.com/svp?callback=?", t).then(function () {
                        e({
                            code: "200"
                        });
                    }, function () {
                        n >= d ? e({
                            code: "408"
                        }) : o();
                    });
                }();
            } else e();
        });
    }
    var a = i(3),
        o = i(4),
        r = i(9),
        s = (i(1).os, i(8)),
        d = (i(6), i(15), i(9).REQUEST_MAX_COUNT);
    e.exports = n;
}, function (e, t, i) {
    "use strict";

    var n = (i(19), i(23)),
        a = (i(2), i(4), i(3)),
        o = (i(6), i(16), i(8)),
        r = i(9).REQUEST_MAX_COUNT,
        s = {
        globalCfg: {
            vid: "",
            liveId: ""
        },
        formatLiveInfo: function formatLiveInfo(e) {
            var t = {
                code: "200",
                msg: "",
                data: null
            };
            if (e && e.data) {
                var i = e.data;
                if (1 == i.liveRecore && i.vid) return void (location.href = "//m.tv.sohu.com/v" + i.vid + ".shtml?channeled=" + window.videoData.channeled);
                var a = [],
                    o = i.data.clipsURL[0] || "";
                if (/m3u8/gi.test(o)) {
                    var r = "//" + o;
                    a.push({
                        url: r,
                        duration: i.totalDuration
                    });
                } else i.data.hls && a.push({
                    url: i.data.hls,
                    duration: Infinity
                });
                var s = {};
                s.vid = i.lid || "147", s.liveId = i.lid || "147", s.videoName = i.data.tvName || "", s.urls = a, s.duration = Infinity, t.data = s, document.title = s.videoName + "\u76F4\u64AD_\u641C\u72D0\u89C6\u9891", window.shareData && (window.shareData.title = document.title, window.shareData.img_url = "//i2.itc.cn/20160407/35ec_7a7986e6_7b8a_7c1c_cd0c_57766cd6ce09_1.png");
            } else t.code = "407", t.msg = n[t.code];
            return t;
        },
        loadHLSUrlByLiveId: function loadHLSUrlByLiveId(e, t) {
            t = "function" == typeof t ? t : function () {};
            var i = {},
                n = "//live.tv.sohu.com/live/player_json.jhtml?callback=?&type=2&lid=" + e.liveId;
            return new o(function (e, o) {
                function d() {
                    l += 1, a.getJSON(n, i).then(function (i) {
                        var n = s.formatLiveInfo(i);
                        t(n), e(n);
                    }, function () {
                        if (l >= r) {
                            var i = s.formatLiveInfo();
                            t(i), e(i);
                        } else d();
                    });
                }
                var l = 0;
                d();
            });
        }
    };
    e.exports = {
        loadData: s.loadHLSUrlByLiveId
    };
}, function (e, t, i) {
    "use strict";

    function n(e, t, i, n, a) {
        this.player = e, this.videoData = i, this.channelInfo = n, this.mcode = a || "", this.config = t || {}, d.extend(this, t, c), d.extend(this, {
            resolutionList: [],
            mediaData: {}
        }), "live" === t.playType ? this.initLive(i, n) : this.initVOD(i, n);
    }
    var a = i(1).os,
        o = i(25),
        r = i(18),
        s = i(10),
        d = i(2),
        l = i(4),
        c = {
        playMode: "one",
        duration: 0,
        index: 0,
        count: -1,
        timeLimit: 0
    };
    d.extend(n.prototype, {
        initVOD: function initVOD(e, t) {
            "horizon" === this.posterType ? this.poster = e.hor_w16_pic || e.horHighPic || e.verHighPic || "" : this.poster = e.verHighPic || e.horHighPic || "", this.poster = this.poster.replace("http:", ""), d.extend(this, {
                tvid: e.tvid,
                vid: e.vid,
                duration: parseInt(e.totalDuration || e.total_duration || 0, 10),
                title: e.tvname || e.videoName || e.video_name || "",
                playcount: e.playCount || e.play_count || 0,
                ugcode: e.ugcode || "",
                ugu: e.ugu || "",
                vw: e.vWidth || 0,
                vh: e.vHeight || 0
            });
            try {
                if (2 != this.videoData.site) {
                    var i = this.channelInfo.cid || "",
                        n = this.channelInfo.limitIds || "",
                        c = this.videoData.plid || this.videoData.aid || this.videoData.sid || "";
                    i = i.replace(/\s/g, "").replace(/\uff0c/g, ","), n = n.replace(/\s/g, "").replace(/\uff0c/g, ","), (-1 != i.split(",").indexOf("" + this.videoData.cid) || c && -1 != n.split(",").indexOf("" + c)) && (this.timeLimit = this.channelInfo.timeLimit || 0);
                }
            } catch (w) {
                s.log(w);
            }
            this.timeLimit && this.timeLimit < this.duration && (this.duration = this.timeLimit), 0 == this.timeLimit ? o.isForceUseM3u8() ? (this.mediaType = "m3u8", this.playMode = "one") : o.isForceUseDownloadUrl() ? (this.mediaType = "mp4", this.playMode = "one", e.urls.mp4 = {}, e.urls.mp4.nor = e.urls.downloadUrl) : r.m3u8() ? (this.mediaType = "m3u8", this.playMode = "one") : (this.mediaType = "mp4", this.playMode = "segment") : a.ios ? (this.mediaType = "m3u8", this.playMode = "one") : (this.mediaType = "mp4", this.playMode = "segment"), this.addUrlParam(e.urls);
            var h = !1;
            if (e.urls) {
                var u = e.urls[this.mediaType],
                    p = e.durations;
                for (var m in u) {
                    if (this.mediaData[m] = [], u[m] instanceof Array) for (var f = u[m], v = 0, g = f.length; v < g; v++) {
                        var y = {
                            url: l.removeProtocol(f[v])
                        };
                        "m3u8" == this.mediaType ? y.duration = e.totalDuration || e.total_duration || -1 : y.duration = parseInt(p[m][v] || -1, 10), this.mediaData[m].push(y);
                    }!h && this.mediaData[m].length > 0 && (h = !0, this.count = this.mediaData[m].length);
                }
                if (!h) {
                    var y = {
                        url: ""
                    };
                    e.urls.downloadUrl && (y.url = l.removeProtocol(e.urls.downloadUrl[0] || "")), y.duration = parseInt(this.duration || -1, 10), this.mediaType = "mp4", this.playMode = "none", this.resolutionType = "nor", this.mediaData.nor = [y], this.count = this.mediaData.nor.length;
                }
                this.count > 0 && (this.index = 0), this.initResolution();
            }
            this.initEvent();
        },
        initResolution: function initResolution() {
            for (var e, t = 0, i = this.resolutionTypeList.length; t < i; t++) {
                if (e = this.resolutionTypeList[t], this.mediaData[e] && this.mediaData[e].length && (this.resolutionList.push(e), 0 === this.getMediaList().length)) {
                    this.resolutionType = e;
                    break;
                }
            }
        },
        addUrlParam: function addUrlParam(e) {
            var t = this.config,
                i = function i(e) {
                if (e && e.length) {
                    var i = l.getLQD(),
                        n = l.getLCODE();
                    e.forEach(function (a, o) {
                        a = a || "", -1 != a.indexOf("?") ? a += "&oth=" + i + "&cd=" + n : a += "?oth=" + i + "&cd=" + n, t.m3u8Params && (a += "&" + t.m3u8Params), e[o] = a;
                    });
                }
            };
            for (var n in e) {
                if (d.isObject(e[n])) for (var a in e[n]) {
                    i(e[n][a]);
                } else d.isArray(e[n]) && i(e[n]);
            }
        },
        initEvent: function initEvent() {
            this.player.on("segment.ended", function () {
                this.index += 1;
            }.bind(this)), this.player.on("reset", this.reset.bind(this));
        },
        reset: function reset() {
            this.index = 0;
        },
        getMediaList: function getMediaList() {
            return this.mediaData[this.resolutionType] || [];
        },
        hasNext: function hasNext() {
            return !!this.getMediaList()[this.index + 1];
        },
        setIndex: function setIndex(e) {
            this.index = e;
        },
        getMediaByIndex: function getMediaByIndex(e) {
            return void 0 === e && (e = this.index), this.getMediaList()[e];
        },
        getMediaByTime: function getMediaByTime(e) {
            if (void 0 !== e && !(e < 0 || e > this.duration)) {
                if ("one" == this.playMode) return {
                    media: getMediaByIndex(0),
                    index: 0,
                    t: e
                };
                var t,
                    i = this.index,
                    n = this.getMediaList(),
                    a = 0,
                    o = 0,
                    r = n.length,
                    s = 0,
                    d = 0;
                if (n.forEach(function (e) {
                    return d += e.duration;
                }), e > d) return o = r - 1, t = n[o], {
                    media: t,
                    index: o,
                    offset: t.duration,
                    change: i != o
                };
                for (; o < r; o++) {
                    if (t = n[o], a <= e && e <= a + t.duration) {
                        s = e - a;
                        break;
                    }
                    a += t.duration;
                }
                return {
                    media: t,
                    index: o,
                    offset: s,
                    change: i != o
                };
            }
        },
        getNext: function getNext() {
            return this.getMediaList()[this.index + 1];
        },
        getOffsetDuration: function getOffsetDuration() {
            for (var e = this.getMediaList(), t = 0, i = this.index, n = 0; t < i; t++) {
                n += e[t].duration;
            }return n;
        },
        hasResolution: function hasResolution(e) {
            for (var t = this.resolutionList, i = 0, n = t.length; i < n; i++) {
                if (e == t[i]) {
                    !0;
                    break;
                }
            }return !0;
        },
        switchResolution: function switchResolution(e) {
            this.hasResolution(e) && (this.resolutionType = e);
        },
        initLive: function initLive(e) {
            if (d.extend(this, {
                vid: e.vid,
                duration: parseInt(e.totalDuration || e.total_duration || 0, 10),
                title: e.tvname || e.videoName || e.video_name || "",
                playcount: e.playCount || e.play_count || 0
            }), this.timeLimit && this.timeLimit < this.duration && (this.duration = this.timeLimit), 0 == this.timeLimit ? o.isForceUseM3u8() ? (this.mediaType = "m3u8", this.playMode = "one") : o.isForceUseDownloadUrl() ? (this.mediaType = "mp4", this.playMode = "one", e.urls.mp4 = {}, e.urls.mp4.nor = l.removeProtocol(e.urls.downloadUrl)) : r.m3u8() ? (this.mediaType = "m3u8", this.playMode = "one") : (this.mediaType = "mp4", this.playMode = "segment") : a.ios ? (this.mediaType = "m3u8", this.playMode = "one") : (this.mediaType = "mp4", this.playMode = "segment"), e.urls) {
                var t = (e.urls, e.durations, {
                    url: ""
                });
                e.urls.length && (t.url = l.removeProtocol(e.urls[0].url || "")), t.duration = parseInt(this.duration || -1, 10), this.mediaType = "mp4", this.playMode = "none", this.resolutionType = "nor", this.mediaData.nor = [t], this.count = this.mediaData.nor.length, this.count > 0 && (this.index = 0), this.initResolution();
            }
            this.initEvent();
        }
    }), e.exports = n;
}, function (e, t, i) {
    "use strict";

    !function () {
        Function.prototype.bind || (Function.prototype.bind = function (e) {
            if ("function" != typeof this) throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
            var t = Array.prototype.slice.call(arguments, 1),
                i = this,
                n = function n() {},
                a = function a() {
                return i.apply(this instanceof n && e ? this : e, t.concat(Array.prototype.slice.call(arguments)));
            };
            return n.prototype = this.prototype, a.prototype = new n(), a;
        });
    }();
    var n = i(35),
        a = {
        createPlayer: function createPlayer(e, t) {
            return new n(e, t);
        }
    };
    e.exports = a;
}, function (e, t, i) {
    "use strict";

    function n(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    var a = function () {
        function e(e, t) {
            for (var i = 0; i < t.length; i++) {
                var n = t[i];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), define_property_default()(e, n.key, n);
            }
        }
        return function (t, i, n) {
            return i && e(t.prototype, i), n && e(t, n), t;
        };
    }(),
        o = i(1).os,
        r = function () {
        function e(t, i) {
            var a = this;
            n(this, e), this.player = t, this.config = i, this.el = this.player.el.querySelector(".x-player");
            var r = function () {
                var e;
                return "onfullscreenchange" in document ? e = "fullscreenchange" : "onwebkitfullscreenchange" in document ? e = "webkitfullscreenchange" : "onmozfullscreenchange" in document ? e = "mozfullscreenchange" : "msRequestFullscreen" in document && (e = "MSFullscreenChange"), e;
            }();
            o.ios || (this.player.video.addEventListener(r, function (e) {
                a.isVideoFullscreen() || a.exitFancyFullscreen();
            }, !1), document.addEventListener(r, function (e) {
                a.isNativeFullscreen() || a.exitFancyFullscreen();
            }, !1));
        }
        return a(e, [{
            key: "requestFullscreen",
            value: function value() {
                var e = navigator.userAgent.toLowerCase();
                if (!o.ios && -1 != e.indexOf("sohunews")) return this.requestFancyFullscreen();
                var t = this.el;
                t.requestFullscreen ? t.requestFullscreen() : t.webkitRequestFullscreen ? t.webkitRequestFullscreen() : t.mozRequestFullScreen ? t.mozRequestFullScreen() : t.msRequestFullscreen && t.msRequestFullscreen(), this.isNativeDOMFullscreen() || this.requestVideoNativeFullscreen(), this.isNativeFullscreen() || this.requestFancyFullscreen(), o.ios || this.requestFancyFullscreen();
            }
        }, {
            key: "exitFullscreen",
            value: function value() {
                this.exitFancyFullscreen();
                this.el;
                document.exitFullscreen ? document.exitFullscreen() : document.webkitCancelFullScreen ? document.webkitCancelFullScreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.msExitFullscreen ? document.msExitFullscreen() : document.cancelFullScreen && document.cancelFullScreen(), this.exitVideoNativeFullscreen();
            }
        }, {
            key: "requestVideoNativeFullscreen",
            value: function value() {
                try {
                    this.player.video.requestFullscreen ? this.player.video.requestFullscreen() : this.player.video.webkitEnterFullscreen();
                } catch (e) {}
            }
        }, {
            key: "exitVideoNativeFullscreen",
            value: function value() {
                this.player.video.webkitExitFullscreen();
            }
        }, {
            key: "requestFancyFullscreen",
            value: function value() {
                (document.documentElement || document.body).classList.add("x-fancy-fs"), this.el.classList.add("x-player-fancy-fs");
            }
        }, {
            key: "exitFancyFullscreen",
            value: function value() {
                (document.documentElement || document.body).classList.remove("x-fancy-fs"), this.el.classList.remove("x-player-fancy-fs");
            }
        }, {
            key: "isNativeFullscreen",
            value: function value() {
                return this.isNativeDOMFullscreen() || this.isVideoFullscreen();
            }
        }, {
            key: "isNativeDOMFullscreen",
            value: function value() {
                return (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) == this.el;
            }
        }, {
            key: "isVideoFullscreen",
            value: function value() {
                return (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) == this.player.video || !!this.player.video.webkitDisplayingFullscreen;
            }
        }]), e;
    }();
    e.exports = r;
}, function (e, t, i) {
    "use strict";

    function n(e, t) {
        this.player = e, this.originalConfig = t, this.config = t || {}, this.list = this.config.list || [];
    }
    var a = i(2);
    a.extend(n.prototype, {
        hasNext: function hasNext() {
            var e = this.indexOf();
            return -1 == e ? !!this.list.length : e != this.list.length - 1;
        },
        getNext: function getNext() {
            if (this.hasNext()) {
                var e = this.indexOf();
                return this.list[e + 1];
            }
        },
        append: function append() {
            var e = [].slice.call(arguments),
                t = this.list;
            e.forEach(function (e) {
                a.isArray(e) ? t = t.concat(e) : a.isObject(e) && t.push(e);
            }), this.list = t;
        },
        replace: function replace(e) {
            this.list = e || [];
        },
        indexOf: function indexOf(e) {
            var t = this.player.videoData,
                i = this.list,
                n = 0,
                a = i.length,
                o = -1;
            for (e = e || t.vid; n < a; n++) {
                if (i[n].vid == e) {
                    o = n;
                    break;
                }
            }return o;
        },
        clear: function clear() {
            this.list = [];
        }
    }), e.exports = n;
}, function (e, t, i) {
    "use strict";

    function n(e, t) {
        this.player = e, this.config = t || {};
        var i = this.getVideoData();
        this.qfDomain = (Math.random() > .5 ? "qf1" : "qf2") + ".hd.sohu.com.cn", this.qcURL = null !== p.getQueryString("r") && i ? "//sptjs1.hd.sohu.com.cn/h5/tttst.html" : "//qc.hd.sohu.com.cn/caton/video/", this.playId = +new Date(), l.extend(this, {
            realVVDone: !1,
            vvDone: !1,
            endedDone: !1,
            heartTimer: null
        }), this.heartTime = 3e4, r.is56 && (this.heartTime = 12e4), this.init();
    }
    var a = i(1).os,
        o = i(1).browser,
        r = i(9),
        s = (i(6), i(15)),
        d = i(4),
        l = i(2),
        c = i(11),
        h = i(13),
        u = i(39),
        p = i(5),
        m = r.ScreenSize,
        f = 44,
        v = "";
    a.ipad ? (f = 4, v = "1h5") : a.iphone ? (f = 41, v = "3h5") : a.android ? (f = 42, v = "6h5") : a.wp ? (f = 43, v = "11h5") : o.ie && (f = 43);
    var g = function (e) {
        var t = 0;
        try {
            window.top.location.href;
        } catch (i) {
            t = 1;
        }
        return t;
    }();
    l.extend(n.prototype, {
        qcPlat: v,
        platType: f,
        init: function init() {
            this.observPlayer();
        },
        observPlayer: function observPlayer() {
            var e = this;
            this.player.on("reset", this.reset.bind(this)), this.player.on("data.ok", function () {
                r.isExternal && !e.config.autoplay || e.startVV();
            }), this.player.on("player.start", function () {
                return e.startVV();
            }), this.player.on("timeupdate", function () {
                this.player.isPlayingAD || (this.realVV(), this.heartTimer || (this.heartTimer = setInterval(function () {
                    this.heart();
                }.bind(this), this.heartTime)));
            }.bind(this)), this.player.on("ended", function () {
                var e = this.player.getCurrentTime();
                this.ended(e, this.player.bufferCount);
            }.bind(this)), this.player.on("error", function (e) {
                this.qcPingback("code=8&errorcode=" + e.code + "&currentTime=" + this.player.getCurrentTime());
            }.bind(this)), this.player.on("buffer", function (e) {
                e < 1 || (1 == e ? this.qcPingback("code=6") : this.qcPingback("code=4"));
            }.bind(this));
        },
        getVideoData: function getVideoData() {
            return this.player.videoData;
        },
        getVideoSrc: function getVideoSrc() {
            var e = this.getVideoData(),
                t = this.player.video && this.player.video.src;
            return e.video_src || t || "";
        },
        qcPingback: function qcPingback(e) {
            var t = "",
                i = "",
                n = r.uid,
                o = this.player.dataModel || {},
                s = this.getVideoData(),
                l = this.getVideoSrc(),
                c = o.mediaType || "",
                h = s.plid || s.aid || s.sid || "";
            a.ios ? t = 1 : a.android ? t = 2 : a.wp && (t = 3), a.ipad ? i = "ipad" : a.ipod ? i = "ipod" : a.iphone ? i = "iphone" : a.wp && (i = "windowsphone");
            var p = new Date().getTime(),
                m = u("" + s.vid % 127 + n + p % 127);
            e += "&uid=" + n + "&poid=&plat=" + this.qcPlat + "&sver=" + a.version + "&os=" + t + "&sysver=" + a.version + "&net=" + d.getConnectionType() + "&playmode=&tvid=" + (s.tvid || "") + "&vid=" + (s.vid || "") + "&sid=" + h + "&vtype=" + c + "&pn=" + i + "&duFile=" + encodeURIComponent(l) + "&version=" + (s.videoVersion || 0) + "&isp2p=0&ltype=0&site=" + (s.site || 1) + "&time=" + p + (o.ugcode ? "&ugcode2=" + o.ugcode : "") + (o.ugu ? "&ugu2=" + o.ugu : "") + "&ts=" + m, d.pingback(this.qcURL + "?" + e);
        },
        qfPingback: function qfPingback(e) {
            var t = this.getVideoData(),
                i = this.player.dataModel || {};
            e += "&seekto=0&pt=" + this.platType + "&sid=" + r.uid + "&tvid=" + (t.tvid || "") + "&vid=" + (t.vid || "") + "&nid=" + (t.nid || "") + "&ref=" + encodeURIComponent(location.href) + "&dom=" + (i.ugcode ? "&ugcode2=" + i.ugcode : "") + (i.ugu ? "&ugu2=" + i.ugu : "") + "&t=" + +new Date(), d.pingback("//" + this.qfDomain + "/dov.do?method=stat" + e);
        },
        DMPingback: function DMPingback(e, t, i) {
            var n = this.getVideoData(),
                o = this.player.dataModel || {},
                c = d.getChanneled(),
                u = location.href,
                f = n.plid || n.aid || n.sid || "",
                v = this.player.dataModel ? this.player.dataModel.mcode || "" : "";
            e = l.extend({
                url: encodeURIComponent(u),
                refer: p.getParam("landingrefer") || encodeURIComponent(document.referrer),
                uid: r.uid,
                webtype: d.getConnectionType(),
                screen: m,
                muid: r.muid,
                catecode: n.cateCode,
                pid: f,
                tvid: n.tvid || "",
                vid: n.vid,
                cateid: n.cid,
                ltype: n.ltype,
                company: n.company,
                version: 0,
                type: 9001 == n.cid ? "my" : "vrs",
                td: n.duration || 0,
                apikey: r.API_KEY,
                t: +new Date(),
                os: a.type,
                platform: a.platform,
                passport: s.getPassport(),
                channeled: c,
                site: n.site || 1,
                playid: +this.playId,
                nid: n.nid || "",
                mcode: v,
                MTV_SRC: encodeURIComponent(h.getSrc()),
                oth: d.getLQD(),
                cd: d.getLCODE(),
                isout: g
            }, e), o.ugcode && (e.ugcode2 = o.ugcode), o.ugu && (e.ugu2 = o.ugu);
            var y = p.getParam("columnid");
            y && (i || (i = {}), i.columnId = y), i && (e.details = stringify_default()(i)), n.liveId && (e.cid = "9002"), d.pingback((t || "//z.m.tv.sohu.com/vv.gif") + "?" + p.stringify(e)), window.flashStatistId && (e.channeled = window.flashStatistId, d.pingback((t || "//z.m.tv.sohu.com/vv.gif") + "?" + p.stringify(e)));
        },
        DMPingback56: function DMPingback56(e) {
            var t = this.getVideoData(),
                i = this.player.dataModel || {},
                n = 2 == t.site ? "my" : "vrs",
                o = t.ltype || 0,
                c = 2 == t.site ? 1 : 0,
                u = p.getParam("landingrefer") || encodeURIComponent(document.referrer),
                f = encodeURIComponent(location.href),
                v = d.getChanneled();
            e = l.extend({
                cts: "isow",
                isHD: 0,
                time: 0,
                ua: "h5",
                isp2p: 0,
                sid: t.sid,
                uid: r.uid,
                pid: t.pid || "",
                tvid: t.tvid || "",
                vid: t.vid,
                nid: t.nid || "",
                type: n,
                ltype: o,
                company: t.company || "",
                url: f,
                td: t.duration || 0,
                cateid: t.cateid || "",
                catcode: t.cateCode || "",
                refer: u,
                systype: c,
                os: a.type,
                platform: a.platform,
                passport: s.getPassport(),
                channeled: v,
                screen: m,
                webtype: d.getConnectionType(),
                MTV_SRC: encodeURIComponent(h.getSrc()),
                apikey: r.API_KEY,
                fver: "",
                isout: g,
                t: new Date().getTime()
            }, e), i.ugcode && (e.ugcode2 = i.ugcode), i.ugu && (e.ugu2 = i.ugu), d.pingback("//pb.hd.sohu.com.cn/hdpb.gif?" + p.stringify(e));
        },
        startVV: function startVV() {
            this.vv(), (a.ios && (o.uc || o.qq) || o.baiduboxapp) && (this.realVV(), this.heartTimer || (this.heartTimer = setInterval(function () {
                this.heart();
            }.bind(this), this.heartTime)));
        },
        vv: function vv() {
            if (!this.vvDone) {
                this.vvDone = !0;
                var e = this.getVideoData(),
                    t = 10;
                e && "undefined" != typeof e.duration && (t = e.duration), this.qfPingback("&error=0&code=2&allno=0&vvmark=1&totTime=" + t), r.IS_EXTERNAL_PLAYER || d.pingback(("https:" == document.location.protocol ? "https://sb" : "http://b") + ".scorecardresearch.com/b?c1=1&c2=7395122&c3=&c4=&c5=&c6=&c11=" + r.uid), r.is56 ? this.DMPingback56({
                    msg: "playCount"
                }) : this.DMPingback({
                    site: e.site || 1,
                    msg: "playCount",
                    time: "0"
                }), this.playId = +new Date(), this.qcPingback("code=10&duation=0"), c.pingback("play_verify"), c.pingback("play_ablum_video");
            }
        },
        realVV: function realVV(e) {
            if (!this.realVVDone) {
                this.realVVDone = !0;
                var t = e ? (+new Date() - e) / 1e3 : 0;
                this.getVideoData();
                r.is56 ? this.DMPingback56({
                    msg: "videoStart"
                }) : this.DMPingback({
                    msg: "videoStart",
                    time: (+new Date() - this.playId) / 1e3
                }), this.qcPingback("code=5&duation=" + t);
            }
        },
        heart: function heart() {
            var e = Math.round(this.player.getCurrentTime());
            r.is56 ? this.heart56(e) : this.DMPingback({
                tc: e
            }, "//z.m.tv.sohu.com/playtime.gif");
        },
        heart56: function heart56(e) {
            var t = this.getVideoData(),
                i = this.player.dataModel || {},
                n = 2 == t.site ? "my" : "vrs",
                o = t.ltype || 0,
                l = 2 == t.site ? 1 : 0,
                c = p.getParam("landingrefer") || encodeURIComponent(document.referrer),
                u = encodeURIComponent(location.href),
                f = d.getChanneled(),
                v = {
                cts: "isow",
                isHD: 0,
                time: e || 0,
                ua: "h5",
                heart: 120,
                isp2p: 0,
                sid: t.sid,
                uid: r.uid,
                pid: t.pid || "",
                tvid: t.tvid || "",
                vid: t.vid,
                nid: t.nid || "",
                type: n,
                ltype: o,
                company: t.company || "",
                url: u,
                td: t.duration || 0,
                cateid: t.cateid || "",
                catcode: t.cateCode || "",
                refer: c,
                systype: l,
                apikey: r.API_KEY,
                fver: "",
                os: a.type,
                platform: a.platform,
                passport: s.getPassport(),
                channeled: f,
                screen: m,
                webtype: d.getConnectionType(),
                MTV_SRC: encodeURIComponent(h.getSrc()),
                t: new Date().getTime()
            };
            i.ugcode && (v.ugcode2 = i.ugcode), i.ugu && (v.ugu2 = i.ugu), d.pingback("//pb.hd.sohu.com.cn/stats.gif?" + p.stringify(v));
        },
        ended: function ended(e, t) {
            this.endedDone || (this.endedDone = !0, r.is56 ? this.DMPingback56({
                msg: "videoEnds",
                time: e
            }) : this.DMPingback({
                msg: "videoEnds",
                time: e
            }), this.qcPingback("code=7&duration=" + e + "&ct=" + t));
        },
        reset: function reset() {
            this.realVVDone = !1, this.vvDone = !1, this.endedDone = !1, clearInterval(this.heartTimer), this.heartTimer = null;
        }
    }), e.exports = n;
}, function (e, t, i) {
    "use strict";

    function n(e) {
        return (u[e] || "") + "\uFF08" + e + "\uFF09";
    }
    function a(e) {
        if (!isNaN(e)) {
            e = parseInt(e || 0);
            var t = "" + Math.floor(e / 60);
            return e = "" + e % 60, t.length < 2 && (t = "0" + t), e.length < 2 && (e = "0" + e), t + ":" + e;
        }
    }
    function o(e, t) {
        this.superClass.constructor.call(this), this.player = e, this.originalConfig = t, this.config = t || {}, this.el = this.player.el, this.tmpl = new r(y.player), this.resolutionTmpl = new r(w), this.recommendTmpl = new r(b), this.adv = this.player.adv, this.isDragging = !1, this.idleTimer = null, this.timeupdateCount = 0, this.clickOrPlayFlag = !1, this.init();
    }
    var r = i(12),
        s = (i(24), i(1).browser),
        d = i(1).os,
        l = i(2),
        c = i(31),
        h = i(10),
        u = i(23),
        p = i(13),
        m = i(16),
        f = i(11),
        v = i(14).EventEmitter,
        g = i(29),
        y = {};
    y.video = function () {
        return '<div class="x-video x-video-hide"><video webkit-playsinline x-webkit-airplay="isHtml5UseAirPlay" ></video></div>';
    }, y.ctrl = function () {
        return '<div class="x-ctrl-container"><div class="x-dashboard"><div class="x-playbtn-wrap"><div class="x-play-btn"></div><div class="x-pause-btn"></div></div><div class="x-progress-panel"><div class="x-progress-live-txt">LIVE</div></div><div class="x-fsbtn-wrap"><div class="x-fs-btn"></div><div class="x-exit-fs-btn"></div></div></div></div>';
    }, y.ad = function () {
        return "<div class=x-ad-panel><a class=\"x-ad-link\" target=\"_blank\" href=\"#\">\u8BE6\u60C5&gt;</a><div class=\"x-cover-playbtn\"></div><div class=\"x-ad-time-wrap\"><div class=\"x-ad-time\"></div><div class=\"x-ad-fee-btn\">\u514D\u8D39\u53BB\u5E7F\u544A</div></div></div>";
    }, y.resolution = function () {
        return '<div class="x-resolution-panel"></div>';
    }, y.loading = function () {
        return "<div class=\"x-player-loading-panel\"><div class=\"x-player-loading\"></div><div class=\"x-player-loading-notice\">\u52AA\u529B\u52A0\u8F7D\u4E2D,\u8BF7\u7A0D\u540E...</div></div>";
    }, y.player = '<%@ h:helper %><div class="x-player">' + y.video() + "<div class=\"x-poster\"></div><div class=\"x-info-panel\"><div class=\"x-title\"></div><div class=\"x-playcount\"></div></div><div class=\"x-timelimit-panel\"><mark>\u8BD5\u770B</mark><span class=\"x-limit-time\"></span></div>" + y.ctrl() + y.loading() + y.ad() + "<div class=\"x-cover-playbtn-wrap\"><div class=\"x-cover-playbtn\"></div></div><div class=\"x-recommend-panel\"><div class=\"x-replay-panel\"><div class=\"x-replay-btn\"><mark>\u8BD5\u770B\u7ED3\u675F\uFF0C</mark><em>\u6253\u5F00APP\u770B\u5B8C\u6574\u7248</em></div></div><div class=\"x-recommend-list-wrap\"></div></div><div class=\"x-message-panel\"><div class=\"x-message-frame\"></div><div class=\"x-message-btn-frame\"><div class=\"x-msg-txt\"></div><button class=\"x-msg-app-btn\">\u4E0B\u8F7D\u641C\u72D0\u89C6\u9891\u5BA2\u6237\u7AEF</button></div></div><div class=\"x-liveend-panel\"><div class=\"x-liveend-msg\"><div class=\"x-liveend-txt1\">\u76F4\u64AD\u7ED3\u675F</div><div class=\"x-liveend-txt2\">\u5B89\u88C5<button class=\"x-liveend-msg-app-btn\">\u641C\u72D0\u89C6\u9891APP</button>\u89C2\u770B\u66F4\u591A\u76F4\u64AD</div></div></div><div class=\"x-bigplaybtn-panel\"></div><a class=\"x-download-panel x-dl-shake\"><div class=\"x-download-intro\"><img src=\"//css.tv.itc.cn/m/img/logo_download.png\" class=\"logo\"><img src=\"//css.tv.itc.cn/m/img/player/dlTxt.png\" class=\"txt\"></div><div class=\"x-download-btn\">\u7ACB\u5373\u5B89\u88C5</div><div class=\"btn-close\"></div></a></div>";
    var w = '<%@ h:helper %><% var i = 0, len = resolutionList.length, resolution, title;%><% for (; i < len; i++) { %><%resolution = resolutionList[i];title = RESOLUTION_MODE[resolution];%><div class="x-resolution-item<%= resolution == currentResolution ? " on" : "" %>" data-resolution="<%= resolution %>"><%= title %></div><% } %>',
        b = '<%@ h:helper %><% var i = 0, len = videos.length, video; %><ul class="x-recommend-list"><% for(; i < len; i++) {%><% video = videos[i]; %><li class="x-recommend-item"><a href="<%= video.videoUrl %>"><img src="<%= video.v_320_180 %>"><p><%= video.videoName %></p></a></li><% } %></ul>';
    l.inherit(o, v, {
        init: function init() {
            this.el.innerHTML = this.tmpl.render({
                config: this.config
            }), this.loadingPanle = this.el.querySelector(".x-player-loading-panel"), this.ctrlContainer = this.el.querySelector(".x-ctrl-container"), this.elposter = this.el.querySelector(".x-poster"), this.coverPlayBtnWrap = this.el.querySelector(".x-cover-playbtn-wrap"), this.elDashboard = this.el.querySelector(".x-dashboard"), this.xvideoEl = this.el.querySelector(".x-video"), this.adPanel = this.el.querySelector(".x-ad-panel"), this.adLink = this.adPanel.querySelector("a"), this.adTime = this.adPanel.querySelector(".x-ad-time"), this.adFeeBtn = this.adPanel.querySelector(".x-ad-fee-btn"), this.adCoverBtn = this.adPanel.querySelector(".x-cover-playbtn"), this.playBtn = this.el.querySelector(".x-play-btn"), this.pauseBtn = this.el.querySelector(".x-pause-btn"), this.fsBtn = this.el.querySelector(".x-fs-btn"), this.exitFsBtn = this.el.querySelector(".x-exit-fs-btn"), this.infoPanel = this.el.querySelector(".x-info-panel"), this.elTitle = this.infoPanel.querySelector(".x-title"), this.messagePanel = this.el.querySelector(".x-message-panel"), this.messageFrame = this.el.querySelector(".x-message-frame"), this.messageBtnFrame = this.el.querySelector(".x-message-btn-frame"), this.appBtn = this.el.querySelector(".x-msg-app-btn"), this.timelimitPanel = this.el.querySelector(".x-timelimit-panel"), this.elTimeLimit = this.timelimitPanel.querySelector(".x-limit-time"), this.replayPanel = this.el.querySelector(".x-replay-panel"), this.recommendPanel = this.el.querySelector(".x-recommend-panel"), this.downloadPanel = this.el.querySelector(".x-download-panel"), this.bigplayPanel = this.el.querySelector(".x-bigplaybtn-panel"), this.livedEndPanel = this.el.querySelector(".x-liveend-panel"), this.liveAppBtn = this.el.querySelector(".x-liveend-msg-app-btn"), this.initEvent();
        },
        enableSeek: function enableSeek() {},
        initEvent: function initEvent() {
            this.observPlayer();
            var e = this.player,
                t = function () {
                var e;
                return "onfullscreenchange" in document ? e = "fullscreenchange" : "onwebkitfullscreenchange" in document ? e = "webkitfullscreenchange" : "onmozfullscreenchange" in document ? e = "mozfullscreenchange" : "msRequestFullscreen" in document && (e = "MSFullscreenChange"), e;
            }();
            t && document.addEventListener(t, this.onfullscreenchange.bind(this)), this.coverPlayBtnWrap.addEventListener("click", function (t) {
                this.onClickPlay(), e.play(), t.stopPropagation();
            }.bind(this)), this.adLink.addEventListener("click", function () {
                var e = this.adLink.getAttribute("data-pingback");
                this.player.adv.pingback(e), this.player.pause();
            }.bind(this)), this.adCoverBtn.addEventListener("click", function () {
                c.hide(this.adCoverBtn), this.clickOrPlayFlag = !0, this.player.play();
            }.bind(this)), this.ctrlContainer.addEventListener("click", function () {
                this.isDashBoardShowed() ? this.hideDashBoard() : this.showDashBoard();
            }.bind(this)), this.playBtn.addEventListener("click", function () {
                e.play();
            }), this.pauseBtn.addEventListener("click", function () {
                e.pause();
            }), this.fsBtn.addEventListener("click", function () {
                e.requestFullscreen(), e.play();
            }), this.exitFsBtn.addEventListener("click", function () {
                e.exitFullscreen();
            }), this.elDashboard.addEventListener("click", function (e) {
                this.showDashBoard(), e.stopPropagation();
            }.bind(this)), this.appBtn.addEventListener("click", function (e) {
                s.wx ? window.apptips && window.apptips.callApp() : window.apptips.callApp("appdownload_banner_open"), e.stopPropagation();
            }), this.liveAppBtn.addEventListener("click", function (e) {
                s.wx ? window.apptips && window.apptips.callApp() : window.apptips.callApp("appdownload_banner_open"), e.stopPropagation();
            }), this.replayPanel.addEventListener("click", function (e) {
                s.wx ? window.apptips && window.apptips.callApp() : m.gotoDownload(), e.stopPropagation();
            }.bind(this)), this.adFeeBtn.addEventListener("click", function () {
                f.pingback("appdownload_adRemove"), e.pause(), this.appActions();
            }.bind(this)), this.downloadPanel.addEventListener("click", function (e) {
                f.pingback("appdownload_pause"), e.target.classList.contains("btn-close") ? (c.hide(e.currentTarget), this.showDashBoard()) : window.apptips ? window.apptips.callApp() : this.appActions();
            }.bind(this)), this.bigplayPanel.addEventListener("click", function (t) {
                this.showDashBoard(), e.play();
            }.bind(this));
        },
        appActions: function appActions() {
            p.loadChannelInfo().then(function (e) {
                if ("1" === e.startapp) {
                    var t = m.parserAttributes();
                    t.type = "click";
                    try {
                        var i = m.sendAction(t);
                    } catch (n) {
                        alert(n);
                    }
                    i && i.then(function (e) {
                        e && !s.sohuVideoApp && m.gotoDownload();
                    });
                } else s.sohuVideoApp || m.gotoDownload();
            });
        },
        observPlayer: function observPlayer() {
            this.player.on("waiting", function () {
                this.clickOrPlayFlag && this.showLoading(), g.loadData(window.videoData).then(function (e) {
                    200 == e.code && (e.data.videoData.urls.length || (this.hideLoading(), this.player.exitFullscreen(), this.liveEnded()));
                }.bind(this));
            }.bind(this)), this.player.on("playing", this.onPlaying.bind(this)), this.player.on("error", this.onError.bind(this)), this.player.on("data.loading", this.showLoading.bind(this)), this.player.on("data.loaded", this.hideLoading.bind(this)), this.player.on("data.exception", this.onDataException.bind(this)), this.player.on("data.ok", this.updateUI.bind(this)), this.player.on("player.start", this.onStart.bind(this)), this.player.on("timeupdate", this.onTimeupdate.bind(this)), this.player.on("adv.ended", function () {
                this.hideADUI(), this.showTimeLimitPanel();
            }.bind(this)), this.player.on("pause", this.onPause.bind(this)), this.player.on("play", this.onPlay.bind(this)), this.player.on("reset", this.reset.bind(this)), this.player.on("timelimit", function (e) {
                this.elTimeLimit.innerHTML = a(e);
            }.bind(this)), this.player.on("recommend.loaded", function (e) {
                c.show(this.recommendPanel), this.recommendPanel.querySelector(".x-recommend-list-wrap").innerHTML = this.recommendTmpl.render({
                    videos: e || []
                });
            }.bind(this)), this.player.on("ended", function () {
                this.reset(), c.show(this.livedEndPanel);
            }.bind(this));
        },
        onfullscreenchange: function onfullscreenchange(e) {
            var t = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
            t == this.el.querySelector(".x-player") ? (c.hide(this.fsBtn), c.show(this.exitFsBtn)) : null == t && (c.hide(this.exitFsBtn), c.show(this.fsBtn));
        },
        showTimeLimitPanel: function showTimeLimitPanel() {
            this.player.dataModel.timeLimit && c.show(this.timelimitPanel);
        },
        hideTimeLimitPanel: function hideTimeLimitPanel() {
            c.hide(this.timelimitPanel);
        },
        showDashBoard: function showDashBoard() {
            c.show(this.elDashboard), c.show(this.infoPanel), this.hideDashboardDelay(), this.hideTimeLimitPanel();
        },
        hideDashBoard: function hideDashBoard() {
            c.hide(this.elDashboard), c.hide(this.infoPanel), this.showTimeLimitPanel();
        },
        hideDashboardDelay: function hideDashboardDelay() {
            clearTimeout(this.idleTimer), this.idleTimer = setTimeout(function () {
                this.hideDashBoard();
            }.bind(this), 4e3);
        },
        isDashBoardShowed: function isDashBoardShowed() {
            return "none" != c.css(this.elDashboard, "display");
        },
        showLoading: function showLoading() {
            c.show(this.loadingPanle);
        },
        hideLoading: function hideLoading() {
            c.hide(this.loadingPanle);
        },
        onTimeupdate: function onTimeupdate() {
            if (d.ios && s.qq && (this.hideLoading(), c.show(this.adCoverBtn)), this.clickOrPlayFlag = !0, this.player.isPlayingAD) {
                if (0 == this.timeupdateCount) return void (this.timeupdateCount += 1);
                this.updateADUI();
            } else this.hideADUI(), this.updateProgress();
            c.hide(this.messagePanel);
        },
        onPlay: function onPlay() {
            c.hide(this.playBtn), c.show(this.pauseBtn), c.hide(this.adCoverBtn), c.hide(this.downloadPanel), c.hide(this.bigplayPanel);
        },
        onPause: function onPause() {
            this.player.isPlayingAD ? c.show(this.adCoverBtn) : (c.show(this.playBtn), c.hide(this.pauseBtn), c.show(this.downloadPanel), c.show(this.bigplayPanel), this.showDashBoard(), clearTimeout(this.idleTimer));
        },
        onPlaying: function onPlaying() {
            this.hideLoading(), c.hide(this.elposter), c.hide(this.coverPlayBtnWrap), c.hide(this.infoPanel), c.removeClass(this.xvideoEl, "x-video-hide"), c.hide(this.playBtn), c.show(this.pauseBtn);
        },
        onError: function onError(e) {
            if (this.hideLoading(), this.reset(), h.log("\u64AD\u653E\u5931\u8D25-->", e), !this.player.dataModel.videoData.urls.length) return void this.liveEnded();
            g.loadData(window.videoData).then(function (t) {
                if (200 == t.code && !t.data.videoData.urls.length) return this.hideLoading(), this.player.exitFullscreen(), void this.liveEnded();
                3 == e.code || 4 == e.code ? (this.messageBtnFrame.querySelector(".x-msg-txt").innerHTML = n(e.code), c.hide(this.messageFrame), c.show(this.messageBtnFrame)) : (this.messageFrame.innerHTML = n(e.code || "400"), c.hide(this.messageBtnFrame), c.show(this.messageFrame)), c.show(this.messagePanel);
            }.bind(this));
        },
        onDataException: function onDataException(e) {
            100 == e.code || 102 == e.code ? (this.messageBtnFrame.querySelector(".x-msg-txt").innerHTML = n(e.code), c.show(this.messagePanel), c.show(this.messageBtnFrame), c.hide(this.messageFrame)) : (this.messageFrame.innerHTML = n(e.code || "400"), c.show(this.messagePanel), c.show(this.messageFrame), c.hide(this.messageBtnFrame));
        },
        onClickPlay: function onClickPlay() {
            this.showLoading(), c.hide(this.coverPlayBtnWrap), c.hide(this.infoPanel), c.hide(this.recommendPanel), c.removeClass(this.xvideoEl, "x-video-hide");
        },
        onStart: function onStart() {
            c.removeClass(this.xvideoEl, "x-video-hide"), c.hide(this.recommendPanel);
        },
        updateProgress: function updateProgress() {
            this.updateBufferedTrack(), this.updateTime(), this.isDragging || this.updatePlayedTrack();
        },
        updateTime: function updateTime() {
            var e = this.player,
                t = e.getCurrentTime(),
                i = e.getDuration();
            this.elTimeLimit.innerHTML = a(Math.floor(i - t)), this.isDashBoardShowed() ? this.hideTimeLimitPanel() : this.showTimeLimitPanel();
        },
        updateUI: function updateUI() {
            var e = this.player,
                t = (e.getDuration(), this.player.dataModel);
            if (t.poster && (this.elposter.style.backgroundImage = "url(" + t.poster + ")"), this.elTitle.innerHTML = t.title, !t.videoData.urls.length) return void this.liveEnded();
            c.show(this.elposter), c.show(this.infoPanel), c.show(this.coverPlayBtnWrap);
        },
        updateADUI: function updateADUI() {
            var e = this.player.adv,
                t = e.getDataByIndex(),
                i = e.getCurrentTime(),
                n = e.duration;
            t && (c.show(this.adPanel), this.adTime.innerHTML = "<b>" + Math.ceil(Math.max(n - i, 0)) + "</b>", t.clickurl ? (c.show(this.adLink), this.adLink.href = t.clickurl, this.adLink.setAttribute("data-pingback", t.cp)) : c.hide(this.adLink), s.wx && c.hide(this.adFeeBtn), c.hide(this.timelimitPanel));
        },
        hideADUI: function hideADUI() {
            c.hide(this.adPanel);
        },
        reset: function reset() {
            c.show(this.elposter), c.show(this.infoPanel), c.hide(this.coverPlayBtnWrap), c.hide(this.downloadPanel), c.hide(this.bigplayPanel), setTimeout(function () {
                c.hide(this.elDashboard);
            }.bind(this), 100), c.hide(this.messagePanel), c.hide(this.adPanel), c.hide(this.timelimitPanel), c.hide(this.recommendPanel), c.addClass(this.xvideoEl, "x-video-hide"), this.timeupdateCount = 0, this.clickOrPlayFlag = !1;
        },
        liveEnded: function liveEnded() {
            this.player.off("timeupdate"), this.player.off("pause"), this.player.off("waiting"), this.reset(), c.show(this.livedEndPanel), this.player.emit("ended");
        }
    }), e.exports = o;
}, function (e, t, i) {
    "use strict";

    function n(e, t) {
        this.superClass.constructor.call(this), this.player = e, this.originalConfig = t, this.config = t || {}, this.el = this.player.el, this.tmpl = new o(s), this.init();
    }
    var a = i(2),
        o = i(12),
        r = i(14).EventEmitter,
        s = '<%@ h:helper %><div class="x-player"><div class="x-video"><video controls webkit-playsinline x-webkit-airplay="isHtml5UseAirPlay" <%= config.autoplay ? "autoplay" : "" %> ></video></div></div>';
    a.inherit(n, r, {
        init: function init() {
            this.el.innerHTML = this.tmpl.render({
                config: this.config
            });
        },
        reset: function reset() {}
    }), e.exports = n;
}, function (e, t, i) {
    "use strict";

    function n(e) {
        return (g[e] || "") + "\uFF08" + e + "\uFF09";
    }
    function a(e) {
        if (!isNaN(e)) {
            e = parseInt(e || 0);
            var t = "" + Math.floor(e / 60);
            return e = "" + e % 60, t.length < 2 && (t = "0" + t), e.length < 2 && (e = "0" + e), t + ":" + e;
        }
    }
    function o(e) {
        var t = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g;
        return e >= 1e8 ? (e = Math.round(10 * parseFloat(e / 1e8)) / 10, e = e.toString().replace(t, "$1,") + "\u4EBF") : e = e >= 1e5 ? parseInt(e / 1e4).toString().replace(t, "$1,") + "\u4E07" : e.toString().replace(t, "$1,"), e;
    }
    function r(e, t) {
        this.superClass.constructor.call(this), this.player = e, this.originalConfig = t, this.config = t || {}, this.el = this.player.el, this.tmpl = new l(k.player), this.resolutionTmpl = new l(_), this.recommendTmpl = new l(L), this.adv = this.player.adv, this.isDragging = !1, this.idleTimer = null, this.timeupdateCount = 0, this.clickOrPlayFlag = !1, this.errorCountDown = !1, this.outset = m.checkOutset(), this.registerHot = 0, this.init();
    }
    var s = i(28),
        d = function (e) {
        return e && e.__esModule ? e : {
            "default": e
        };
    }(s),
        l = i(12),
        c = i(24),
        h = i(1).browser,
        u = i(1).os,
        p = i(2),
        m = i(4),
        f = i(31),
        v = i(10),
        g = i(23),
        y = i(13),
        w = i(16),
        b = i(11),
        x = i(14).EventEmitter,
        T = i(15),
        P = i(3),
        D = i(5),
        S = i(30),
        C = i(9),
        k = {};
    k.video = function () {
        return '<div class="x-video x-video-hide"><video webkit-playsinline playsinline x-webkit-airplay="isHtml5UseAirPlay" ></video></div>';
    }, k.ctrl = function () {
        return '<div class="x-ctrl-container"><div class="x-drag-time-wrap x-s-forward"><b class="x-forward-ico"></b><b class="x-rewind-ico"></b><span class="x-drag-time-txt">00:00</span></div><div class="x-dashboard"><div class="x-playbtn-wrap"><div class="x-play-btn"></div><div class="x-pause-btn"></div></div><div class="x-progress-panel"><div class="x-progress-track"><div class="x-progress-buffer-track"></div><div class="x-progress-play-track"><div class="x-seek-btn"></div></div></div></div><div class="x-ctrl-time-wrap"><b class="x-currenttime-txt">00:00</b> / <span class="x-duration-txt">00:00</span></div><div class="x-fsbtn-wrap"><div class="x-fs-btn"></div><div class="x-exit-fs-btn"></div></div></div></div>';
    }, k.ad = function () {
        return "<div class=x-ad-panel><a class=\"x-ad-link\" target=\"_blank\" href=\"#\">\u8BE6\u60C5&gt;</a><div class=\"x-cover-playbtn\"></div><div class=\"x-ad-time-wrap\"><div class=\"x-ad-time\"></div><div class=\"x-ad-fee-btn\">\u514D\u8D39\u53BB\u5E7F\u544A</div></div></div>";
    }, k.resolution = function () {
        return '<div class="x-resolution-panel"></div>';
    }, k.loading = function () {
        return "<div class=\"x-player-loading-panel\"><div class=\"x-player-loading\"></div><div class=\"x-player-loading-notice\">\u52AA\u529B\u52A0\u8F7D\u4E2D,\u8BF7\u7A0D\u5019...</div></div>";
    }, k.plevel = function () {
        return "<div class=\"x-plevel-panel\"><div class=\"x-plevel-frame\"><div class=\"x-plevel-tt\">\u8BE5\u89C6\u9891\u5DF2\u52A0\u5BC6</div><div class=\"x-plevel-form\"><input type=\"password\" placeholder=\"\u8BF7\u8F93\u5165\u5BC6\u7801\u67E5\u770B\"><div class=\"btn\">\u63D0\u4EA4</div></div><div class=\"x-plevel-errortip\">\u5BC6\u7801\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165</div></div></div>";
    }, k.player = '<%@ h:helper %><div class="x-player">' + k.video() + "<div class=\"x-poster\"></div><div class=\"x-info-panel\"><div class=\"x-title\"></div><div class=\"x-playcount\"></div></div><div class=\"x-timelimit-panel\"><mark>\u8BD5\u770B</mark><span class=\"x-limit-time\"></span></div>" + k.ctrl() + k.resolution() + k.loading() + k.ad() + "<div class=\"x-cover-playbtn-wrap\"><div class=\"x-cover-playbtn\"></div></div><div class=\"x-recommend-panel\"><div class=\"x-replay-panel\"><div class=\"x-replay-btn\"><mark>\u8BD5\u770B\u7ED3\u675F\uFF0C</mark><em>\u6253\u5F00APP\u770B\u5B8C\u6574\u7248</em></div></div><div class=\"x-recommend-list-wrap\"></div></div><div class=\"x-message-panel\"><div class=\"x-message-frame\"></div><div class=\"x-message-btn-frame\"><div class=\"x-msg-txt\"></div><button class=\"x-msg-app-btn\">\u4E0B\u8F7D\u641C\u72D0\u89C6\u9891\u5BA2\u6237\u7AEF</button></div></div><div class=\"x-bigplaybtn-panel\"></div><a class=\"x-download-panel x-dl-shake\"><div class=\"x-download-intro\"><img src=\"//css.tv.itc.cn/m/img/logo_download.png\" class=\"logo\"><img src=\"//css.tv.itc.cn/m/img/player/dlTxt.png\" class=\"txt\"></div><div class=\"x-download-btn\">\u7ACB\u5373\u5B89\u88C5</div><div class=\"btn-close\"></div></a><div class=\"x-hot-panel\"></div>" + k.plevel() + "<div class=\"x-error-panel\"><div class=\"x-error-txt-frame\"><div class=\"x-error-txt\"></div><div class=\"x-error-cd\"><div class=\"second\">3\u79D2</div><div class=\"txt\">\u540E\u81EA\u52A8\u64AD\u653E\u7CBE\u5F69\u5185\u5BB9</div></div></div><div class=\"x-error-btn-frame\"><div class=\"x-error-txt\"></div><div class=\"x-error-cd\"><div class=\"second\">3\u79D2</div><div class=\"txt\">\u540E\u81EA\u52A8\u64AD\u653E\u7CBE\u5F69\u5185\u5BB9</div></div><button class=\"x-error-app-btn\">\u4E0B\u8F7D\u641C\u72D0\u89C6\u9891\u5BA2\u6237\u7AEF</button></div></div></div>";
    var _ = '<%@ h:helper %><% var i = 0, len = resolutionList.length, resolution, title;%><% for (; i < len; i++) { %><%resolution = resolutionList[i];title = RESOLUTION_MODE[resolution];%><div class="x-resolution-item<%= resolution == currentResolution ? " on" : "" %>" data-resolution="<%= resolution %>"><%= title %></div><% } %>',
        L = '<%@ h:helper %><% var i = 0, len = videos.length, video; %><ul class="x-recommend-list"><% for(; i < len; i++) {%><% video = videos[i]; %><li class="x-recommend-item"><a href="<%= video.videoUrl %>"><img src="<%= video.v_320_180 %>"><p><%= video.videoName %></p></a></li><% } %></ul>';
    p.inherit(r, x, {
        init: function init() {
            this.el.innerHTML = this.tmpl.render({
                config: this.config
            }), this.loadingPanle = this.el.querySelector(".x-player-loading-panel"), this.ctrlContainer = this.el.querySelector(".x-ctrl-container"), this.elposter = this.el.querySelector(".x-poster"), this.resolutionPanel = this.el.querySelector(".x-resolution-panel"), this.coverPlayBtnWrap = this.el.querySelector(".x-cover-playbtn-wrap"), this.elDashboard = this.el.querySelector(".x-dashboard"), this.xvideoEl = this.el.querySelector(".x-video"), this.adPanel = this.el.querySelector(".x-ad-panel"), this.adLink = this.adPanel.querySelector("a"), this.adTime = this.adPanel.querySelector(".x-ad-time"), this.adFeeBtn = this.adPanel.querySelector(".x-ad-fee-btn"), this.adCoverBtn = this.adPanel.querySelector(".x-cover-playbtn"), this.playBtn = this.el.querySelector(".x-play-btn"), this.pauseBtn = this.el.querySelector(".x-pause-btn"), this.fsBtn = this.el.querySelector(".x-fs-btn"), this.exitFsBtn = this.el.querySelector(".x-exit-fs-btn"), this.seekBtn = this.el.querySelector(".x-seek-btn"), this.elTrack = this.el.querySelector(".x-progress-track"), this.elPlaytrack = this.el.querySelector(".x-progress-play-track"), this.elBuffertrack = this.el.querySelector(".x-progress-buffer-track"), this.elDrapTimeWrap = this.el.querySelector(".x-drag-time-wrap"), this.elDrapTimeTxt = this.el.querySelector(".x-drag-time-txt"), this.elCurrentTime = this.el.querySelector(".x-currenttime-txt"), this.elDurationTime = this.el.querySelector(".x-duration-txt"), this.infoPanel = this.el.querySelector(".x-info-panel"), this.elTitle = this.infoPanel.querySelector(".x-title"), this.elPlayCount = this.infoPanel.querySelector(".x-playcount"), this.messagePanel = this.el.querySelector(".x-message-panel"), this.messageFrame = this.el.querySelector(".x-message-frame"), this.messageBtnFrame = this.el.querySelector(".x-message-btn-frame"), this.appBtn = this.el.querySelector(".x-msg-app-btn"), this.timelimitPanel = this.el.querySelector(".x-timelimit-panel"), this.elTimeLimit = this.timelimitPanel.querySelector(".x-limit-time"), this.replayPanel = this.el.querySelector(".x-replay-panel"), this.recommendPanel = this.el.querySelector(".x-recommend-panel"), this.downloadPanel = this.el.querySelector(".x-download-panel"), this.bigplayPanel = this.el.querySelector(".x-bigplaybtn-panel"), this.hotVedioPanel = this.el.querySelector(".x-hot-panel"), this.errorPanel = this.el.querySelector(".x-error-panel"), this.errorTxtFrame = this.errorPanel.querySelector(".x-error-txt-frame"), this.errorBtnFrame = this.errorPanel.querySelector(".x-error-btn-frame"), this.plevelPanel = this.el.querySelector(".x-plevel-panel"), this.plevelPassword = this.plevelPanel.querySelector("input"), this.plevelSubmitBtn = this.plevelPanel.querySelector(".btn"), this.plevelErrorTip = this.plevelPanel.querySelector(".x-plevel-errortip"), this.plevelErrorTip.innerHTML = "", C.is56 && (this.appBtn.innerHTML = "\u4E0B\u8F7D56\u89C6\u9891\u5BA2\u6237\u7AEF", this.el.querySelector(".x-error-app-btn").innerHTML = "\u4E0B\u8F7D56\u89C6\u9891\u5BA2\u6237\u7AEF"), this.initEvent(), this.enableSeek(), this.initHide();
        },
        enableSeek: function enableSeek() {
            var e,
                t,
                i,
                n = this,
                o = this.player,
                r = {},
                s = "ontouchstart" in window,
                d = s ? "touchstart" : "mousedown",
                l = s ? "touchmove" : "mousemove",
                c = s ? "touchend" : "mouseup",
                h = function h(e) {
                var t = e.changedTouches;
                return t && t.length ? t[0] : e;
            },
                u = function u(e) {
                e.preventDefault(), e.stopPropagation(), v.log("\u8FDB\u5EA6\u6761\u5F00\u59CB\u62D6\u52A8"), clearTimeout(n.idleTimer);
                var a = h(e);
                n.isDragging = !0, r = {
                    x: a.screenX,
                    y: a.screenY
                }, t = f.width(n.elPlaytrack), i = t;
            },
                p = function p(s) {
                if (n.isDragging) {
                    s.preventDefault(), s.stopPropagation();
                    var d = h(s),
                        l = d.screenX - r.x,
                        c = t + l,
                        u = f.width(n.elTrack);
                    c = Math.max(c, 0), c = Math.min(c, u), e = o.getDuration() * c / u, "number" == typeof e && (n.updatePlayedTrack(e), f.show(n.elDrapTimeWrap), n.elDrapTimeTxt.innerHTML = a(e), c >= i ? (f.removeClass(n.elDrapTimeWrap, "x-s-rewind"), f.addClass(n.elDrapTimeWrap, "x-s-forward")) : (f.removeClass(n.elDrapTimeWrap, "x-s-forward"), f.addClass(n.elDrapTimeWrap, "x-s-rewind")), i = c);
                }
            },
                m = function m(t) {
                n.isDragging && "number" == typeof e && (o.seek(e), o.play(), g(), n.hideDashboardDelay(), t.stopPropagation());
            },
                g = function g(e) {
                n.isDragging = !1, f.hide(n.elDrapTimeWrap), e && e.stopPropagation();
            };
            this.seekBtn.addEventListener(d, u), document.addEventListener(l, p), document.addEventListener(c, m), document.addEventListener("touchcancel", g);
        },
        initEvent: function initEvent() {
            var e = this;
            this.observPlayer();
            var t = this.player,
                i = function () {
                var e;
                return "onfullscreenchange" in document ? e = "fullscreenchange" : "onwebkitfullscreenchange" in document ? e = "webkitfullscreenchange" : "onmozfullscreenchange" in document ? e = "mozfullscreenchange" : "msRequestFullscreen" in document && (e = "MSFullscreenChange"), e;
            }();
            i && document.addEventListener(i, this.onfullscreenchange.bind(this)), this.resolutionPanel.addEventListener("click", function (e) {
                e.stopPropagation();
                var i = e.target;
                if (f.hasClass(i, "x-resolution-item") && !f.hasClass(i, "on")) {
                    for (var n = i.getAttribute("data-resolution"), a = this.resolutionPanel.querySelectorAll(".x-resolution-item"), o = 0, r = a.length; o < r; o++) {
                        f.removeClass(a[o], "on");
                    }f.addClass(i, "on"), t.isStarted && this.showDashBoard(), t.switchResolution(n);
                }
            }.bind(this)), this.coverPlayBtnWrap.addEventListener("click", function (i) {
                i.stopPropagation();
                var n = e.player.videoData;
                if (/^wx\.m\.tv\.sohu\.com$/i.test(document.domain) && h.wx && u.ios && parseFloat(u.version) >= 9 && 1 == n.site) {
                    b.pingback("wx_video_pause");
                    var a = w.parserAttributes();
                    a.type = "click";
                    var o = w.makeActionUrl(a);
                    location.href = "//m.tv.sohu.com/app/link.html?action=" + o;
                }
                e.onClickPlay(), t.play();
            }), this.adLink.addEventListener("click", function () {
                var e = this.adLink.getAttribute("data-pingback");
                this.player.adv.pingback(e), this.player.pause(), b.pingback("ad_detail_click");
            }.bind(this)), this.adCoverBtn.addEventListener("click", function () {
                f.hide(this.adCoverBtn), this.clickOrPlayFlag = !0, this.player.play();
            }.bind(this)), this.ctrlContainer.addEventListener("click", function () {
                this.isDashBoardShowed() ? this.hideDashBoard() : this.showDashBoard();
            }.bind(this)), this.playBtn.addEventListener("click", function () {
                t.play();
            }), this.pauseBtn.addEventListener("click", function () {
                t.pause();
            }), this.fsBtn.addEventListener("click", function () {
                t.requestFullscreen(), t.play();
            }.bind(this)), this.exitFsBtn.addEventListener("click", function () {
                t.exitFullscreen();
            }.bind(this)), this.elDashboard.addEventListener("click", function (e) {
                this.showDashBoard(), e.stopPropagation();
            }.bind(this)), this.appBtn.addEventListener("click", function (e) {
                b.pingback("appdownload_banner_open"), this.appActions(), e.stopPropagation();
            }.bind(this)), this.replayPanel.addEventListener("click", function (e) {
                window.apptips && window.apptips.callApp(), e.stopPropagation();
            }.bind(this)), this.adFeeBtn.addEventListener("click", function () {
                b.pingback("appdownload_adRemove"), t.pause(), this.appActions();
            }.bind(this)), this.downloadPanel.addEventListener("click", function (e) {
                b.pingback("appdownload_pause"), e.target.classList.contains("btn-close") ? (f.hide(e.currentTarget), this.showDashBoard()) : this.appActions();
            }.bind(this)), this.bigplayPanel.addEventListener("click", function (e) {
                this.showDashBoard(), t.play();
            }.bind(this)), this.errorBtnFrame.querySelector(".x-error-app-btn").addEventListener("click", function (e) {
                this.errorCountDown && null !== m.cdTimeout && clearTimeout(m.cdTimeout), b.pingback("appdownload_banner_open"), this.appActions(), e.stopPropagation();
            }.bind(this)), this.plevelSubmitBtn.addEventListener("click", function (e) {
                b.pingback("play_dec_");
                var t = this.plevelPassword.value;
                t && S.loadVideoSrc({
                    password: t
                }).then(function (e) {
                    200 == e.code ? (f.hide(this.plevelPanel), this.player.nextdoPlay(e.data)) : this.plevelErrorTip.innerHTML = "\u5BC6\u7801\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165";
                }.bind(this));
            }.bind(this));
        },
        initHide: function initHide() {
            this.config.hasOwnProperty("infoPanel") && !1 === this.config.infoPanel && (this.infoPanel.innerHTML = "", this.infoPanel.style.height = 0);
        },
        initHot: function initHot() {
            var e = this.player.videoData;
            if (this.config.hotVideo && "1" != this.outset) {
                var t,
                    i,
                    n = new l("<%@ h:helper %><% var i = 0, len = videos.length > 12 ? 12 : videos.length, video, url; %><div class=\"x-hot-title\">\u4ECA\u65E5\u70ED\u70B9</div><div class=\"x-hot-content\"><% for(; i < len ; i++){  %><% video = videos[i]; %><a class=\"x-hot-list\" data-vid=\"<%= video.vid%>\" data-videoname=\"<%= video.videoName%>\"><img class=\"image\" src=\"<%= video.picUrl || video.v_320_180 || video.v_170_110 %>\"><div class=\"title\"><span><%= video.videoName %></span></div></a><% } %></div>"),
                    a = "varsimilar" + new Date().getTime();
                1 == e.site ? (i = "//rc.vrs.sohu.com/dramaH5?callback=?&p=" + T.getPassport() + "&pid=" + e.plid, this.loadVrsRcData(i).then(function (e) {
                    e.data && e.data.videos && e.data.videos.length && (t = n.render({
                        videos: e.data.videos
                    }), this.hotVedioPanel.innerHTML = t, 0 == this.registerHot && this.initHotEvent(), f.show(this.hotVedioPanel), this.initTxtEllipsis());
                }.bind(this))) : 2 == e.site && (i = "//rc.vrs.sohu.com/pgc/relate/video?&isH5=1&source=20&refer=" + (D.getParam("landingrefer") || encodeURIComponent(document.referrer)) + "&ab=" + this.ab + "&title=" + escape(escape(e.tvname || e.video_name || e.videoName)) + "&vid=" + e.vid + "&cid=" + e.cid + "&catecode=" + (e.cateCode || e.cate_code) + "&pageSize=30&var=" + a, this.loadPgcRcData(i).then(function () {
                    var e = window[a] || {};
                    e.videos && e.videos.length && (t = n.render({
                        videos: e.videos
                    }), this.hotVedioPanel.innerHTML = t, 0 == this.registerHot && this.initHotEvent(), f.show(this.hotVedioPanel), this.initTxtEllipsis());
                }.bind(this)));
            }
        },
        appActions: function appActions() {
            if (C.is56) d["default"].open();else {
                window.apptips ? window.apptips.callApp() : y.loadChannelInfo().then(function (e) {
                    if ("1" === e.startapp) {
                        var t = w.parserAttributes();
                        t.type = "click";
                        try {
                            var i = w.sendAction(t);
                        } catch (n) {
                            console.log(n);
                        }
                        i && i.then(function (e) {
                            e && !h.sohuVideoApp && w.gotoDownload();
                        });
                    } else h.sohuVideoApp || w.gotoDownload();
                });
            }
        },
        observPlayer: function observPlayer() {
            this.player.on("waiting", function () {
                this.clickOrPlayFlag && this.showLoading();
            }.bind(this)), this.player.on("playing", this.onPlaying.bind(this)), this.player.on("error", this.onError.bind(this)), this.player.on("data.loading", this.showLoading.bind(this)), this.player.on("data.loaded", this.hideLoading.bind(this)), this.player.on("data.exception", this.onDataException.bind(this)), this.player.on("data.ok", this.updateUI.bind(this)), this.player.on("player.start", this.onStart.bind(this)), this.player.on("timeupdate", this.onTimeupdate.bind(this)), this.player.on("adv.ended", function () {
                this.hideADUI(), this.showTimeLimitPanel();
            }.bind(this)), this.player.on("pause", this.onPause.bind(this)), this.player.on("play", this.onPlay.bind(this)), this.player.on("reset", this.reset.bind(this)), this.player.on("playcount.loaded", function (e) {
                this.elPlayCount.innerHTML = o(e), window.messagebus && messagebus.publish("playcount.loaded", o(e));
            }.bind(this)), this.player.on("timelimit", function (e) {
                this.elTimeLimit.innerHTML = a(e);
            }.bind(this)), this.player.on("recommend.loaded", function (e) {
                f.show(this.recommendPanel), this.recommendPanel.querySelector(".x-recommend-list-wrap").innerHTML = this.recommendTmpl.render({
                    videos: e || []
                });
            }.bind(this)), this.player.on("ended", function () {
                this.hideLoading(), "1" != this.outset && this.config.hotVideo && (f.hide(this.downloadPanel), f.hide(this.bigplayPanel), f.hide(this.infoPanel), this.player.exitFullscreen(), this.initHot());
            }.bind(this)), this.player.on("play.plevel", function (e) {
                2 == e && (this.elposter.style.backgroundImage = "", this.hideDashBoard(), f.hide(this.coverPlayBtnWrap), f.hide(this.bigplayPanel), f.show(this.plevelPanel));
            }.bind(this));
        },
        onfullscreenchange: function onfullscreenchange(e) {
            var t = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
            t == this.el.querySelector(".x-player") ? (f.hide(this.fsBtn), f.show(this.exitFsBtn)) : null == t && (f.hide(this.exitFsBtn), f.show(this.fsBtn));
        },
        showTimeLimitPanel: function showTimeLimitPanel() {
            var e = this.player.dataModel;
            e && e.timeLimit && f.show(this.timelimitPanel);
        },
        hideTimeLimitPanel: function hideTimeLimitPanel() {
            f.hide(this.timelimitPanel);
        },
        showDashBoard: function showDashBoard() {
            f.show(this.resolutionPanel), f.show(this.elDashboard), f.show(this.infoPanel), this.hideDashboardDelay(), this.hideTimeLimitPanel();
        },
        hideDashBoard: function hideDashBoard() {
            f.hide(this.resolutionPanel), f.hide(this.elDashboard), f.hide(this.infoPanel), this.showTimeLimitPanel();
        },
        hideDashboardDelay: function hideDashboardDelay() {
            clearTimeout(this.idleTimer), this.idleTimer = setTimeout(function () {
                this.hideDashBoard();
            }.bind(this), 4e3);
        },
        isDashBoardShowed: function isDashBoardShowed() {
            return "none" != f.css(this.elDashboard, "display");
        },
        showLoading: function showLoading() {
            f.show(this.loadingPanle);
        },
        hideLoading: function hideLoading() {
            f.hide(this.loadingPanle);
        },
        onTimeupdate: function onTimeupdate() {
            if (u.ios && h.qq && (this.hideLoading(), f.show(this.adCoverBtn)), this.clickOrPlayFlag = !0, this.player.isPlayingAD) {
                if (0 == this.timeupdateCount) return void (this.timeupdateCount += 1);
                this.updateADUI();
            } else this.hideADUI(), this.updateProgress();
            f.hide(this.messagePanel);
        },
        onPlay: function onPlay() {
            f.hide(this.playBtn), f.show(this.pauseBtn), f.hide(this.adCoverBtn), (this.config.dlBanner || this.config.dlBanner == undefined) && (f.hide(this.downloadPanel), f.hide(this.bigplayPanel));
        },
        onPause: function onPause() {
            this.player.isPlayingAD ? f.show(this.adCoverBtn) : (f.show(this.playBtn), f.hide(this.pauseBtn), clearTimeout(this.idleTimer), this.config.dlBanner || this.config.dlBanner == undefined ? (!h.weixin || h.weixin && 3 != this.outset) && (this.hideDashBoard(), f.show(this.downloadPanel), f.show(this.bigplayPanel)) : this.showDashBoard());
        },
        onPlaying: function onPlaying() {
            this.hideLoading(), f.hide(this.elposter), f.hide(this.coverPlayBtnWrap), f.hide(this.resolutionPanel), f.hide(this.infoPanel), f.removeClass(this.xvideoEl, "x-video-hide"), f.hide(this.playBtn), f.show(this.pauseBtn);
        },
        onError: function onError(e) {
            this.hideLoading(), f.css(this.xvideoEl, "width", "0px"), v.log("\u64AD\u653E\u5931\u8D25-->", e), "1" == this.outset || this.config.hotVideo || this.player.playList.hasNext() || window.nextUrl || (3 == e.code || 4 == e.code ? (this.messageBtnFrame.querySelector(".x-msg-txt").innerHTML = n(e.code), f.show(this.messagePanel), f.show(this.messageBtnFrame), f.hide(this.messageFrame)) : (this.messageFrame.innerHTML = n(data.code || "400"), f.show(this.messagePanel), f.show(this.messageFrame), f.hide(this.messageBtnFrame))), 3 != e.code && 4 != e.code || h.weixin && "3" == this.outset ? (this.errorTxtFrame.querySelector(".x-error-txt").innerHTML = n(e.code || "400"), f.hide(this.errorBtnFrame), f.show(this.errorTxtFrame)) : (this.errorBtnFrame.querySelector(".x-error-txt").innerHTML = n(e.code), f.hide(this.errorTxtFrame), f.show(this.errorBtnFrame)), f.show(this.errorPanel), this.errorTimeCountDown();
        },
        onDataException: function onDataException(e) {
            if (101 == e.code || 401 == e.code || 402 == e.code || 403 == e.code) return f.css(this.xvideoEl, "width", "0px"), h.weixin && "3" == this.outset ? (this.errorTxtFrame.querySelector(".x-error-txt").innerHTML = n(e.code || "400"), f.hide(this.errorBtnFrame), f.show(this.errorTxtFrame)) : (this.errorBtnFrame.querySelector(".x-error-txt").innerHTML = n(e.code), f.hide(this.errorTxtFrame), f.show(this.errorBtnFrame)), f.show(this.errorPanel), void this.errorTimeCountDown();
            100 == e.code || 102 == e.code || 103 == e.code ? (this.messageBtnFrame.querySelector(".x-msg-txt").innerHTML = n(e.code), f.show(this.messagePanel), f.show(this.messageBtnFrame), f.hide(this.messageFrame), f.hide(this.downloadPanel), this.hideDashBoard()) : (this.messageFrame.innerHTML = n(e.code || "400"), f.show(this.messagePanel), f.show(this.messageFrame), f.hide(this.messageBtnFrame));
        },
        onClickPlay: function onClickPlay() {
            this.showLoading(), f.hide(this.coverPlayBtnWrap), f.hide(this.resolutionPanel), f.hide(this.infoPanel), f.hide(this.recommendPanel), f.removeClass(this.xvideoEl, "x-video-hide");
        },
        onStart: function onStart() {
            f.removeClass(this.xvideoEl, "x-video-hide"), f.hide(this.recommendPanel);
        },
        updateProgress: function updateProgress() {
            this.updateBufferedTrack(), this.updateTime(), this.isDragging || this.updatePlayedTrack();
        },
        updateTime: function updateTime() {
            var e = this.player,
                t = e.getCurrentTime(),
                i = e.getDuration();
            this.elCurrentTime.innerHTML = a(t), this.elDurationTime.innerHTML = a(i), this.elTimeLimit.innerHTML = a(Math.floor(i - t)), this.isDashBoardShowed() ? this.hideTimeLimitPanel() : this.showTimeLimitPanel();
        },
        updateBufferedTrack: function updateBufferedTrack() {
            var e = this.player,
                t = e.getDuration(),
                i = e.getBufferedTime();
            if (t && !window.isNaN(t)) {
                var n = Math.min(i / t * 100, 100) + "%";
                e.isPlayingAD || (this.elBuffertrack.style.width = n);
            }
        },
        updatePlayedTrack: function updatePlayedTrack(e) {
            var t = this.player,
                i = t.getCurrentTime(),
                n = t.getDuration();
            void 0 !== e && (i = e);
            var a = Math.min(i / n * 100, 100) + "%";
            t.isPlayingAD || (this.elPlaytrack.style.width = a);
        },
        updateUI: function updateUI() {
            var e = this.player,
                t = e.getDuration(),
                i = this.player.dataModel;
            this.elposter.style.backgroundImage = "url(" + i.poster + ")", this.elTitle.innerHTML = i.title, this.config.hasOwnProperty("resolution") && !1 === this.config.resolution || (this.resolutionPanel.innerHTML = this.resolutionTmpl.render({
                resolutionList: i.resolutionList,
                currentResolution: i.resolutionType,
                RESOLUTION_MODE: c.RESOLUTION_MODE
            })), this.elDurationTime.innerHTML = a(t), f.show(this.elposter), f.show(this.resolutionPanel), f.show(this.infoPanel), f.show(this.coverPlayBtnWrap), this.hideTimeLimitPanel();
        },
        updateADUI: function updateADUI() {
            var e = this.player.adv,
                t = e.getDataByIndex(),
                i = e.getCurrentTime(),
                n = e.duration;
            t && (f.show(this.adPanel), this.adTime.innerHTML = "<b>" + Math.ceil(Math.max(n - i, 0)) + "</b>", t.clickurl ? (f.show(this.adLink), this.adLink.href = t.clickurl, this.adLink.setAttribute("data-pingback", t.cp)) : f.hide(this.adLink), h.wx && f.hide(this.adFeeBtn), f.hide(this.timelimitPanel));
        },
        hideADUI: function hideADUI() {
            f.hide(this.adPanel);
        },
        reset: function reset() {
            f.show(this.elposter), f.show(this.infoPanel), f.show(this.resolutionPanel), f.show(this.coverPlayBtnWrap), setTimeout(function () {
                f.hide(this.elDashboard);
            }.bind(this), 100), f.hide(this.messagePanel), f.hide(this.adPanel), f.hide(this.timelimitPanel), f.hide(this.recommendPanel), f.hide(this.downloadPanel), f.hide(this.bigplayPanel), f.hide(this.errorPanel), f.hide(this.plevelPanel), this.resetErrorPanel(), f.addClass(this.xvideoEl, "x-video-hide"), this.timeupdateCount = 0, this.clickOrPlayFlag = !1, f.css(this.xvideoEl, "width", "100%");
        },
        ab: function () {
            var e = 0,
                t = parseInt(100 * Math.random());
            return t < 25 ? e = 0 : t < 50 ? e = 1 : t < 75 ? e = 2 : t < 85 ? e = 3 : t < 95 ? e = 4 : t < 100 && (e = 5), e;
        }(),
        loadVrsRcData: function loadVrsRcData(e) {
            return P.getJSON(e);
        },
        loadPgcRcData: function loadPgcRcData(e) {
            return P.getScript(e);
        },
        initTxtEllipsis: function initTxtEllipsis() {
            for (var e = this.hotVedioPanel.querySelectorAll(".title span"), t = e.length, i = 0; i < t; i++) {
                m.ellipsis(e[i], 14, 2);
            }
        },
        initHotEvent: function initHotEvent() {
            this.registerHot = 1, this.hotVedioPanel.addEventListener("click", function (e) {
                var t = e.target,
                    i = t.parentNode;
                if (t.classList.contains("x-hot-title")) return null;
                b.pingback("hot_panel");
                var n = t.classList.contains("x-hot-list") ? t : "span" == t.tagName.toLowerCase() ? i.parentNode : i,
                    a = n.dataset.vid,
                    o = n.dataset.videoname,
                    r = {
                    vid: a,
                    videoName: o
                };
                f.hide(this.hotVedioPanel), this.player.play(r);
            }.bind(this));
        },
        errorTimeCountDown: function errorTimeCountDown() {
            this.errorCountDown = !0;
            var e = "none" == this.errorTxtFrame.style.display ? this.errorBtnFrame.querySelector(".second") : this.errorTxtFrame.querySelector(".second");
            m.countDownSecond(e, function () {
                this.triggerPlayNext();
            }.bind(this));
        },
        triggerPlayNext: function triggerPlayNext() {
            this.player.playList.hasNext() ? (this.player.playNext(), this.resetErrorPanel()) : (this.player.emit("list.ended"), window.nextUrl ? b.pingback("video_play_nextout") : "1" != this.outset && this.config.hotVideo && (f.hide(this.downloadPanel), f.hide(this.bigplayPanel), f.hide(this.infoPanel), this.player.exitFullscreen(), this.initHot(), this.resetErrorPanel()));
        },
        resetErrorPanel: function resetErrorPanel() {
            f.hide(this.errorPanel), this.errorPanel.querySelector(".x-error-txt-frame .second").innerHTML = "3\u79D2", this.errorPanel.querySelector(".x-error-btn-frame .second").innerHTML = "3\u79D2", this.errorCountDown && null !== m.cdTimeout && (clearTimeout(m.cdTimeout), this.errorCountDown = !1);
        }
    }), e.exports = r;
}]);
// CONCATENATED MODULE: ./src/api/utils/funcs.js
/* harmony export (immutable) */ __webpack_exports__["b"] = getRandomStr;
/* harmony export (immutable) */ __webpack_exports__["a"] = formatTime;
/* harmony export (immutable) */ __webpack_exports__["d"] = openApp;
/* harmony export (immutable) */ __webpack_exports__["c"] = loadVideo;
/**
 * Created by xinjundong on 2017/11/20.
 */



/**
 * 获取一个随机字符串
 * */
function getRandomStr(str) {
  return str + '_' + String(new Date().getTime() * Math.random()).substr(0, 13).replace('.', 'a');
}

/**
 * 格式化时间
 * */
function formatTime(v) {
  var today = new Date();
  var dateObj = new Date(v);
  var year = dateObj.getFullYear();
  var month = dateObj.getMonth();
  var date = dateObj.getDate();
  var hours = dateObj.getHours();
  var minute = dateObj.getMinutes();
  var ty = today.getFullYear();
  var tm = today.getMonth() + 1;
  var td = today.getDate();
  var th = today.getHours() + 1;
  var tmn = today.getMinutes() + 1;
  month += 1;
  hours += 1;
  minute += 1;

  var month1 = month < 10 ? '0' + month : month;
  var date1 = date < 10 ? '0' + date : date;
  var hours1 = hours < 10 ? '0' + (hours - 1) : hours - 1;
  var minute1 = minute < 10 ? '0' + minute : minute;
  if (ty == year && tm == month) {

    if (td == date) {
      if (hours == th) {
        var mstr = tmn - minute;
        if (mstr == 0) {
          return '一分钟前';
        } else {
          return mstr + '分钟前';
        }
      } else {
        return '今天&nbsp;' + hours1 + ':' + minute1;
      }
    } else if (td - date == 1) {
      return '昨天&nbsp;' + hours1 + ':' + minute1;
    } else {
      return month1 + '-' + date1 + '&nbsp;' + hours1 + ":" + minute1;
    }
  } else {
    return year + '-' + month1 + '-' + date1 + '&nbsp;' + hours1 + ":" + minute1;
  }
}
/**
 * js 打开 app
 * */
function openApp(id) {
  var openAppUrl = void 0;
  if (id) {
    openAppUrl = 'sohuauto://sohuauto.auto.sohu.com/news/textNewsDetail?newsId=' + id;
  } else {
    openAppUrl = 'sohuauto://sohuauto.auto.sohu.com/app/splash';
  }
  var uaStr = navigator.userAgent.toLowerCase();
  if (uaStr.match(/(iphone|ipod|ipad);?/i)) {
    // let loadDateTime = new Date()
    // window.setTimeout(function () {
    //   let timeOutDateTime = new Date()
    //   if (timeOutDateTime - loadDateTime < 5000) {
    //     window.location.href = iosUrl
    //   }
    //   // } else {
    //   //   window.close()
    //   // }
    // }, 25)
    if (id) {
      openAppUrl = 'https://oia.auto.sohu.com/articles/' + id;
    } else {
      openAppUrl = 'https://oia.auto.sohu.com/articles/';
    }
    window.location.href = openAppUrl;
  } else if (uaStr.match(/android/i)) {
    if (uaStr.indexOf('micromessenger') > -1) {
      window.location.href = androidWXURL;
    } else {
      window.location.href = openAppUrl;
      setTimeout(function () {
        window.location.href = androidUrl;
      }, 200);
    }
  }
}

// 加载视频

function loadVideo() {
  var videoDoms = Object(dom["b" /* gets */])('.video-box');
  Array.prototype.forEach.call(videoDoms, function (el, i) {
    var videoBid = el.getAttribute('data-bid');
    playerFactory.createPlayer('[data-bid="' + videoBid + '"]', {
      autoplay: false,
      mtvSrc: 10010001,
      data: {
        vid: videoBid,
        site: 2
      }
    });
  });
}

/***/ }),

/***/ "Yobk":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("77Pl");
var dPs = __webpack_require__("qio6");
var enumBugKeys = __webpack_require__("xnc9");
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("ON07")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("RPLV").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "Zrlr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "Zx67":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("fS6E"), __esModule: true };

/***/ }),

/***/ "Zzip":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("/n6Q"), __esModule: true };

/***/ }),

/***/ "aA3F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ax3d":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("e8AB")('keys');
var uid = __webpack_require__("3Eo+");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "cGG2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("JP+z");
var isBuffer = __webpack_require__("Re3r");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "cWxy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("dVOP");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "crlp":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var LIBRARY = __webpack_require__("O4g8");
var wksExt = __webpack_require__("Kh4W");
var defineProperty = __webpack_require__("evD5").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "dIwP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "dSzd":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("e8AB")('wks');
var uid = __webpack_require__("3Eo+");
var Symbol = __webpack_require__("7KvD").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "dVOP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "e6n0":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("evD5").f;
var has = __webpack_require__("D2L2");
var TAG = __webpack_require__("dSzd")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "e8AB":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("FeBl");
var global = __webpack_require__("7KvD");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("O4g8") ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "edGf":
/***/ (function(module, exports, __webpack_require__) {


var eventObj = __webpack_require__("1BEy");
/*
  说明： 用touch事件和transform :"translate3d(0,0,0)"样式实现移动端滑动效果
  参数：
   opt.el :焦点图容器dom
   opt.tagName:子元素标签名
   opt.swipe：横向还是纵向滑动
   opt.nav:导航容器dom
*/
var Slide = function Slide(opt) {
	this.el = opt.el;
	this.elParent = null;
	this.tagName = opt.tagName || 'li';
	this.chirdren = null;
	this.navis = null;
	this.swipe = opt.swipe || "X";
	this.nav = opt.nav || null;
	this.numNav = null;
	this.navType = opt.navType || 'normal'; // normal表示普通的导航，num，表示数字导航
	this.prevBtn = opt.prevBtn || null;
	this.nextBtn = opt.nextBtn || null;
	this.urllist = opt.urllist || null; //add shop btnlist
	this.urlbtn = opt.urlbtn || null; //add shop btn
	this.autoflag = opt.auto || null;
	this.isNoFullScreen = opt.isNoFullScreen || null; // 是否为全屏滑动， 默认全屏
	this.flag;
	this.currentIndex = 0; //索引
	this.chirdW = 0;
	this.chirdH = 0;
	this.elWidth = 0; //积累el的总高度或总宽度
	this.interval = opt.interval || 400;
	this.pageX;
	this.pageY;
	this.fangxiang = ""; // 向哪个方向滑动
	this.left = 0; //this.swipe = 'X'
	this.top = 0; //this.swipe = 'Y'
	this.count = 0; //子元素的个数
	this.pcMoveFlag = true;
	this.isInertia = false; //是否有惯性
	this.inertiaLength = 300;
	this.init();
};
Slide.prototype = {
	init: function init(index) {
		var k = this;
		k.elParent = k.el.parentNode;
		//k.chirdren = k.el.getElementsByTagName(k.tagName);
		//k.chirdren = Array.prototype.slice.call(k.chirdren, 0);
		//k.count = k.chirdren.length;
		if (k.isNoFullScreen) {
			k.resizeLayoutNoScreen();
		} else {
			k.resizeLayout();
		}
		this.events();
		if (k.autoflag) {
			k.automove();
		}
		if (k.urllist) {
			this.changeUrl();
		} //xly
		//this.automove();
	},
	reComputed: function reComputed() {
		var k = this;
		k.chirdren = k.el.getElementsByTagName(k.tagName);
		k.chirdren = Array.prototype.slice.call(k.chirdren, 0);
		k.count = k.chirdren.length;
	},
	resizeLayout: function resizeLayout() {
		var k = this;
		k.reComputed();
		if (k.swipe === 'X') {
			k.elWidth = 0;
			k.chirdW = k.getW(k.elParent);
			for (var i = 0; i < k.count; i++) {
				k.chirdren[i].style.width = k.chirdW + "px";
				k.elWidth += k.chirdW;
			}
			k.el.style.width = k.elWidth + "px";
		} else if (k.swipe === 'Y') {
			k.elHeight = 0;
			k.chirdH = k.getH(k.elParent);
			for (var i = 0; i < k.count; i++) {
				k.chirdren[i].style.height = k.chirdH + "px";
				k.elHeight += k.chirdH;
			}
			k.el.style.height = k.elHeight + "px";
		}
		if (k.nav) {
			if (k.navType === 'normal') {
				k.createNav();
			} else if (k.navType === 'num') {
				k.createNumNav();
			}
		}
	},
	resizeLayoutNoScreen: function resizeLayoutNoScreen() {
		var k = this;
		k.reComputed();
		if (k.swipe == 'X') {
			k.elWidth = 0;
			k.chirdren.forEach(function (ele, idx) {
				var extW = k.getStyleValue(ele, 'padding-left') + k.getStyleValue(ele, 'padding-right') + k.getStyleValue(ele, 'margin-left') + k.getStyleValue(ele, 'margin-right');
				k.elWidth += k.getW(ele) + extW;
			});
			k.el.style.width = k.elWidth + "px";
		} else if (k.swipe == 'Y') {
			k.elHeight = 0;
			k.chirdren.forEach(function (ele, idx) {
				k.elHeight += k.getH(ele);
			});
			k.el.style.height = k.elHeight + "px";
		}
	},
	createNumNav: function createNumNav() {
		var k = this;

		k.numNav = k.nav.querySelector('.cur');
		k.nav.querySelector('.total').innerHTML = k.count;
		k.numNav.innerHTML = 1;
	},
	createNav: function createNav() {
		var k = this;
		var span = null;
		k.nav.innerHTML = '';
		for (var i = 0; i < k.count; i++) {
			span = document.createElement('span');
			if (i == 0) {
				span.className = "box-size on";
				k.nav.appendChild(span);
			} else {
				span.className = "box-size";
				k.nav.appendChild(span);
			}
		}
		k.navis = k.nav.getElementsByTagName('span');
		k.navis = Array.prototype.slice.call(k.navis, 0);
	},
	getW: function getW(e) {
		return Number(window.getComputedStyle(e, "").width.replace("px", ""));
	},
	getH: function getH(e) {
		return Number(window.getComputedStyle(e, "").height.replace("px", ""));
	},
	getStyleValue: function getStyleValue(e, name) {

		return Number(window.getComputedStyle(e, null)[name].replace("px", ""));
	},
	automove: function automove() {
		//自动滑动到下一个item
		var k = this;
		k.flag = setInterval(function () {
			k.next.call(k);
		}, 3e3);
	},
	clear: function clear() {
		clearInterval(this.flag);
		this.flag = null;
	},
	events: function events() {
		var k = this;
		k.el.addEventListener(eventObj.touchStart, function (e) {
			//e.preventDefault();
			e.stopPropagation();
			k.touchstart.call(k, e);
		}, false);
		k.el.addEventListener(eventObj.touchMove, function (e) {
			//e.preventDefault();
			e.stopPropagation();
			k.touchmove.call(k, e);
		}, false);
		k.el.addEventListener(eventObj.touchEnd, function (e) {
			//e.preventDefault();
			e.stopPropagation();
			k.touchend.call(k, e);
		}, false);
		k.el.addEventListener(eventObj.touchCancel, function (e) {
			//e.preventDefault();
			e.stopPropagation();
			k.touchcancel.call(k, e);
		}, false);
		if (k.prevBtn) {
			k.prevBtn.addEventListener(eventObj.touchEnd, function (e) {
				k.prev();
			}, false);
		}
		if (k.nextBtn) {
			k.nextBtn.addEventListener(eventObj.touchEnd, function (e) {
				k.next();
			}, false);
		}
	},
	touchstart: function touchstart(e) {
		var k = this;
		var t = eventObj.getPoint(e);
		k.clear();
		k.move = 0;
		k.pageX = t.x;
		k.pageY = t.y;
		k.fangxiang = '';
		k.pcMoveFlag = false;
		if (window.PointerEvent || window.MSPointerEvent) {
			var sleft = k.el.style.msTransform || k.el.style.transform;
			k.left = k.getInitPosition(sleft, "x");
			k.top = k.getInitPosition(sleft, "y");
		} else {
			k.left = k.getInitPosition(k.el.style.webkitTransform, "x");
			k.top = k.getInitPosition(k.el.style.webkitTransform, "y");
		}
	},
	touchmove: function touchmove(e) {
		var k = this;
		if (k.pcMoveFlag) {
			return;
		}
		var t = eventObj.getPoint(e);
		var px = t.x;
		var py = t.y;
		var lenX = px - k.pageX;
		var lenY = py - k.pageY;
		if (k.swipe == 'X') {
			if (Math.abs(lenY) > Math.abs(lenX)) {
				return;
			}
			e.preventDefault();
			k.move = lenX;
			k.isInertia = false;
			//if(Math.abs(lenX) <= 80) {//小于80，就会有惯性滑动
			k.isInertia = true;
			//}
			if (lenX > 5) {
				k.fangxiang = "left";
			} else if (lenX < -5) {
				k.fangxiang = 'right';
			}
			k.setX(k.el, k.left + lenX, 0);
		} else if (k.swipe == 'Y') {
			if (Math.abs(lenY) < Math.abs(lenX)) {
				return;
			}
			e.preventDefault();
			k.move = lenY;
			k.isInertia = false;
			// if(Math.abs(lenY) >= 30) {
			k.isInertia = true;
			//}
			if (lenY > 5) {
				//top
				k.fangxiang = "top";
			} else if (lenY < -5) {
				//bottom
				k.fangxiang = 'bottom';
			}
			k.setY(k.el, k.top + lenY, 0);
		}
	},
	touchend: function touchend(e) {
		var k = this;
		k.pcMoveFlag = true;
		if (k.isNoFullScreen) {
			k.setNewPositionNoScreen();
		} else {
			k.setNewPosition();
		}
	},
	touchcancel: function touchcancel(e) {
		var k = this;
		k.pcMoveFlag = true;
		if (k.isNoFullScreen) {
			k.setNewPositionNoScreen(e);
		} else {
			k.setNewPosition();
		}
	},
	setNewPosition: function setNewPosition() {
		var k = this;
		if (k.swipe == 'X') {
			if (k.fangxiang == 'left') {
				if (k.currentIndex == 0) {
					k.setX(k.el, 0, k.interval);
				} else {
					k.prev();
				}
			} else if (k.fangxiang == "right") {
				if (k.currentIndex == k.count - 1) {
					k.setX(k.el, -(k.chirdW * (k.count - 1)), k.interval);
				} else {
					k.next();
				}
			} else {
				this.setX(this.el, this.left, 0);
			}
		} else if (k.swipe == 'Y') {
			if (k.fangxiang == 'top') {
				if (k.currentIndex == 0) {
					k.setY(k.el, 0, k.interval);
				} else {
					k.prev();
				}
			} else if (k.fangxiang == "bottom") {
				if (k.currentIndex == k.count - 1) {
					k.setY(k.el, -(k.chirdH * (k.count - 1)), k.interval);
				} else {
					k.next();
				}
			} else {
				this.setY(this.el, this.top, 0);
			}
		}
		k.automove();
	},
	setNewPositionNoScreen: function setNewPositionNoScreen(e) {
		//isNoFullScreen

		var k = this,
		    smallest;
		if (window.PointerEvent || window.MSPointerEvent) {
			var sleft = k.el.style.msTransform || k.el.style.transform;
			k.left = k.getInitPosition(sleft, "x");
			k.top = k.getInitPosition(sleft, "y");
		} else {
			k.left = k.getInitPosition(k.el.style.webkitTransform, "x");
			k.top = k.getInitPosition(k.el.style.webkitTransform, "y");
		}
		if (k.swipe == 'X') {
			if (k.fangxiang == 'left') {

				if (k.left >= 0) {
					k.setX(k.el, 0, k.interval);
				} else {
					if (k.isInertia) {
						k.left += k.inertiaLength;
						if (k.left >= 0) {
							k.setX(k.el, 0, k.interval);
						} else {
							k.setX(k.el, k.left, k.interval);
						}
					}
				}
			} else if (k.fangxiang == "right") {
				smallest = -(k.elWidth - window.innerWidth);
				if (k.left <= smallest) {
					k.setX(k.el, smallest, k.interval);
				} else {
					if (k.isInertia) {
						k.left -= k.inertiaLength;
						if (k.left <= smallest) {
							k.setX(k.el, smallest, k.interval);
						} else {
							k.setX(k.el, k.left, k.interval);
						}
					}
				}
			} else {
				this.setX(this.el, this.left, 0);
			}
		} else if (k.swipe == 'Y') {
			if (k.fangxiang == 'top') {

				if (k.top >= 0) {
					k.setY(k.el, 0, k.interval);
				}
			} else if (k.fangxiang == "bottom") {
				if (k.left <= -(k.elHeight - window.innerHeight)) {
					k.setY(k.el, -(k.elHeight - window.innerHeight), k.interval);
				}
			} else {
				this.setY(this.el, this.top, 0);
			}
		}
	},
	setX: function setX(el, len, time) {
		el.style.webkitTransitionDuration = time + "ms";
		el.style.msTransitionDuration = time + "ms";
		el.style.transitionDuration = time + "ms";
		el.style.webkitTransform = "translate3d(" + len + "px,0,0)";
		el.style.msTransform = "translate3d(" + len + "px,0,0)";
		el.style.transform = "translate3d(" + len + "px,0,0)";
	},
	setY: function setY(el, len, time) {
		el.style.webkitTransitionDuration = time + "ms";
		el.style.msTransitionDuration = time + "ms";
		el.style.transitionDuration = time + "ms";
		el.style.webkitTransform = "translate3d(0," + len + "px,0)";
		el.style.msTransform = "translate3d(0," + len + "px,0)";
		el.style.transform = "translate3d(0," + len + "px,0)";
	},
	next: function next() {
		this.go(this.currentIndex + 1);
	},
	prev: function prev() {
		this.go(this.currentIndex - 1);
	},
	go: function go(idx) {
		var len = 0; //肯定是负值， 最大值为 0，最小值为 -((this.count - 1) * this.chirdW)
		if (idx === this.currentIndex) {
			return;
		}
		if (idx >= this.count) {
			idx = 0;
		}
		if (idx < 0) {
			idx = this.count - 1;
		}
		this.currentIndex = idx;
		if (this.swipe == 'X') {
			len = -(idx * this.chirdW);
			this.setX(this.el, len, this.interval);
		} else if (this.swipe == 'Y') {
			len = -(idx * this.chirdH);
			this.setY(this.el, len, this.interval);
		}
		if (this.nav) {
			if (this.navType === 'normal') {
				this.changeNavi(); //2017.3.6 xly
			} else {
				if (this.numNav) {
					this.numNav.innerHTML = this.currentIndex + 1;
				}
			}
		}
		if (this.urllist) {
			this.changeUrl();
		} //add xly
	},
	changeNavi: function changeNavi() {
		var k = this;
		k.navis.forEach(function (e) {
			e.className = 'box-size';
		});
		k.navis[k.currentIndex].className = 'box-size on';
	},
	changeUrl: function changeUrl() {
		//add xly
		var k = this;
		k.urlbtn.attr("href", k.urllist[k.currentIndex]);
	},
	getInitPosition: function getInitPosition(c, f) {
		//console.log('--------------'+c+'---------------');
		var a = 0,
		    d = /([0-9-\.]+)+(?![3d]\()/gi,
		    e = c.toString().match(d);
		if (!e) {
			return a;
		}
		//console.log(e);
		if (e.length) {
			var b = f == "x" ? 0 : f == "y" ? 1 : 2;
			a = parseFloat(e[b]);
		}
		return a;
	}
};

module.exports = Slide;

/***/ }),

/***/ "erWL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "evD5":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var IE8_DOM_DEFINE = __webpack_require__("SfB7");
var toPrimitive = __webpack_require__("MmMw");
var dP = Object.defineProperty;

exports.f = __webpack_require__("+E39") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "fS6E":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Kh5d");
module.exports = __webpack_require__("FeBl").Object.getPrototypeOf;


/***/ }),

/***/ "fWfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("7KvD");
var has = __webpack_require__("D2L2");
var DESCRIPTORS = __webpack_require__("+E39");
var $export = __webpack_require__("kM2E");
var redefine = __webpack_require__("880/");
var META = __webpack_require__("06OY").KEY;
var $fails = __webpack_require__("S82l");
var shared = __webpack_require__("e8AB");
var setToStringTag = __webpack_require__("e6n0");
var uid = __webpack_require__("3Eo+");
var wks = __webpack_require__("dSzd");
var wksExt = __webpack_require__("Kh4W");
var wksDefine = __webpack_require__("crlp");
var enumKeys = __webpack_require__("Xc4G");
var isArray = __webpack_require__("7UMu");
var anObject = __webpack_require__("77Pl");
var isObject = __webpack_require__("EqjI");
var toIObject = __webpack_require__("TcQ7");
var toPrimitive = __webpack_require__("MmMw");
var createDesc = __webpack_require__("X8DO");
var _create = __webpack_require__("Yobk");
var gOPNExt = __webpack_require__("Rrel");
var $GOPD = __webpack_require__("LKZe");
var $DP = __webpack_require__("evD5");
var $keys = __webpack_require__("lktj");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("n0T6").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("NpIQ").f = $propertyIsEnumerable;
  __webpack_require__("1kS7").f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("O4g8")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("hJx8")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "fZjL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("jFbC"), __esModule: true };

/***/ }),

/***/ "fkB2":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("UuGF");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "fu20":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gets; });
/**
 * Created by xinjundong on 2017/11/20.
 */
var get = function get(selector) {
  return document.querySelector(selector);
};
var gets = function gets(selector) {
  return document.querySelectorAll(selector);
};

/***/ }),

/***/ "fuGk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "fxRn":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+tPU");
__webpack_require__("zQR9");
module.exports = __webpack_require__("g8Ux");


/***/ }),

/***/ "g8Ux":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var get = __webpack_require__("3fs2");
module.exports = __webpack_require__("FeBl").getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ "h65t":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("UuGF");
var defined = __webpack_require__("52gC");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "hJx8":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("evD5");
var createDesc = __webpack_require__("X8DO");
module.exports = __webpack_require__("+E39") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "jFbC":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Cdx3");
module.exports = __webpack_require__("FeBl").Object.keys;


/***/ }),

/***/ "kM2E":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var ctx = __webpack_require__("+ZMJ");
var hide = __webpack_require__("hJx8");
var has = __webpack_require__("D2L2");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "lOnJ":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "lktj":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("Ibhu");
var enumBugKeys = __webpack_require__("xnc9");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "mClu":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("kM2E");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("+E39"), 'Object', { defineProperty: __webpack_require__("evD5").f });


/***/ }),

/***/ "mtWM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("tIFN");

/***/ }),

/***/ "mvHQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("qkKv"), __esModule: true };

/***/ }),

/***/ "mypn":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "n0T6":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("Ibhu");
var hiddenKeys = __webpack_require__("xnc9").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "oJlt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "p1b6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "pBtG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "pFYg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("Zzip");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("5QVw");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "pxG4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "qRfI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "qio6":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("evD5");
var anObject = __webpack_require__("77Pl");
var getKeys = __webpack_require__("lktj");

module.exports = __webpack_require__("+E39") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "qkKv":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("FeBl");
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ "sB3e":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("52gC");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "t8qj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "tIFN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var bind = __webpack_require__("JP+z");
var Axios = __webpack_require__("XmWM");
var defaults = __webpack_require__("KCLY");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("dVOP");
axios.CancelToken = __webpack_require__("cWxy");
axios.isCancel = __webpack_require__("pBtG");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("pxG4");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "thJu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),

/***/ "uqUo":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("kM2E");
var core = __webpack_require__("FeBl");
var fails = __webpack_require__("S82l");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "v5ur":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vFc/":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("TcQ7");
var toLength = __webpack_require__("QRG4");
var toAbsoluteIndex = __webpack_require__("fkB2");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "vIB/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("O4g8");
var $export = __webpack_require__("kM2E");
var redefine = __webpack_require__("880/");
var hide = __webpack_require__("hJx8");
var Iterators = __webpack_require__("/bQp");
var $iterCreate = __webpack_require__("94VQ");
var setToStringTag = __webpack_require__("e6n0");
var getPrototypeOf = __webpack_require__("PzxK");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "woOf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("V3tA"), __esModule: true };

/***/ }),

/***/ "wxAW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "xGkn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("4mcu");
var step = __webpack_require__("EGZi");
var Iterators = __webpack_require__("/bQp");
var toIObject = __webpack_require__("TcQ7");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("vIB/")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "xLtR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var transformData = __webpack_require__("TNV1");
var isCancel = __webpack_require__("pBtG");
var defaults = __webpack_require__("KCLY");
var isAbsoluteURL = __webpack_require__("dIwP");
var combineURLs = __webpack_require__("qRfI");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "xnc9":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "zQR9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("h65t")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("vIB/")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ })

/******/ });


// WEBPACK FOOTER //
// static/js/article/article.afe5c40bd91bc18e18cd.js